export default {
  translation: {
    Automation_flow_templates: "Akış Şablonları",
    Automation_ai_templates: "Yapay Zekâ Şablonları",
    Automation_sample: "Örnek",
    Automation_sample_notice: "Hazır şablonları kullanabilir ve bunları özelleştirebilirsiniz",
    Automation_template_number: "Şablon #{{number}}",
    Automation_beginner: "Başlangıç",
    Automation_intermediate: "Orta",
    Automation_advanced: "İleri",
    Automation_trending: "Popüler",
    Automation_sample_cart: "Alışveriş Sepeti Kurtarma",
    Automation_sample_cart_description:
      "Örnek fikir: müşterilerin sepete dönmesine yardımcı olun ve sorularını yanıtlayın.",
    Automation_sample_language: "Çok Dilli Sohbetler",
    Automation_sample_language_description:
      "Örnek fikir: ziyaretçileri tercih ettikleri dilde bir sohbete yönlendirin.",
    Automation_sample_support: "Müşteri Destek Asistanı",
    Automation_sample_support_description: "Örnek fikir: sık sorulan soruları yanıtlayın ve sonraki adımı gösterin.",
    Automation_sample_welcome: "Yeni Müşterileri Karşılayın",
    Automation_sample_welcome_description: "Örnek fikir: yeni ziyaretçileri karşılayın ve ürünlerinizi tanıtın.",
    Automation_flow_history: "Akış Geçmişi",
    Automation_ai_history: "Yapay Zekâ Geçmişi",
    Automation_loaded_count: "Yüklenen öğeler; + daha fazla öğe olduğunu gösterir.",
    Automation_sort_newest: " önce en yeni",
    Automation_sort_oldest: " önce en eski",
    Automation_sort_title: " başlığa göre",
    Automation_connected_posts: "Bağlı gönderiler",
    Automation_not_connected: "Hiçbir gönderiye bağlı değil.",
    Automation_connections_access: "Yorum izni ve Otomasyon/Yorum erişimi gereklidir.",
    Automation_checking_connections: "Gönderi bağlantıları kontrol ediliyor...",
    Automation_connections_retry: "Tüm bağlantılar doğrulanamadı. Tekrar deneyin.",
    aiSuggestedPrompts_title: "Önerilen promptlar",
    aiSuggestedPrompts_openImage: "Görseli tam ekran aç",
    aiSuggestedPrompts_explain: "Başlangıç olarak kullanmak için bir prompt seçin.",
    aiSuggestedPrompts_category: "Prompt kategorisi",
    aiSuggestedPrompts_subCategory: "Alt kategori",
    aiSuggestedPrompts_allCategories: "Tüm kategoriler",
    aiSuggestedPrompts_loading: "Yükleniyor...",
    aiSuggestedPrompts_empty: "Önerilen prompt bulunamadı.",
    aiSuggestedPrompts_loadMore: "Daha fazla yükle",
    aiSuggestedPrompts_prompt: "Prompt",
    aiSuggestedPrompts_copy: "Promptu kopyala",
    aiSuggestedPrompts_showMore: "Daha fazlasını göster",
    aiSuggestedPrompts_showLess: "Daha az göster",
    unpin: "Pini Kaldır",
    pin: "Pinle",
    usethisPrompt: "Prompt içinde kullan",
    AudienceTooltip:
      "Mevcut etkileşiminizi daha doğru ölçmek için istatistikler son 30 gündeki performansınıza göre gösterilir; Instagram istatistikleri hesabın tüm faaliyet dönemini kapsar ve bu verilerden farklı olabilir",
    toggleShowAll: "Hepsini Göster",
    toggleShowmonthly: "Aylık Göster",
    Nodetutorial: "Blok Açıklaması",
    Dublicate: "Kopyala",
    zoomout: "Uzaklaştır",
    fitscreen: "Ekrana Sığdır",
    zoomin: "Yakınlaştır",
    shortcuts: "Kısayollar",
    History_saved: "Kaydedilmiş Geçmiş",
    Data_Management_explain: "Çalışma akışınızı kaydedebilir ve gerekirse diğer platformlardan içe aktarabilirsiniz.",
    flow_shortcuts_explain: "Çalışma akışlarını yönetmede hız ve verimliliği artırmak için klavye kısayolları.",
    Workflow_Statistics: "İş Akışı İstatistikleri",
    Nodes: "Düğümler",
    Connections: "Bağlantılar",
    Last_Auto_saved: "Son Otomatik Kaydetme",
    Canvas_Behavior: "Tuval Davranışı",
    Canvas_Behavior_explain: "Daha iyi kontrol için ızgara hizalamasını ve kaydırma sınırlarını yapılandırın",
    Data_Management: "Veri Yönetimi",
    importJSON_success: "Dosya başarıyla içe aktarıldı",
    importJSON_error: "Dosya içe aktarılırken hata oluştu",
    exportJSON: "JSON Dışa Aktar",
    importJSON: "JSON İçe Aktar",

    quantity: "Miktar",
    allquantity: "Toplam Miktar",
    remainingquantity: "Kalan Miktar",
    Connecting: "Bağlanıyor",
    Connected: "Bağlandı",
    EmailNotification: "E-posta Bildirimleri",
    EmailNotificationExplain: "Sistem bildirimleri bu E-posta adresine gönderilir.",
    MobileNotification: "Mobil Bildirimler",
    MobileNotificationExplain: "Sistem bildirimleri bu Mobil numaraya gönderilir.",
    Responded: "Yanıtlandı",
    notimelimit: "Zaman sınırı yok",

    usersettingexplain:
      "Instagram hesap bilgileri yalnızca Instagram içinde değiştirilebilir ve burada otomatik olarak güncellenir.",

    loading: "Yükleniyor...",
    Beginner: "Başlangıç",
    Basic: "Temel",
    Growing: "Büyüyen",
    Advanced: "İleri",
    Professional: "Profesyonel",
    Special: "Özel",
    Unavailable: "Kullanılamaz",
    menu: "Menü",
    level: "Seviye",
    bestposts: "En İyi Paylaşımlar",
    daysAgo: "Günler önce",
    hoursAgo: "Saatler önce",
    minutesAgo: "Dakikalar önce",
    justNow: "Şimdi",
    upgradeyouraccount: "Hesabınızı yükseltin",
    featureNotAvailable: "Bu özellik mevcut değil",
    featureNotAvailableDesc: "Bu özelliği kullanmak için hesabınızı yükseltin.",
    likeaprouser: "Gerçek bir iş kurun",
    followerrate: "Takipçi büyüme oranı",
    shoppertitle: "Her şey satışa hazır 👌",
    advertisertitle: "Her şey reklam için hazır 👌",
    shopperdescription: "Satış performansınızı doğru takip edin.",
    advertiserdescription: "Reklam performansınızı doğru takip edin.",
    syncingAccountTitle: "Bilgiler Alınıyor",
    syncingAccountDescription: "Instagram bilgileriniz Brancy'de güncelleniyor",
    syncingAccountDescriptiontooltip: "Bilgilerinizin bir kısmı önümüzdeki 24 saat içinde güncellenecektir.",
    subscriptionExpiringTitle: "Aboneliğiniz Sona Ermek Üzere",
    subscriptionExpiringDescription: "Mevcut özellikleri kullanmaya devam etmek için aboneliğinizi yenileyin.",
    subscriptionDaysRemaining: "{{days}} gün kaldı",
    priceHistory: "Fiyat Geçmişi",
    unselect: "Auswahl aufheben",
    // #region landing page
    shopper: "Satıcı",
    onlinestore: "Online Mağaza",
    onlinestoreExplain: "Daha fazla satış için ihtiyacınız olan her şey tek bir yerde.",
    influencerExplain: "Reklam verenler ve influencer’lar için tüm araçlar profesyonel şekilde bir arada",
    advertiser: "Reklam Veren",
    influencer: "Influencer",
    skip: "Geç",
    skipfornow: "Şimdilik geç",
    freedays: "40 Gün",
    freedaysExplain:
      "Aktif ve büyüyen bir Instagram sayfanız varsa, bu plan sizin için tasarlandı. Brancy'de araçlara, analizlere, içerik, mesaj ve yorum yönetimine ve ekip admini oluşturmaya tam erişim sağlandı.",
    instagramerplanactive: "Instagram planınız aktif",
    influencerplanactive: "Influencer planınız aktif",
    onlinestoreplanactive: "Online mağaza planınız aktif",

    SwitchtoUserpanel: "Kullanıcı Paneline Geç",
    chooselanguage: "Dil Seçimi",
    chooselanguageExplain: "Tercih ettiğiniz dili seçin",
    chooseTheme: "Tema Seçimi",
    chooseThemeExplain: "Favori temanızı seçin",
    chooseCalendar: "Takvim Seçimi",
    chooseCalendarExplain: "Tercih ettiğiniz takvim türünü seçin",
    setupchooseexplain: "Bu ayarlar daha sonra Ayarlar bölümünden değiştirilebilir",

    Lottery: "Piyango",
    services: "Özellikler",
    markets: "Platformlar",
    pricing: "Fiyatlandırma",
    page1_text1: "Instagram İşletme Yönetimi",
    page1_text2: "Bir sonraki nesil ile",
    page1_StartNow: "Profesyonel araçlara erişimle ücretsiz bir başlangıç",
    page1_services: "Hizmetler",
    page1_analytics: "Analitik",
    page1_transportation: "Taşıma",
    page1_financial_solutions: "Finansal Çözümler",
    page1_customer_communication: "Müşteri İletişimi",
    page1_content_management: "İçerik Yönetimi",
    page1_artificial_intelligence: "Yapay Zeka",
    page1_tools: "Araçlar",
    page1_advertises: "Reklam Yönetimi",
    page2_text1: "En kapsamlı iş hizmetleri ve çözümleri",
    page2_text2:
      "Brancy, Instagram hesabınızı yönetmek için güçlü bir araçtır ve başarılı olmanız için gereken araçları sağlar.",
    page2_ads_statistics_title: "İstatistikler",
    page2_ads_statistics_description: "Gelişmiş performans analiz aracı",
    page2_ads_statistics_servicedescription:
      "Sayfanızın tüm ana reklam performans göstergelerini kesin, gerçek zamanlı ve analitik olarak takip edin. Kampanyalarınızı optimize etmek için tam profesyonel görünüm kazanın.",
    page2_ads_calendar_title: "Çalışma Takvimi",
    page2_ads_calendar_description: "En pratik reklam yönetimi",
    page2_ads_calendar_servicedescription:
      "Onayladığınız ve Yapay Zeka’nın önerdiği tüm reklamları, gelişmiş ve düzenli bir zaman çizelgesiyle akıllı takvimde yönetin. Hızlı ve hatasız planlama deneyimi.",
    page2_ads_adlist_title: "Reklam Listesi",
    page2_ads_adlist_description: "Onay bekleyen reklam kuyruğunu görüntüleyin",
    page2_ads_adlist_servicedescription:
      "Bekleyen reklamların net ve kategorize edilmiş listesini görün, tek tıkla onaylayın veya reddedin. Reklam yönetimini hızlı ve profesyonel hale getirin.",
    page2_store_addproduct_title: "Ürün Ekle",
    page2_store_addproduct_description: "Sayfanızdaki tüm ürünleri tanımlayın",
    page2_store_addproduct_servicedescription:
      "Akıllı sistemimiz, sayfanızdaki tüm ürünleri tespit edip otomatik olarak eklemeye hazırlar. İş hızınızı artırır ve hataları azaltır.",
    page2_store_productlist_title: "Ürün Listesi",
    page2_store_productlist_description: "Stok ve ürün yönetimi",
    page2_store_productlist_servicedescription:
      "Ürünlerinizi ve stoklarınızı profesyonel, hassas ve sorunsuz şekilde yönetin. Her şey akıllı ve tam raporlarla elinizin altında.",
    page2_store_orders_title: "Siparişler",
    page2_store_orders_description: "Sipariş, fatura ve gönderi yönetimi",
    page2_store_orders_servicedescription:
      "Siparişten fatura kesimine ve takipli gönderiye kadar tüm aşamalar otomatik ve kusursuz yürür. Müşterilere hızlı ve doğru bir deneyim sunar.",
    page2_store_statistics_title: "İstatistikler",
    page2_store_statistics_description: "Gelişmiş performans analiz aracı",
    page2_store_statistics_servicedescription:
      "Satışları, geliri ve mağaza büyüme trendlerini çok yönlü takip edin ve veriye dayalı akıllı kararlar alın.",
    page2_delivery_smartshipping_title: "Akıllı Gönderim Ücreti",
    page2_delivery_smartshipping_description: "Gönderim ücreti; kaynak, hedef, boyut ve ağırlığa göre",
    page2_delivery_smartshipping_servicedescription:
      "Gönderim ücreti; kaynak, hedef, boyut ve ağırlığa göre hassas ve otomatik hesaplanır. İnsan hatası olmadan gerçek ücret sağlar.",
    page2_delivery_postalservice_title: "Posta Hizmeti",
    page2_delivery_postalservice_description: "Paket toplama ve gönderme",
    page2_delivery_postalservice_servicedescription:
      "Paketleriniz mağazadan akıllıca toplanır ve manuel takip olmadan hedefe gönderilir. Hızlı, düzenli ve kolay lojistik deneyimi.",
    page2_delivery_tracking_title: "Paket Takibi",
    page2_delivery_tracking_description: "Otomatik paket durumu ve takibi",
    page2_delivery_tracking_servicedescription:
      "Müşteriler için doğru ve gerçek zamanlı durum gösterimi ile otomatik takip, tam şeffaflık ve güven sağlar.",
    page2_jobs_subadmin_title: "Alt Yönetici",
    page2_jobs_subadmin_description: "Alt yönetici ekleme imkanı",
    page2_jobs_subadmin_servicedescription:
      "Şifre paylaşmadan alt yöneticiler ekleyin ve her biri için erişimleri özelleştirin. Tam kontrol ve garantili güvenlik.",
    page2_ids_store_title: "ID Mağazası",
    page2_ids_store_description: "Instagram ID alım satımı",
    page2_ids_store_servicedescription:
      "Kimlik doğrulama ile güvenli Instagram hesapları alıp satın. Detaylı analiz, akıllı fiyatlandırma, açık artırma ve sayfa istatistik doğrulama—all in one place.",
    page2_publish_contentmanagement_title: "İçerik Yönetimi",
    page2_publish_contentmanagement_description: "Post ve Story Yönetimi",
    page2_publish_contentmanagement_servicedescription:
      "Tüm post ve story’leri gelişmiş ve akıllı bir platformda yönetin; planlama, kategorilendirme ve hızlı yayınlama ile sosyal medya kontrolünüz kolaylaşır.",
    page2_publish_contentpublishing_title: "İçerik Yayını",
    page2_publish_contentpublishing_description: "Planlanmış Post ve Story Yayını",
    page2_publish_contentpublishing_servicedescription:
      "Post ve story’leri akıllı ve zamanlı yayınlayın. Sistem, takipçi davranış analizine göre en iyi zamanı önerir.",
    page2_publish_analytics_title: "Post & Story Analizi",
    page2_publish_analytics_description: "Tam İçerik Analizi",
    page2_publish_analytics_servicedescription:
      "Yayınlanan içerik performansı ve izleyici geri bildirimleri hakkında derin içgörüler elde edin, içerik stratejinizi optimize edin.",
    page2_publish_statistics_title: "İstatistikler",
    page2_publish_statistics_description: "Gelişmiş Performans Analiz Aracı",
    page2_publish_statistics_servicedescription:
      "Post ve story performansının tam detayları, grafikler ve hassas analizlerle en gelişmiş içerik analiz aracıdır.",
    page2_extension_biolink_title: "Bio Link",
    page2_extension_biolink_description: "Basit bir bio linkten daha fazlası",
    page2_extension_biolink_servicedescription:
      "Tüm önemli linklerinizi gösteren, responsive tasarımlı ve tam özelleştirilebilir özel güzel bir sayfa, basit bir linkin ötesinde.",
    page2_extension_paymentgateway_title: "Ödeme Geçidi",
    page2_extension_paymentgateway_description: "Özel Ödeme Geçidi",
    page2_extension_paymentgateway_servicedescription:
      "Teknik bilgi gerektirmeyen, güvenli ve özel bir ödeme geçidi; detaylı raporlama ve işlem yönetimi sunan kullanıcı dostu ortam.",
    page2_extension_customwebsite_title: "Özel Web Sitesi",
    page2_extension_customwebsite_description: "Sayfanıza özel web sitesi",
    page2_extension_customwebsite_servicedescription:
      "Sayfanızın görsel kimliğine uyumlu, kodlama gerektirmeyen özel web sitesi. Tüm ürün ve hizmetlerinizi profesyonelce sergileyin.",
    page4_menu_instagram_management: "Instagram Sayfa Yönetimi",
    page4_menu_admin_subadmin: "Admin ve Alt Admin",
    page4_menu_store_shipping: "Mağaza ve Kargo",
    page4_menu_advertising: "Reklamlar",
    page4_menu_hashtag_management: "Hashtag Yönetimi",
    page4_menu_ai_analysis: "Akıllı AI Analizi",
    page4_menu_ad_scheduling: "Reklam Zamanlama",
    page4_menu_financial_wallet: "Finans & Cüzdan",
    page4_menu_page_statistics: "Sayfa İstatistikleri",
    page4_menu_professional_messaging: "Profesyonel Mesajlaşma",

    page4_content_instagram_management_text:
      "Sayfanızın tüm bölümlerini — içerik yayınlamadan yorum ve dired cevaplamaya kadar — entegre ve profesyonel yönetin. Birden fazla uygulamaya gerek yok!",
    page4_content_admin_subadmin_text:
      "Ekibinizi kurun! Özel roller atayın, erişimleri sınırlandırın ve insan hatası olmadan faaliyetleri tamamen kontrol edin.",
    page4_content_store_shipping_text:
      "Gerçek bir Instagram mağazası! Stok, sipariş, fatura ve gönderi takibini tek panelden yönetin. Online satış hiç bu kadar kolay olmamıştı!",
    page4_content_advertising_text:
      "Instagram reklamlarını birkaç tıkla tasarlayın, yürütün ve analiz edin! Hedef kitlenizi çekin, kampanya performansını ölçün ve bütçenizi boşa harcamayın.",
    page4_content_hashtag_management_text:
      "Hashtag’lerinizi akıllıca seçin! En iyi ilgili hashtag’leri analiz edin, kaydedin, kategorilere ayırın ve her post için akıllı öneriler alın.",
    page4_content_ai_analysis_text:
      "Takipçi davranışlarını yakından inceleyin! Gelişmiş AI analizleri ile kalıpları, ilgi alanlarını ve en aktif saatleri keşfedin, stratejinizi kazanın.",
    page4_content_ad_scheduling_text:
      "Reklamlarınız uyurken bile aktif kalsın! Kampanyalarınızı planlayın, başlangıç ve bitiş zamanlarını ayarlayın ve endişesiz büyüyün.",
    page4_content_financial_wallet_text:
      "Tüm işlemleri kontrol altında tutun! Gelir, gider, cüzdan bakiyesi ve kapsamlı finansal raporlarla sermayenizi daha iyi yönetin.",
    page4_content_page_statistics_text:
      "Sayfa büyümenizin doğru ve gerçek istatistikleri: etkileşim oranı, takipçi artışı, post performansı, görüntülenmeler ve akıllı kararlar için birçok veri.",
    page4_content_professional_messaging_text:
      "Gerçek direct marketing deneyimi yaşayın! Grup mesajları gönderin, otomatik cevaplar ayarlayın ve takipçilerle profesyonelce sohbetleri yönetin.",

    shipping: "Gönderim",
    jobs: "İşler",
    IDstore: "ID Mağazası",
    page3_text1: "İşletmenizin tüm ihtiyaçlarına çözüm",
    page5_whyBrancy: "Neden Brancy?",
    page5_title1: "Resmi ve Güvenli Instagram İş Ortağı",
    page5_title2: "Entegre Ekosistem, Akıllı Tasarruf",
    page5_title3: "Profesyonel Akıllı Etkileşim",
    page5_title4: "Gelişmiş ve Akıllı Kontrol Paneli",
    page5_title5: "Akıllı Satış ve Lojistik Sistemi",
    page5_title6: "Özel Akıllı Web Sitesi",
    page5_explain1: "Hassas veri olmadan akıllı yönetim – Instagram uyumlu ve güvenli.",
    page5_explain2: "Tüm araçlar bir arada; %70 maliyet, %85 zaman tasarrufu.",
    page5_explain3: "Yapay zeka ile otomatik yanıt; %40 daha fazla yanıt, %95 müşteri tutma.",
    page5_explain4: "Hızlı arayüz, anlık analiz, admin yönetimi, zamanlama & raporlar.",
    page5_explain5: "DM'den satış – güvenli ödeme, mağaza, kargo ve akıllı stok.",
    page5_explain6: "Web sitesi & Bio link – satış, rezervasyon, SEO ve sosyal medya.",
    page9_plantitle: "Uygun paketi görmek için takipçi sayınızı seçin",

    page9_planheader: "Profesyonelce başlayın ve özelliklerin tadını çıkarın!",
    page9_planexplain: "40 gün boyunca ücretsiz, tam ve sınırsız erişim!",
    page9_freeplan: "Ücretsiz",
    page9_basicplan: "Temel",
    page9_proplan: "Profesyonel",
    page9_adsplan: "Reklam",
    page9_storeplan: "Mağaza",
    page9_monthly: "aylık",
    page9_Compare: "Planları detaylı şekilde karşılaştır",
    page9_content_management: "Post ve Story Yönetimi",
    page9_analize_management: "Gelişmiş Analiz ve İstatistik Araçları",
    page9_message_management: "Direct ve Comment Yönetimi",
    page9_biolink_management: "Akıllı Bio Link ve Özel Web Sitesi",
    page9_subadmin_management: "Alt admin alımı ve yönetimi",
    page9_basicoption: "Temel Özellikler",
    page9_ticket_management: "Direct ve Destek Talebi ile Satış",
    page9_finance_management: "Ödeme Geçidi ve Cüzdan",
    page9_store_management: "Akıllı Mağaza Stok Yönetimi",
    page9_logestic_management: "Otomatik Kargo ve Teslimat",
    page9_storeanalize_management: "Gelişmiş Analiz",
    page9_calendar_management: "Reklam Zamanlama Takvimi",
    page9_advertise_management: "Akıllı Reklam Yönetimi",
    page9_adsanalize_management: "Gelişmiş Reklam Analizi",
    page9_campagin_management: "Kampanya Oluştur ve Katıl",
    page9_adsticket_management: "Reklam Geri Bildirimini Otomatik Gönder",

    page6_Header: "Binlerce aktif işletme",
    page6_Explain: "Başarılı işletmelerin çoğu büyük Brancy ailesine katıldı",
    page10_header: "Müşterilerimiz ne diyor?",
    page8_HelpCenter: "Yardım Merkezi",
    page8_Community: "Topluluk",
    page8_learn: "Öğren",
    page8_Blog: "Blog",
    page8_FAQ: "SSS",
    Addfaq: "SSS Ekle",
    addfaqexplain: "En fazla 4 sık sorulan soru ekleyebilirsiniz",
    faqEmptyState: "Sık sorulan sorularınız burada görünecek",

    page8_Support: "Destek",
    support_Online: "Çevrim içi destek",
    support_EnterBlog: "Bloga gir",
    page8_CommunityExplain:
      "Diğer kullanıcılarla iletişim kurun, deneyimlerinizi paylaşın ve daha fazla büyüme için kolektif tavsiyelerden faydalanın.",
    page8_learnExplain:
      "Bu bölümde, iş dünyasında Instagram kullanımı için en son stratejileri öğreneceksiniz. İşletmenizin büyümesi için ihtiyaç duyduğunuz her şey burada.",
    page8_BlogExplain:
      "En son makalelere ve eğitim içeriklerine erişin. İş dünyası ve dijital pazarlama alanlarında güncel bilgiler sizi bekliyor.",
    page8_FAQExplain:
      "Sıkça sorulan sorularınız burada yanıtlanmıştır. Hizmetler veya ürünlerle ilgili herhangi bir rehberlik için bu bölüme başvurun.",
    page8_SupportExplain:
      "Destek ekibimiz size yardımcı olmak için hazır. Herhangi bir sorun veya sorunuz varsa, bizimle iletişime geçmek yeterlidir.",
    page8_CommunityBTN: "Birlikte Öğrenelim",
    page8_learnBTN: "Hızlı Öğren",
    page8_BlogBTN: "Son Haberler",
    page8_FAQBTN: "Anında Yanıtlar",
    page8_SupportBTN: "Yardım İçin Buradayız",
    footer_Brancy: "Brancy",
    footer_AboutUs: "Hakkımızda",
    footer_ContactUs: "Bizimle İletişime Geçin",
    footer_JoinUs: "Bize Katılın",
    footer_OrgChart: "Organizasyon Şeması",
    footer_FollowUs: "Bizi Takip Edin",
    footer_Solutions: "Çözümler",
    footer_HelpCenter: "Yardım Merkezi",
    footer_Support: "Destek",
    footer_FAQ: "Sıkça Sorulan Sorular",
    footer_ReportAnIssue: "Bir Sorun Bildir",
    footer_TrustLegal: "Güven & Yasal",
    footer_TermsAndConditions: "Şartlar ve Koşullar",
    footer_PrivacyNotice: "Gizlilik Bildirimi",
    footer_CookieNotice: "Çerez Bildirimi",
    footer_Blog: "Blog",
    footer_ProductUpdates: "Son Güncellemeler",
    footer_Articles: "Makaleler",
    footer_LatestNews: "Son Haberler",
    installPromptMessage: "Brancy web uygulamasını yükleyin",
    install: "Yükle",
    installStep1: "Alt çubuktaki paylaş düğmesine dokunun.",
    installStep2: "Açılan menüyü yukarı kaydırın ve Add to Home Screen seçeneğini seçin.",
    installStep3: "Ekranın üstündeki Add düğmesine dokunun.",

    joinUs_subtitle: "Brancy'e Katılın; Yenilik Ve Sürdürülebilir Gelecek Burada Şekillenir.",
    joinUs_whyWorkWithUs: "Neden Brancy?",
    joinUs_whyWorkWithUsDescription:
      "Brancy Sadece Bir Çalışma Ortamı Değil; Profesyonel Ve Kişisel Gelişim İçin Stratejik Bir Platformdur. Biz, Lider Organizasyonların En İyi Yeteneklerle Kurulduğuna İnanıyoruz. Taahhüdümüz, Ekip Üyelerinin Kalıcı Bir Etki Yaratabileceği Dinamik, Şeffaf Ve Destekleyici Bir Ortam Yaratmaktır.",
    joinUs_openPositions: "Açık Pozisyonlar",
    joinUs_openPositionsDescription:
      "Mevcut Fırsatları İnceleyin Ve Uzmanlığınıza Ve Kariyer Yolunuza Uygun Rolü Seçin.",
    joinUs_frontendDeveloper: "Frontend Geliştirici",
    joinUs_frontendDeveloperDescription:
      "React Ve TypeScript İle Modern Kullanıcı Deneyimleri Tasarlayın Ve Uygulayın. Ürünlerimizin Kalitesini Ve Verimliliğini Artırmada Kilit Bir Rol Oynayacaksınız.",
    joinUs_backendDeveloper: "Backend Geliştirici",
    joinUs_backendDeveloperDescription:
      "Node.js Ve Bulut Teknolojileriyle Ölçeklenebilir Ve Güvenli Sistemler Tasarlayın Ve Geliştirin. Sistem Düşüncesi Ve Karmaşık Sorunları Çözme Becerisi Gerektirir.",
    joinUs_uiUxDesigner: "UI/UX Tasarımcısı",
    joinUs_uiUxDesignerDescription:
      "Kullanıcı Memnuniyeti Ve Sadakati İçin Standart Arayüzler Ve Sezgisel Deneyimler Yaratın. Detaylara Dikkat Ve Yaratıcılık Gereklidir.",
    joinUs_productManager: "Ürün Yöneticisi",
    joinUs_productManagerDescription:
      "Ürün Stratejisini Yönetin Ve Rekabetçi, Verimli Çözümler Sunmak İçin Ekipleri Koordine Edin. Analitik Vizyona Ve Paydaş Yönetim Becerilerine Sahip Bireyler İçin Uygundur.",
    joinUs_marketingSpecialist: "Pazarlama Uzmanı",
    joinUs_marketingSpecialistDescription:
      "Dijital Kampanyalar Planlayın Ve Yürütün, Marka Konumunu Güçlendirin. Analitik Beceriler İle Yaratıcılığın Birleşimi.",
    joinUs_customerSupport: "Müşteri Destek Uzmanı",
    joinUs_customerSupportDescription:
      "Profesyonel Destek Sağlayın, Sorunları Çözün Ve Kullanıcı Deneyimini İyileştirin. Dikkat, Sabır Ve İletişim Becerileri Gerektirir.",
    joinUs_engineering: "Mühendislik",
    joinUs_design: "Tasarım",
    joinUs_product: "Ürün",
    joinUs_marketing: "Pazarlama",
    joinUs_support: "Destek",
    joinUs_remoteOnsite: "Uzaktan / Ofiste",
    joinUs_onsite: "Ofiste",
    joinUs_remote: "Uzaktan",
    joinUs_fullTime: "Tam Zamanlı",
    joinUs_partTimeFullTime: "Yarı Zamanlı / Tam Zamanlı",
    joinUs_applyNow: "Şimdi Başvur",
    joinUs_applicationProcess: "Brancy İşe Alım Süreci",
    joinUs_submitApplication: "Başvuruyu Gönder",
    joinUs_submitApplicationDescription: "Özgeçmişinizi ve yeteneklerinizi gönderin. Ekibimiz dikkatle inceleyecektir.",
    joinUs_initialScreening: "Ön Eleme",
    joinUs_initialScreeningDescription:
      "İK departmanı özgeçmişleri 3–5 iş günü içinde inceleyip uygun ise iletişime geçer.",
    joinUs_technicalInterview: "Teknik Görüşme",
    joinUs_technicalInterviewDescription:
      "Takımlarla yapılan uzman görüşmeler aracılığıyla teknik bilgi ve deneyimin değerlendirilmesi.",
    joinUs_finalInterview: "Final Görüşmesi",
    joinUs_finalInterviewDescription:
      "Hedefler ve değerlerin uyumunu sağlamak için üst düzey yöneticiler ve ana ekiplerle yapılan son oturum.",
    joinUs_welcomeAboard: "Aramıza Hoşgeldiniz",
    joinUs_welcomeAboardDescription:
      "Kabulünüzden sonra, organizasyonun kültürü ve hedefleriyle tanışmanız için kapsamlı bir onboarding süreci başlayacaktır.",
    joinUs_readyToJoinUs: "Aradığınız pozisyonu bulamadınız mı?",
    joinUs_readyToJoinUsDescription:
      "Her zaman yetenekli ve motive bireyleri ağırlıyoruz. Özgeçmişinizi gönderin ve Brancy ile iş birliği vizyonunuzu açıklayın.",
    joinUs_sendYourResume: "Özgeçmişinizi Gönderin",

    aboutUs_pageTitle: "Brancy Hakkında",
    aboutUs_metaDescription:
      "Sosyal ağları ve dijital işletmeleri yönetmek için kapsamlı ve uluslararası bir platform olan Brancy ile tanışın; inovasyon, güven ve sürdürülebilir büyümenin bir araya gelerek dijital ekonominin geleceğini şekillendirdiği yer.",
    aboutUs_subtitle: "Brancy ile Dijital Ekonominin Akıllı Yönetimi",
    aboutUs_ourStoryTitle: "Hikayemiz",
    aboutUs_ourStoryPara1:
      "Brancy, çevrimiçi iş yönetimini yeniden tanımlama amacıyla doğdu; gelişmiş teknolojilerin işletme sahiplerinin gerçek ihtiyaçlarıyla buluştuğu nokta. Sadece bir araç sunmuyoruz; işletmelerin büyük ve profesyonel bir organizasyon gibi çalışabileceği bir ortam yarattık.",
    aboutUs_ourStoryPara2:
      "Bu yol, şu inanç üzerine kuruldu: teknoloji insanın ve işin büyümesini kolaylaştırmalı, önünde bir engel olmamalıdır.",
    aboutUs_innovationTitle: "Temel Avantaj Olarak İnovasyon",
    aboutUs_innovationPara1:
      "Brancy, yapay zeka, büyük veri ve modern web teknolojilerini kullanarak kullanıcılar için sorunsuz, güvenli ve verimli bir deneyim sunar. Her özellik, kullanım kolaylığı ve maksimum verimlilik odaklı tasarlanmıştır.",
    aboutUs_innovationPara2:
      "Bizim için inovasyon sadece teknolojiyle sınırlı değildir; geleceğe bakışımızda ve organizasyon kültürümüzde kök salmış stratejik bir yaklaşımdır.",
    aboutUs_coreValuesTitle: "Temel Değerlerimiz",
    aboutUs_innovationFirstTitle: "İnovasyonda Öncü",
    aboutUs_innovationFirstDesc:
      "Her zaman dijital işletmelerin gelecekteki ihtiyaçlarını karşılayacak çözümler arıyoruz.",
    aboutUs_trustSecurityTitle: "Güven ve Güvenlik",
    aboutUs_trustSecurityDesc:
      "Veri güvenliği ve süreç şeffaflığı, kullanıcıların tam güvenle büyüyebilmeleri için önceliğimizdir.",
    aboutUs_globalCommunityTitle: "Küresel Bir Topluluk",
    aboutUs_globalCommunityDesc:
      "Brancy, sınırların ötesine geçerek işletmeler ve profesyonellerden oluşan küresel bir ekosistemi birbirine bağlıyor.",
    aboutUs_sustainableGrowthTitle: "Sürdürülebilir Büyüme",
    aboutUs_sustainableGrowthDesc:
      "Etik ilkelere ve sosyal sorumluluğa uygun olarak akıllı ve sürdürülebilir büyümeye bağlıyız.",
    aboutUs_userEmpowermentTitle: "Kullanıcıların Güçlendirilmesi",
    aboutUs_userEmpowermentDesc:
      "Sezgisel araçlarımız ve eğitim kaynaklarımız herkes için dijital fırsatlara eşit erişim sağlar.",
    aboutUs_continuousEvolutionTitle: "Sürekli Evrim",
    aboutUs_continuousEvolutionDesc:
      "Dinamik bir dünyada değişim yolumuzun bir parçasıdır. Her zaman öğrenerek ve sürekli gelişerek ilerliyoruz.",
    aboutUs_globalImpactTitle: "Küresel Etki",
    aboutUs_globalImpactPara:
      "Bugün Brancy, milyonlarca girişimciyi ve işletmeyi güçlendiren bir platformdur; dijital fırsatlarla sınırsız bir gelecek arasında köprü kurar.",
    aboutUs_activeUsers: "Aktif Kullanıcılar",
    aboutUs_countries: "Kapsanan Ülkeler",
    aboutUs_uptime: "Sistem Kullanılabilirliği",
    aboutUs_support: "Özel Destek",
    aboutUs_teamTitle: "Brancy Ekibi",
    aboutUs_teamPara1:
      "Ekibimiz, dijital ekonomiyi geliştirme ortak hedefiyle bir araya gelen teknoloji uzmanları, stratejistler ve yaratıcı kişilerden oluşur.",
    aboutUs_teamPara2:
      "Sektör öncülerinin deneyiminden genç yeteneklerin enerjisine kadar Brancy’de yeni bir dijital ticaret neslini şekillendiren küresel bir hareketi yönetiyoruz.",

    // #region  landing page
    Dashboard: "Gösterge Paneli",
    greeting1: "Güneş seninle uyandı,",
    greeting2: "Enerji dolu bir sabahın olsun,",
    greeting3: "İyi günler,",
    greeting4: "İyi akşamlar,",
    greeting5: "Altın akşamın olsun,",
    greeting6: "Gece yaklaşıyor",
    greeting7: "Huzurlu bir gece olsun,",
    greetingtext1: "Erken sabah gerçekten büyüleyici🌅",
    greetingtext2: "Dünya senin adımlarını bekliyor 💪",
    greetingtext3: "Bir fincan çay ve gülümseme zamanı ☕😊",
    greetingtext4: "Lezzetli yemeğinin tadını çıkar 🍽️",
    greetingtext5: "Güneş hala gökyüzünde, devam et 🌟",
    greetingtext6: "Harika bir son yarat 🌇",
    greetingtext7: "Büyük hayaller kur ve yarın başla🌙",
    userpanel_yourorders: "Siparişleriniz",
    userpanel_SavedProducts: "Kaydedilen Ürünler",
    userpanel_NoSavedProducts: "Kaydedilmiş ürün bulunmamaktadır.",
    userpanel_Startexplore: "Milyonlarca arasında keşfetmeye başlayın",
    userpanel_Startexploreexplain: "Pazarlar, Ürünler ve Sayfalar",
    userpanel_TicketSupportExplain: "Sipariş takibi, satıcıyla sohbet",
    userpanel_TicketSupport: "Destek talebiyle iletişime geç",

    userpanel_UseInstagram: "Instagram'ı profesyonelce yönetin.",
    userpanel_FreeProPanel: "Ücretsiz ProPanel",
    userpanel_Premiumaccount: "Premium Hesap",
    userpanel_daysFreePremium: "40 Gün Ücretsiz Premium",
    userpanel_LimitedOffer: "Sınırlı Teklif!",
    // #region 0️⃣ General Section
    //0️⃣ General -> sidebar
    color: "Renk",
    button: "Düğme",
    Liter: "Litre",
    FrontFace: "Ön Yüz",
    SideFace: "Yan Yüz",
    TopFace: "Üst Yüz",
    Area: "Alan",
    Perimeter: "Çevre",
    Volume: "Hacim",
    inSystem: "Sistemde",
    sending: "Gönderiliyor",
    uploadsRemaining: "Kalan Yükleme",
    logoutExplain: "Brancy'den çıkış yapmaya çalışıyorsunuz",
    welcomeToBrancy: "Brancy'ye Hoş Geldiniz!",
    notloginexplain: "Brancy'nin hizmetlerinden yararlanmak için lütfen Instagram hesabınızı bağlayın.",
    welcomeToBrancyExplain: "Yönetim panelinizi kurmak için Instagram Kimliğinizi girin.",
    welcomeToBrancyExplainPhone: "Yönetim panelinizi kurmak için telefon numaranızı girin.",
    loginWithGoogle: "Google giriş",
    loginWithMobile: "SMS giriş",

    or: "veya",
    InstagramID: "Instagram Kullanıcı Adı (ID)",
    EmptyNotification: "Henüz bildirim yok",
    Notification_NewMessage: "{{sender}} kişisinden yeni bir mesajınız var",
    Notification_NewOrder: "{{sender}} kişisinden yeni bir siparişiniz var",
    Notification_ImagesCreatedBy: "Görselleriniz {{version}} modeli tarafından başarıyla oluşturuldu.",
    Notification_VideoCreatedBy: "Videonuz {{version}} modeli tarafından başarıyla oluşturuldu.",
    Notification_MediaCreationFailed: "Medyanız {{version}} modeli tarafından oluşturulamadı: {{metadata}}",
    Notification_VideoCreationFailed: "Videonuz {{version}} modeli tarafından oluşturulamadı: {{metadata}}",
    Notification_NewPost: "Yeni Gönderi",
    Notification_UploadPostFailed: "Gönderi Yüklenemedi",
    Notification_NewStory: "Yeni Hikaye",
    Notification_UploadStoryFailed: "Hikaye Yüklenemedi",
    Notification_NewVideo: "Yeni Video",
    Notification_VideoCreationFailedTitle: "Video Oluşturulamadı",
    Notification_YouHaveNewMessage: "Yeni bir mesajınız var",
    Notification_AccountDeauthorized: "Instagram hesabının yetkisi kaldırıldı",
    EnterYourText: "Metninizi Girin",
    EnterYourphonenumber: "Telefon Numaranızı Girin",
    CopyText: "Metni Kopyala",
    successfulCopy: "Kopyalandı",
    download: "İndir",
    automatic: "Otomatik",
    manual: "Manuel",
    phonenumber: "Telefon Numarası",
    SendVerificationCode: "Kodu Gönder",
    ShowUserDashboard: "Gösterge Paneline Git",
    VerificationCode: "Doğrulama Kodu",
    VerificationCodeExplain: "Telefonunuza gönderilen doğrulama kodunu giriniz.",
    remainingTime: "Kalan Süre",
    createtime: "Oluşturma Zamanı",
    ResendVerificationCode: "Doğrulama Kodunu Yeniden Gönder",
    VerifyCode: "Kodu Doğrula",
    Verify: "Doğrula",
    VerifyAddress: "Adresi Doğrula",
    Continue: "Devam Et",
    metaRedirect_aiAnalysisNotice:
      "Sayfanızın yapay zeka ile analiz edilmesinin birkaç saat sürebileceğini lütfen unutmayın.",
    Efficiency: "Verimlilik",
    max: "MAKS",
    logout: "Çıkış Yap",
    notallowed: "İzin Verilmedi",
    notallowedExplain: "Bu özelliğe erişim izniniz yok",
    notallowedExplainPage: "Bu sayfaya erişim izniniz yok",
    CollaboratorExplain: "Post veya Reels'i Birden Fazla Instagram Sayfası Arasında Ortak Paylaşın",
    CreateAutomationFlow: "Otomasyon Akışı Oluştur",
    CreateAutomationFlowExplain: "Görsel iş akışı oluşturucu ile Instagram etkileşimlerini otomatikleştir.",
    CreateAutomationAI: "Yapay Zeka Otomasyonu Oluştur",
    CreateAutomationAIExplain: "Yapay zeka destekli yanıtlarla Instagram etkileşimlerini otomatikleştir.",
    flowProperties_notworking_privateReply:
      "⚠️ Dikkat: Bu akış arkadaşlarla yapılan özel sohbetlerde çalışmaz ve yalnızca yorumlara ve Direct mesajlarına otomatik yanıt vermek için kullanılır",
    flowProperties_privateReply_requiresFollower:
      'Bu akış özel yanıtlar için kullanılamaz. Etkinleştirmek için Ayarlar\'da "Kullanıcı sayfayı takip etmeli" seçeneğini etkinleştirin.',

    needPass: "Doğrulama ve Aktivasyon",
    needPassExplain: "Bu özelliğe tam erişim için Instagram hesap şifresi gereklidir",
    soon: "Yakında",
    soonExplain: "Bu özellik yakında aktif olacak",
    underdevelop: "Geliştirme Aşamasında",
    reject: "Reddet",
    rejected: "Reddedildi",
    approved: "Onaylandı",
    ExpirationTime: "Son Kullanma Zamanı",
    send: "Gönder",
    accept: "Kabul Et",
    selectall: "Hepsini Seç",
    General: "Genel",
    Business: "İşletme",
    total: "Toplam",
    Unknown: "Bilinmeyen",
    undo: "Geri Al",
    redo: "Yinele",
    close: "Kapat",
    closed: "Kapandı",
    admin: "Yönetici",
    user: "Kullanıcı",
    stop: "Durdur",
    save: "Kaydet",
    discard: "İptal Et",
    all: "Hepsi",
    update: "Güncelle",
    like: "like",
    dislike: "Dislike",
    next: "sonraki",
    cancel: "iptal",
    canceled: "İptal Edildi",
    comment: "yorum",
    mention: "bahset",
    add: "Ekle",
    icon: "Simge",
    copylist: "Listeyi Kopyala",
    reply: "Yanıtla",
    replies: "Yanıtlar",
    PrivateReply: "Özel Yanıt",
    copy: "Kopyala",
    everywhere: "Her Yerde",
    UnHide: "Gizliliği Kaldır",
    show: "Göster",
    Hide: "Gizle",
    pageSummary: "Sayfa Özeti",
    summaryGeneralIntro: "Genel Sayfa Genel Bakış",
    summaryUserEngagement: "Kullanıcı Etkileşim Analizi",
    summaryContentStrategy: "İçerik Stratejisi İncelemesi",
    summaryPostingSchedule: "Yayın Programı Değerlendirmesi",
    summaryImprovementSuggestions: "İyileştirme ve Büyüme Önerileri",
    Ignore: "Yoksay",
    Orange: "Turuncu",
    Purple: "Mor",
    Green: "Yeşil",
    White: "Beyaz",
    DarkGray: "Koyu Gri",
    Blue: "Mavi",
    LightGray: "Açık Gri",
    Brown: "Kahverengi",
    Pink: "Pembe",
    Yellow: "Sarı",
    Silver: "Gümüş",
    Black: "Siyah",
    Red: "Kırmızı",
    select: "seç",
    back: "Geri",
    start: "Başlat",
    country: "Ülke",
    device: "Aygıt",
    yourdevice: "Senin Aygıtın",
    otherdevice: "Diğer Aygıt",
    SessionID: "Oturum Kimliği",
    header: "başlık",
    upload: "Yükle",
    active: "Aktif",
    activate: "Aktive Et",
    activateAll: "Tümünü Aktive Et",
    signout: "Çıkış Yap",
    switchaccount: "Hesap Değiştir",
    instagramConnect: "Bağlan Instagram Hesabı",
    upgrade: "Yükselt",
    Renew_Subscription: "Aboneliği Yenile",
    DeactivateAll: "Tümünü Devre Dışı Bırak",
    deactive: "Pasif",
    Deactivate: "Devre Dışı Bırak",
    done: "Tamamlandı",
    text: "Metin",
    PlaceHolder: "Yazılıyor...",
    media: "Video/Fotoğraf",
    ReplyStory: "Story’ye Yanıt",
    photo: "Fotoğraf",
    audio: "Sesli Mesaj",
    Generic: "Genel",
    StoryMention: "Story Etiketi",
    FileShare: "Dosya",
    voice: "Ses",

    abort: "İptal",
    Pending: "Beklemede",
    Preparing: "Hazırlanıyor",
    Finished: "Bitti",
    finish: "Bitir",
    exportJPG: "JPG'yi Dışa Aktar",
    exportPDF: "PDF'yi Dışa Aktar",
    exportXlxs: "Excel'yi Dışa Aktar",
    dismiss: "Kapat",
    empty: "Boş",
    searching: "Aranıyor ...",
    searchMessage: "Kişi veya Anahtar Kelime Ara",
    searchKeyword: "Anahtar Kelime Ara",
    Recommended: "Önerilen",
    VERFIED: "Doğrulandı",
    SuccessADS: "Reklam Başarısı",
    SuccessSALES: "Satış Başarısı",
    StartOrder: "Siparişi Başlat",
    Startshoping: "Alışverişi Başlat",
    question: "Soru",
    Answer: "Cevap",
    shareStory: "Story'i Paylaş",
    search: "arama",
    searchLocation: "Konum Ara",
    searchPeople: "Kişi Ara",
    edit: "Düzenle",
    delete: "Sil",
    deletecover: "Kapak Resmini Sil",
    details: "Detaylar",
    Insights: "İstatistikler",
    new: "Yeni",
    comments: "Yorumlar",

    nocomment: "Hiç yorum yok",
    SimilarProducts: "Benzer Ürünler",
    QandA: "Sorular",
    caption: "Altyazı",
    collaborator: "İşbirlikçi Sayfası",
    collaboratorpost: "İşbirlikçi Postu",
    sidebar_Home: "Ev",
    sidebar_Page: "Sayfa Yönetimi",
    sidebar_Message: "Mesajlar",
    sidebar_Wallet: "Cüzdan",
    sidebar_biolink: "Biyografi Bağlantısı",
    sidebar_Advertise: "Reklamlar",
    sidebar_Store: "Mağaza",
    sidebar_Stores: "Mağazalar",
    sidebar_Business: "İşletme",
    sidebar_Setting: "Ayarlar",
    //0️⃣ General -> navbar
    navbar_Post: "Gönderi",
    navbar_Live: "Canlı",
    navbar_Story: "Hikaye",
    navbar_Feed: "Feed",
    navbar_Reels: "Reels",
    navbar_Statistics: "İstatistikler",
    navbarTools: "Araçlar",
    navbar_Direct: "Direkt",
    navbar_Comments: "Yorumlar",
    navbar_Ticket: "Biletler",
    navbar_AI: "Yapay Zeka",
    navbar_ContentCreator: "İçerik Oluşturucu",
    navbar_Properties: "Özellikler",
    navbar_AIAndFlow: "AI ve Agent",
    navbar_Payment: "Ödemeler",
    navbar_Title: "Başlık",
    navbar_Home: "Anasayfa",
    navbar_Biolink: "Benim linkim",
    navbar_Calendar: "Takvim",
    navbar_AdList: "Reklam Listesi",
    navbar_General: "Genel",
    navbar_SubAdmin: "Alt Yöneticiler",
    navbar_HelpCenter: "Yardım ve Destek",

    addnewaccount: "Hesap Ekle",
    SwitchtoAccountexplain: "Brancy'ye eklenen tüm hesaplarınız burada listelenir",
    addedaccounts: "Eklenen Hesaplar",
    SwitchtoAccount: "Hesaba Geç",
    accountmanagement: "Hesap Yönetimi",
    subadmininvitation: "İşbirliği Daveti",
    subadmininvitationexplain: "Instagram yönetimi için yardımcı Admin daveti",

    navbar_Products: "Ürünler",
    navbar_Orders: "Siparişler",
    navbar_totalOrders: "Toplam Siparişler",
    //0️⃣ countdown
    countdown_Days: "Gün",
    countdown_Hours: "Saat",
    countdown_Minutes: "Dakika",
    Expired: "Süresi Doldu",
    justnow: "Şimdi",
    LessThanAMinute: "Bir dakikadan az",
    ExpiresIn: "Şu sürede sona erecek",

    ExportPDF: "PDF Dışa Aktar",
    ExportJPG: "JPG Dışa Aktar",
    ShareTo: "Paylaş",
    Expand: "Genişlet",
    // #endregion General Section
    // #region 1️⃣home Section
    // 1️⃣ Home -> cards
    home_FollowRequest: "Takip İstekleri",
    home_UnreadNewComments: "Okunmamış Yeni Yorumlar",
    home_Last24H: "Son 24 Saat",
    home_Last30Days: "Son 30 gün içinde",
    home_LastLikes: "Yeni Beğeniler",
    home_LastPost: "Son Gönderi",
    home_Followings: "Takip Edilenler",
    home_Followers: "Takipçiler",
    AudienceLocation: "Aktif Kitle Konumu",
    AudienceGender: "Aktif Kitle Cinsiyeti",
    AudienceAge: "Aktif Kitle Yaşı",

    AudienceGenderStats: "{{female}} kadın, {{male}} erkek ve {{unknown}} cinsiyeti belirsiz takipçiniz var",

    AudienceAgeStats:
      "İzleyicilerinizin çoğu {{ageRange}} yaş aralığında ({{percentage}}%), bu nedenle içerik {{ageCategory}} kitle için çekici ve uygun olmalıdır.",

    AgeCategoryYoung: "genç",
    AgeCategoryMiddleAged: "orta yaşlı",
    AgeCategoryOlder: "yaşlı",

    AudienceLocationStats:
      "En aktif kitleniz {{country}} ülkesinden {{countryCount, number}} kişi ve {{city}} şehrinden {{cityCount, number}} kişidir",

    // 1️⃣ Home -> last like
    lastLike: "Son Beğeniler",
    // 1️⃣ Home -> last message
    lastMessage: "Son Mesajlar",
    lastOrder: "Son Siparişler",
    lastTransaction: "Son İşlemler",
    // 1️⃣ Home -> last follower
    LastFollowers: "Son Takipçiler",
    // #endregion home Section
    // #region 2️⃣page Section
    // 2️⃣ Page -> Post
    CreateNewPost: "Yeni Gönderi Oluştur",
    Postnotvisible: "Post Görünmüyor mu?",
    Storynotvisible: "Story Görünmüyor mu?",
    SmartPageAnalysis: "Akıllı Sayfa Analizi",
    EducationAndGuidance: "Eğitim ve Rehberlik",
    HowToUseBrancy: "Brancy Nasıl Kullanılır",
    BrancyKnowsYou: "Brancy Sizi Tanıyor",
    BrancyKnowsYouExplain:
      "Brancy, dijital kimliğinizin eksiksiz bir profilini oluşturmak için sayfanızı derinlemesine analiz eder; kişiliğiniz, işletmeniz ve faaliyetlerinizden iletişim tonunuz ve tarzınıza, içerik türünüzden içerikleri sunma biçiminize, paylaşım zamanlamanızdan kitlenizle etkileşim şeklinize kadar birçok unsuru değerlendirir.\n\nBu analiz, sayfanızdaki tüm iletişim noktalarındaki faaliyetlerinizi de dikkate alır; yorumlara ve Direct mesajlara verdiğiniz yanıtlardan yazım tarzınıza, kitlenizle iletişim şeklinizden farklı durumlara verdiğiniz tepkilere kadar.\n\nManuel eğitim, ton ayarı veya ek bilgi girişi gerekmeden Brancy sizi tanır ve yapay zekâyı gerçek kimliğiniz ve tarzınız doğrultusunda uyumlandırır.",
    CreateYourDigitalVersion: "Dijital Versiyonunuzu Oluşturun",
    CreateNewStrory: "Yeni Hikaye Oluştur",
    PostDraft: "Gönderi Taslağı",
    StoryDraft: "Hikaye Taslağı",
    publishError: "Yayınlama Hatası",
    DeletedPost: "Silinmiş Gönderi",
    errorDraft_title: "Post yayınlanırken bir hata oluştu",
    errorDraft_configFailed: "Post yayın ayarları hatalı, lütfen kontrol edip düzeltin.",
    errorDraft_invalidTags: "Geçersiz etiketler: ",
    errorDraft_unknown: "Bilinmeyen hata! Lütfen tekrar deneyin.",
    errorDraft_uploadError: "Resim yükleme başarısız oldu, lütfen tekrar deneyin.",
    errorDraft_userCancel: "Post yayını tarafınızdan iptal edildi.",
    InvalidAspectRatio: "Geçersiz en-boy oranı",
    SizeLimitExceed: "Dosya boyutu sınırı aşıldı",
    UnSupportMediaType: "Desteklenmeyen medya türü",
    NotPublishedAtTheTime: "Gönderi seçilen saatte yayınlanmadı",
    NotSuccessLogin: "Giriş başarısız",

    NewScheduledPost: "Yeni Planlanmış Gönderi",
    thereAreNoPost: "Henüz zamanlanmış bir Post oluşturmadınız",
    ScheduledPost: "Planlanmış Gönderi",
    // 2️⃣ Page -> story
    pageStory_CreateNewStory: "Yeni Hikaye Oluştur (Yakında)",
    pageStory_CreateNewStories: "Yeni Planlanmış Hikaye (Yakında)",
    pageStory_thereAreNoStories: "Henüz zamanlanmış bir Story oluşturmadınız",
    pageStory_ScheduledStories: "Planlanmış Hikaye",
    // 2️⃣ Page -> highlight
    pageStory_highlightManagement: "Öne Çıkanlar Yönetimi",
    pageStory_thereAreNoHighlight: "Öne Çıkan Yok",
    pageStory_HighlightTitle: "Öne Çıkanlar / Klasörler",
    // 2️⃣ Page -> statistic
    pageStatistics_YourBestFollowers: "En İyi Takipçileriniz",
    pageStatistics_YourBestFollowersExplain:
      "Tüm sayfadaki etkileşim puanına göre hesaplanır (beğeniler, yorumlar ve paylaşımlar dahil).",
    pageStatistics_LoadMore: "Daha Fazla Yükle",
    pageStatistics_UnFollowers: "Takipten Çıkanlar",
    pageStatistics_Followers: "Takipçiler",
    pageStatistics_NewFollowers: "Yeni Takipçiler",
    pageStatistics_ActiveFollowers: "Aktif Takipçiler",
    pageStatistics_MediaFollows: "Medya Takipleri",
    pageStatistics_Reach: "Erişim",
    pageStatistics_ProfileVisit: "Profil Ziyaretleri",
    pageStatistics_30Days: "30 gün",
    pageStatistics_60Days: "60 gün",
    pageStatistics_90Days: "90 gün",
    pageStatistics_120Days: "120 gün",
    pageStatistics_WorstTime: "En Kötü Zaman",
    pageStatistics_BestTime: "En İyi Zaman",
    pageStatistics_likes: "Beğeniler",
    pageStatistics_Engagements: "Etkileşimler",
    pageStatistics_Impression: "Gösterim",
    pageStatistics_Views: "Görünümler",
    pageStatistics_RePosts: "Yeniden Paylaşımlar",
    pageStatistics_followerViews: "Ziyaretçi Falorlar",
    pageStatistics_ghostViewers: "Gizli Görüntüleyenler",
    pageStatistics_Comments: "Yorumlar",
    pageStatistics_Shares: "Paylaşımlar",
    pageStatistics_summary: "Özet",
    pageStatistics_EmptyList: "Henüz veri yok!",
    pageStatistics_from: "Karşılaştırıldığında",
    pageStatistics_post: "Gönderiler",
    pageStatistics_stories: "Hikayeler",
    pageStatistics_MaxView: "Maksimum Erişim",
    pageStatistics_MinView: "Minimum Erişim",
    pageStatistics_MaxCommentLike: "Max Yorum & Beğeni",
    pageStatistics_MinCommentLike: "Min Yorum & Beğeni",
    pageStatistics_PostTimeAnalysis: "Gönderi Zamanı Analizi",
    pageStatistics_Rate: "Oran",
    pageStatistics_RateExplain: "Sayfanın tamamında alınan en yüksek yorum sayısına göre",

    pageStatistics_24HourHeatmap: "24 Saatlik Isı Haritası",
    pageStatistics_Low: "Düşük",
    pageStatistics_High: "Yüksek",
    pageStatistics_TopHour: "En İyi Saat",
    pageStatistics_WeakHour: "Zayıf Saat",
    pageStatistics_AverageHour: "Ortalama Saat",
    pageStatistics_TopMinute: "En İyi Dakika",
    pageStatistics_WeakMinute: "Zayıf Dakika",
    pageStatistics_AverageMinute: "Ortalama Dakika",
    pageStatistics_HourExcellentLevel:
      "Bu saat, mükemmel bir etkileşim seviyesine sahiptir (%80 kapasitenin üzerinde). Bu zaman aralığında etkileşim ortalamadan {{percentage}}% daha yüksektir ve önemli içerikler için idealdir.",
    pageStatistics_HourGoodLevel:
      "Bu saat, iyi bir etkileşim seviyesine sahiptir (%60–80 kapasite). Etkileşim ortalamadan {{percentage}}% daha yüksektir, normal içerikler için uygundur.",
    pageStatistics_HourAverageLevel:
      "Bu saatte etkileşim seviyesi orta düzeydedir (%40–60 kapasite). Daha iyi sonuçlar için daha yüksek yoğunluklu saatleri (yeşil) deneyin. En iyi zamana fark: {{difference}}%.",
    pageStatistics_HourWeakLevel:
      "Bu saat düşük bir etkileşim seviyesine sahiptir (%20–40 kapasite). Daha yüksek yoğunluklu saatlerde paylaşım önerilir.",
    pageStatistics_HourVeryWeakLevel:
      "Bu saat çok düşük bir etkileşim seviyesine sahiptir (%20’nin altında). Etkileşim beklentinin altındadır ve paylaşım önerilmez.",
    pageStatistics_MinuteTopDescription:
      "Bu dakika, {{hour}}:00 saatinin en iyi 10 dakikası arasındadır. Maksimum etkileşim için tam olarak bu dakikada paylaşım önerilir. En zayıf dakikaya fark: {{difference}}%.",
    pageStatistics_MinuteWeakDescription:
      "Bu dakikada etkileşim düşüktür. Saatin ilk veya orta dakikalarında paylaşım daha iyi sonuç verebilir. En iyi dakikaya fark: {{difference}}%.",
    pageStatistics_MinuteAverageDescription:
      "Etkileşim ortalama seviyededir. Daha iyi optimize etmek için saatin daha üst sıralarda yer alan dakikalarını inceleyin.",
    pageStatistics_PeakEngagement: "En Yüksek Etkileşim",
    pageStatistics_StableGrowth: "Dengeli Büyüme",
    pageStatistics_HighEngagementProbability: "Yüksek Etkileşim Olasılığı",
    pageStatistics_LowestEngagement: "En Düşük Anlık Etkileşim",
    pageStatistics_SustainedLowPeriod: "Sürekli Düşük Dönem",
    pageStatistics_LowEngagementProbability: "Düşük Etkileşim Olasılığı",
    pageStatistics_BestTimes: "En İyi Zamanlar",
    pageStatistics_WorstTimes: "En Kötü Zamanlar",
    pageStatistics_EngagementPrediction: "Etkileşim Tahmini",
    pageStatistics_PeakTimeDescription:
      "Bu anda en yüksek etkileşim gerçekleşir. Maksimum erişim için bu saat önerilir.",
    pageStatistics_StableTimeDescription:
      "Bu zamandan itibaren etkileşim artmaya başlar ve ortalamanın üzerinde kalır. Stabil etkileşim için uygundur.",
    pageStatistics_SecondaryTimeDescription: "Bu zamanda paylaşım yapmak iyi sonuç verebilir.",
    pageStatistics_LowestTimeDescription:
      "Bu zaman en düşük anlık etkileşime sahiptir. Bu saatte paylaşım yapmak potansiyel etkileşimin {{percentage}}%’sini kaybettirir.",
    pageStatistics_SustainedLowTimeDescription:
      "Bu andan sonra etkileşim düşmeye başlar ve bir süre düşük kalır. Paylaşım önerilmez.",
    pageStatistics_SecondaryLowTimeDescription:
      "Düşük etkileşim olasılığına sahip başka bir zayıf zaman dilimi. Paylaşım tavsiye edilmez.",
    pageStatistics_HourEngagementTooltip: "{{hour}}:00 - {{count}} etkileşim ({{percentage}}%)",
    pageStatistics_MinuteEngagementTooltip: "{{hour}}:{{minute}} - {{count}} etkileşim",

    // statistics suggestions box
    Statistics_UnFollowers_up_title: "Unfollower Azalması 💡Artık tutundurma stratejini güçlendirme zamanı",
    Statistics_UnFollowers_up_summary:
      "Düşüş azaldı, yani son içeriklerin işe yaradı. Bu yolu daha dikkatli şekilde devam ettir.",
    Statistics_UnFollowers_up_action1: "Son üç Post’u kapak, ilk cümle ve CTA açısından analiz et.",
    Statistics_UnFollowers_up_action2: "Bu formatlara göre haftalık bir takvim oluştur ve değişiklikleri kaydet.",
    Statistics_UnFollowers_up_action3: "Yeni Followers için hoş geldin Story’si ve düzenli bir Highlight hazırla.",
    Statistics_UnFollowers_up_urgency: "Orta",

    Statistics_UnFollowers_neutral_title: "Sabit düşüş 💡Değişiklik yapmadan önce kullanıcıdan veri al",
    Statistics_UnFollowers_neutral_summary:
      "Kitle davranışı değişmemiş; doğrudan görüşlerini ölçmen ve kısa testler yapman gerekiyor.",
    Statistics_UnFollowers_neutral_action1: "Story’de bir anket paylaşarak neyin daha çekici olduğunu sor.",
    Statistics_UnFollowers_neutral_action2: "Haftada bir sabit formatlı Post paylaş ve sonuçları karşılaştır.",
    Statistics_UnFollowers_neutral_action3:
      "Comments’te en sık tekrar eden üç sorunu topla ve her biri için bir sorun-çözüm Post’u hazırla.",
    Statistics_UnFollowers_neutral_urgency: "Düşük",

    Statistics_UnFollowers_down_title: "Unfollow Artışı 💡Hızlı bir düzeltme şart",
    Statistics_UnFollowers_down_summary:
      "Unfollow artışı, içerikte veya paylaşım ritminde negatif bir sinyal olduğu anlamına gelir; hızlı test ve tepki gerekir.",
    Statistics_UnFollowers_down_action1:
      "Son 7 günün verilerini kontrol et ve en fazla unfollow alan iki Post'u belirle.",
    Statistics_UnFollowers_down_action2:
      "Dürüst veya kamera arkası bir Post paylaş ve nedeni doğrudan takipçilerden sor.",
    Statistics_UnFollowers_down_action3:
      "“Neden Unfollow yaptın?” şeklinde açık uçlu bir Story paylaş ve yanıtları kategorize et.",
    Statistics_UnFollowers_down_urgency: "Yüksek",

    Statistics_UnFollowers_zero_title: "Hiçbir aktivite yok 💡analiz için veri bulunmuyor",
    Statistics_UnFollowers_zero_summary:
      "Aktivite olmadığı için analiz edilecek sinyal oluşmamış; önce paylaşım döngünü yeniden başlatmalısın.",
    Statistics_UnFollowers_zero_action1: "İlk davranış sinyalini oluşturmak için değer odaklı bir Post paylaş.",
    Statistics_UnFollowers_zero_action2:
      "İlk reaksiyonu almak için iki etkileşim odaklı Story paylaş (Poll veya Question).",
    Statistics_UnFollowers_zero_action3:
      "Organik erişimin başlaması için kısa bir tanıtım veya güncelleme Post'u paylaş.",
    Statistics_UnFollowers_zero_urgency: "Yüksek",

    Statistics_Followers_up_title: "Takipçi Artışı 💡Yeni Gelenleri Doğru Karşıla",
    Statistics_Followers_up_summary:
      "Büyüme yükselişte; içeri girer girmez onlara olumlu bir deneyim sunmalısın ki aktif Followers olsunlar.",
    Statistics_Followers_up_action1:
      "“Ne bulacaksın & sana nasıl yardımcı olacak” formatında bir karşılama Highlight hazırla.",
    Statistics_Followers_up_action2: "Sürekli ve kaliteli bir çekim için iki hafif iş birliği veya Mention planla.",
    Statistics_Followers_up_action3: "Takipçi kalitesini kampanya istatistikleri ve Reels girişlerinden kontrol et.",
    Statistics_Followers_up_urgency: "Orta",

    Statistics_Followers_neutral_title: "Dengeli Büyüme 💡Kısa Testlerin Zamanı",
    Statistics_Followers_neutral_summary:
      "Sayfa büyümesi sabit; çekimi etkileyen şeyleri anlamak için 7 günlük testlere ihtiyacın var.",
    Statistics_Followers_neutral_action1: "Hashtag, paylaşım zamanı ve farklı kapaklar üzerinde 7 günlük bir test yap.",
    Statistics_Followers_neutral_action2: "Sonuçları kaydet ve en iyi kombinasyonu sabit bir formata dönüştür.",
    Statistics_Followers_neutral_action3:
      "Yeni gelenlerin ne bekleyeceğini hızlıca anlaması için kısa bir tanıtım videosu paylaş.",
    Statistics_Followers_neutral_urgency: "Orta",

    Statistics_Followers_down_title: "Çekim Düşüşü 💡Son içerik muhtemelen personayla uyuşmuyor",
    Statistics_Followers_down_summary:
      "Çekim azalması, mevcut içerik ile hedef kitle arasında uyumsuzluk sinyali olduğunu gösterir.",
    Statistics_Followers_down_action1: "Personayla son içerik arasında üç uyumsuzluk bul ve düzelt.",
    Statistics_Followers_down_action2: "Bio, CTA ve son birkaç Post’un kapaklarını hızlıca yeniden yaz ve test et.",
    Statistics_Followers_down_action3:
      "Sayfanın algısını yeniden canlandırmak için küçük bir iş birliği veya UGC kampanyası yap.",
    Statistics_Followers_down_urgency: "Yüksek",

    Statistics_Followers_zero_title: "Son Aktivite Yok 💡Çekim Verisi Oluşmadı",
    Statistics_Followers_zero_summary:
      "Paylaşım veya çekim adımı olmadığı için analiz edilecek sinyal yok; çekim döngüsünü yeniden aktive etmelisin.",
    Statistics_Followers_zero_action1: "İlk girişleri oluşturmak için 3 saniyelik hook’a sahip beş kısa Reels paylaş.",
    Statistics_Followers_zero_action2: "Doğal erişimi başlatmak için tanıtım veya güncelleme Post’u paylaş.",
    Statistics_Followers_zero_action3:
      "Büyümeyi yeniden başlatmak için küçük bir çekim kampanyası (lokal bile olabilir) düzenle.",
    Statistics_Followers_zero_urgency: "Yüksek",

    Statistics_MediaFollows_up_title: "Explore Trafiği Arttı 💡En İyi Yöntem Seri İçerik",
    Statistics_MediaFollows_up_summary:
      "Harici yönlendirmelerin var; başarılı formatlarını düzenli bir seriye dönüştür.",
    Statistics_MediaFollows_up_action1: "Başarılı formatı 3 ila 5 bölüme ayır ve tüm bölümlerde ortak bir CTA kullan.",
    Statistics_MediaFollows_up_action2: "Sabit bir kapak ve düzenli bir takvim seç ki izleyici seriye alışsın.",
    Statistics_MediaFollows_up_action3: "İlk günlerdeki dağılımı takip et ve hızlı trafik getiren kaynağa odaklan.",
    Statistics_MediaFollows_up_urgency: "Orta",

    Statistics_MediaFollows_neutral_title: "Orta Seviyede Yönlendirme 💡Kapak ve Kaynak İçin A/B Zamanı",
    Statistics_MediaFollows_neutral_summary:
      "Explore girişini artırmak için kapak ve yönlendirme kaynağı optimize edilmeli.",
    Statistics_MediaFollows_neutral_action1: "İki A/B kapak yayınla ve 48 saatlik performanslarını karşılaştır.",
    Statistics_MediaFollows_neutral_action2: "En çok trafik getiren kaynakları listele ve tekrar hedefle.",
    Statistics_MediaFollows_neutral_action3: "Başarılı formatlardan bir banka oluştur ki tekrarları kolaylaşsın.",
    Statistics_MediaFollows_neutral_urgency: "Düşük",

    Statistics_MediaFollows_down_title: "Explore’dan Gelen Trafik Düştü 💡Daha Çekici İçerik Gerekli",
    Statistics_MediaFollows_down_summary:
      "Explore’dan çekim için daha faydalı veya indirilebilir içerik daha etkili olur.",
    Statistics_MediaFollows_down_action1:
      "İndirilebilir bir PDF veya kontrol listesi oluştur ve paylaşım için bir link ver.",
    Statistics_MediaFollows_down_action2: "Kısa eğitim içerikleri yayınla ve hedefli reklamı test et.",
    Statistics_MediaFollows_down_action3: "Tüm linkleri ve yönlendirme yollarını teknik olarak kontrol et.",
    Statistics_MediaFollows_down_urgency: "Yüksek",

    Statistics_MediaFollows_zero_title: "Hiç Aktivite Yok 💡Explore Sinyali Oluşmamış",
    Statistics_MediaFollows_zero_summary:
      "Paylaşım veya çekim adımı olmadığı için analiz edilecek veri yok; önce içerik döngüsünü aktifleştirmen gerekiyor.",
    Statistics_MediaFollows_zero_action1: "Kullanıcılar için çekici içerikler üretmeye ve düzenli paylaşmaya başla.",
    Statistics_MediaFollows_zero_action2: "İlk yönlendirme sinyallerini oluşturmak için günde beş kısa içerik paylaş.",
    Statistics_MediaFollows_zero_action3: "İlk gün bir güçlendirilmiş Post paylaşarak başlangıç trafiği oluştur.",
    Statistics_MediaFollows_zero_urgency: "Yüksek",

    Statistics_Reach_up_title: "Reach Arttı 💡Ölçekleme Zamanı",
    Statistics_Reach_up_summary: "Erişim arttı; büyüme dalgasını sürdürmek için en iyi formatları tekrar edin.",
    Statistics_Reach_up_action_1: "En yüksek Reach formatlarından ikisini zirve zamanlarda yeniden paylaşın.",
    Statistics_Reach_up_action_2: "Etkili hashtag’leri sabitleyin ve her zaman açıklamada bulundurun.",
    Statistics_Reach_up_action_3: "Organik Reach’i artırmak için paylaşılabilirliği yüksek Posts oluşturun.",
    Statistics_Reach_up_urgency: "Orta",

    Statistics_Reach_neutral_title: "Reach Sabit 💡Test Gerekiyor",
    Statistics_Reach_neutral_summary:
      "Durağanlıktan çıkmak için hafif işbirliği veya hashtag testi en iyi yaklaşımdır.",
    Statistics_Reach_neutral_action_1: "Aynı alanda bir sayfa ile cross-Post koordine edin.",
    Statistics_Reach_neutral_action_2: "İki eğitim veya eğlence Reels yayınlayın ve geri bildirimi değerlendirin.",
    Statistics_Reach_neutral_action_3: "Haftalık hashtag listenizi kontrol edin ve en iyi kombinasyonu bulun.",
    Statistics_Reach_neutral_urgency: "Düşük",

    Statistics_Reach_down_title: "Reach Düştü 💡Hızlı Tepki Gerek",
    Statistics_Reach_down_summary: "Erişim azaldı; paylaşılabilir içerik ve kısa vadeli testler öncelikli.",
    Statistics_Reach_down_action_1: "Yüksek potansiyelli Reels üzerinde 7 günlük test yapın.",
    Statistics_Reach_down_action_2: "Paylaşılabilir Posts oluşturun ve kısa bir reklam ile destekleyin.",
    Statistics_Reach_down_action_3: "Başlığı, kapak ve hashtag’leri yeniden yazın ve Post’u tekrar yayınlayın.",
    Statistics_Reach_down_urgency: "Yüksek",

    Statistics_Reach_zero_title: "Reach Kaydedilmedi 💡Düşük Aktivite",
    Statistics_Reach_zero_summary:
      "Yayın eksikliği veya yeterli sinyal olmadığı için Reach verisi yok; içerik döngüsü aktif olmalı.",
    Statistics_Reach_zero_action_1:
      "Veri toplama (API/logs) bağlantısını kontrol edin, düzgün çalıştığından emin olun.",
    Statistics_Reach_zero_action_2: "5 trend Reels yayınlayın ve ikinci günden birini destekleyin.",
    Statistics_Reach_zero_action_3: "Yayınlama zamanlama sistemini test edin ve gerekirse resetleyin.",
    Statistics_Reach_zero_urgency: "Yüksek",

    Statistics_ProfileVisit_up_title: "Profil Ziyaretleri Yüksek 💡Dönüşüme Odaklan",
    Statistics_ProfileVisit_up_summary:
      "İyi trafik var; Bio ve CTA hızlı bir şekilde optimize edilmeli, böylece ziyaretler falo ve clicklere dönüşür.",
    Statistics_ProfileVisit_up_action_1: "Bio'yu net bir değer önerisi ve doğrudan CTA ile yeniden yazın.",
    Statistics_ProfileVisit_up_action_2:
      "Kullanıcının ne gördüğünü ve ne beklediğini anlaması için önemli Highlights oluşturun.",
    Statistics_ProfileVisit_up_action_3: "Link tıklama oranını artırmak için özel teklifli bir Post paylaşın.",
    Statistics_ProfileVisit_up_urgency: "Yüksek",

    Statistics_ProfileVisit_neutral_title: "Ziyaret Var, Dönüşüm Yok 💡Lead Oluştur",
    Statistics_ProfileVisit_neutral_summary: "Trafik var ama dönüşüm düşük; çekici bir Lead akışı değiştirebilir.",
    Statistics_ProfileVisit_neutral_action_1: "Highlights içine ücretsiz bir dosya veya kontrol listesi ekleyin.",
    Statistics_ProfileVisit_neutral_action_2: "Kapsamlı CTA ile açıklamaları güçlendirin.",
    Statistics_ProfileVisit_neutral_action_3: "Profil yönlendiren ve davet eden Stories sayısını artırın.",
    Statistics_ProfileVisit_neutral_urgency: "Orta",

    Statistics_ProfileVisit_down_title: "Ziyaretler Düştü 💡Daha Güçlü Bir Hook Gerek",
    Statistics_ProfileVisit_down_summary: "Merak azaldı; caption başlangıçları ve CTA daha çekici ve net olmalı.",
    Statistics_ProfileVisit_down_action_1: "Captionları 3–5 kelimelik bir hook ile yeniden yazın.",
    Statistics_ProfileVisit_down_action_2: "Yönlendirici Stories ekleyin ve linki kalın yapın.",
    Statistics_ProfileVisit_down_action_3: "Kullanıcıları profil ziyaretine teşvik eden bir Post paylaşın.",
    Statistics_ProfileVisit_down_urgency: "Yüksek",

    Statistics_ProfileVisit_zero_title: "Ziyaret Kaydı Yok 💡Yeterli Aktivite Yok",
    Statistics_ProfileVisit_zero_summary:
      "Yayınlama veya yeterli sinyal olmaması nedeniyle profil ziyareti kaydedilmedi; etkileşim döngüsü yeniden aktive edilmeli.",
    Statistics_ProfileVisit_zero_action_1: "Hesap durumunu kontrol edin ve public olduğundan emin olun.",
    Statistics_ProfileVisit_zero_action_2: "Açık CTA ile davet edici bir Post paylaşın.",
    Statistics_ProfileVisit_zero_action_3: "Önemli Highlights'i güncelleyin ve ilk ziyaret sinyalini oluşturun.",
    Statistics_ProfileVisit_zero_urgency: "Yüksek",

    Statistics_Likes_up_title: "Beğeniler İyi 💡Alışkanlık Yarat",
    Statistics_Likes_up_summary:
      "Kullanıcılar beğeniyor; şimdi bu davranışı sürekli bir alışkanlığa dönüştürmeyi hedefle.",
    Statistics_Likes_up_action_1: "Başarılı formatları belgeleyin (cover, template, uzunluk).",
    Statistics_Likes_up_action_2: "Post sonunda basit bir beğeni CTA'sı ekleyin (örneğin 'Katılıyorsan ❤').",
    Statistics_Likes_up_action_3: "Cover ve ilk 3 saniye için küçük bir A/B testi yapın.",
    Statistics_Likes_up_urgency: "Orta",

    Statistics_Likes_neutral_title: "Beğeniler Artabilir 💡Hook ve Cover'ı Geliştir",
    Statistics_Likes_neutral_summary: "Potansiyel var; cover ve hook'u değiştirerek beğeni oranını artırabilirsiniz.",
    Statistics_Likes_neutral_action_1: "Cover ve ilk 3 saniyeyi optimize edin ve test edin.",
    Statistics_Likes_neutral_action_2: "Beğeni daveti için duygusal veya sorulu CTA'lar kullanın.",
    Statistics_Likes_neutral_action_3: "Hedef kitlenin görsel tercihlerini anlamak için küçük bir anket yapın.",
    Statistics_Likes_neutral_urgency: "Düşük",

    Statistics_Likes_down_title: "Beğeniler Düştü 💡Görsel Kimliği Yeniden Tasarla",
    Statistics_Likes_down_summary: "Mesaj veya görsel güçlü olmayabilir; içeriğin ilk anına odaklanın.",
    Statistics_Likes_down_action_1: "Cover ve caption'ın ilk cümlesini yeniden yazın.",
    Statistics_Likes_down_action_2: "Cover rengi/tasarımı için A/B testi yapın.",
    Statistics_Likes_down_action_3: "Güçlü ve ilgili görsel Posts yayınlayın.",
    Statistics_Likes_down_urgency: "Yüksek",

    Statistics_Likes_zero_title: "Sıfır Beğeni 💡Ya Veri Yok ya da İçerik Yok",
    Statistics_Likes_zero_summary: "İçerik varsa ama beğeni yoksa, veriyi kontrol edin; yoksa üretime başlayın.",
    Statistics_Likes_zero_action_1: "Veri kayıt doğruluğunu doğrulayın.",
    Statistics_Likes_zero_action_2: "İçerik yoksa, birkaç Post güçlü cover ile yayınlayın.",
    Statistics_Likes_zero_action_3: "Geri bildirim almak için partner ağları kullanın.",
    Statistics_Likes_zero_urgency: "Yüksek",

    Statistics_Comments_up_title: "Yorumlar Arttı 💡Konuşmaları Ciddiye Al",
    Statistics_Comments_up_summary:
      "İnsanlar konuşuyor; yorumlara cevap vererek ve yorumları içeriğe dönüştürerek onları değerlendirin.",
    Statistics_Comments_up_action1: "Yorumlara cevap verin ve en iyi 3 fikri bir Post’a dönüştürün.",
    Statistics_Comments_up_action2: "En iyi yorumlara dikkat çekin veya Story’de gösterin.",
    Statistics_Comments_up_action3: "Caption’a insanları cevap vermeye teşvik eden bir soru ekleyin.",
    Statistics_Comments_up_urgency: "Orta",

    Statistics_Comments_neutral_title: "Yorumlar Az 💡Bir Uyarıcı Ekle",
    Statistics_Comments_neutral_summary: "Sohbet yaratmak için basit ve doğrudan sorular sorun.",
    Statistics_Comments_neutral_action1: "Post’un sonunda açık bir soru bırakın.",
    Statistics_Comments_neutral_action2: "İlk 5 yoruma hızlıca cevap verin, diğerlerini teşvik edin.",
    Statistics_Comments_neutral_action3: "Kısa bir challenge veya anket yapın.",
    Statistics_Comments_neutral_urgency: "Düşük",

    Statistics_Comments_down_title: "Yorumlar Azaldı 💡Açık Stimüller Ekleyin",
    Statistics_Comments_down_summary: "Konuşmayı başlatmak için doğrudan CTA ve davetlere ihtiyacınız var.",
    Statistics_Comments_down_action1: "Bir challenge yayınlayın veya kişisel deneyimler isteyin.",
    Statistics_Comments_down_action2: "Caption’da yorumlar için açık bir CTA ekleyin (ör: 'Sen ne düşünüyorsun?').",
    Statistics_Comments_down_action3: "İlk yorumlara hızlıca cevap verin.",
    Statistics_Comments_down_urgency: "Yüksek",

    Statistics_Comments_zero_title: "Yorum Yok 💡Davet Edici Ol",
    Statistics_Comments_zero_summary: "İçerik insanları yorum yapmaya teşvik etmiyor; formatları daha davetkar yapın.",
    Statistics_Comments_zero_action1: "Basit ve çekici sorular tasarlayın (ör: iki seçenek arasında seçim).",
    Statistics_Comments_zero_action2: "İlk yorumlara hızlı yanıt verin ki diğerleri teşvik edilsin.",
    Statistics_Comments_zero_action3: "Yorum yapmak için doğrudan CTA kullanın.",
    Statistics_Comments_zero_urgency: "Yüksek",

    Statistics_Views_up_title: "Görüntülemeler Arttı 💡Trafikten Yararlan",
    Statistics_Views_up_summary:
      "Video görüntülemeleri iyi; videonun sonunu trafik yönlendirmek için kullan (profil/kaydet).",
    Statistics_Views_up_action1: "Videonun sonunda net bir CTA ekle (ör: 'Daha fazlası için kaydet').",
    Statistics_Views_up_action2: "Ek içerik linkini bio veya highlight’ta paylaş.",
    Statistics_Views_up_action3: "Kısa bir versiyon veya teaser oluştur ve yayınla.",
    Statistics_Views_up_urgency: "Orta",

    Statistics_Views_neutral_title: "Görüntülemeler Sabit 💡Kanca ve Kapak Güçlendir",
    Statistics_Views_neutral_summary: "İzlenme oranını artırmak için ilk 3 saniye ve kapağa odaklan.",
    Statistics_Views_neutral_action1: "Başlangıç kancasını ve kapağı yeniden yaz.",
    Statistics_Views_neutral_action2: "Test için kısa bir versiyon yayınla.",
    Statistics_Views_neutral_action3: "Hedef kitleden görsel geri bildirim al.",
    Statistics_Views_neutral_urgency: "Düşük",

    Statistics_Views_down_title: "Görüntülemeler Düştü 💡Kancayı Güçlendir",
    Statistics_Views_down_summary: "Videonun başı zayıf; kısa ve ilgi çekici versiyonları test etmeye başla.",
    Statistics_Views_down_action1: "5 güçlü 15 saniyelik video üret.",
    Statistics_Views_down_action2: "Videonun başını yeniden yaz ve A/B testi yap.",
    Statistics_Views_down_action3: "Dikkati korumak için düzenleme hızını artır.",
    Statistics_Views_down_urgency: "Yüksek",

    Statistics_Views_zero_title: "Sıfır Görüntüleme? 💡İçeriği Hemen Yayınla",
    Statistics_Views_zero_summary: "İçerik üretimine en kısa sürede başla.",
    Statistics_Views_zero_action1: "Sadece sayfanın iş akışını analiz ederek başla.",
    Statistics_Views_zero_action2: "Video yayınlanmadıysa 3 kısa reel üret.",
    Statistics_Views_zero_action3: "İlk gösterimi sağlamak için bir destek postu yap.",
    Statistics_Views_zero_urgency: "Yüksek",

    Statistics_FollowerViews_up_title: "Takipçiler İzliyor 💡İç Etkileşim Oluştur",
    Statistics_FollowerViews_up_summary: "Takipçiler aktif; onları iç etkileşim için kullan (AMA, anketler).",
    Statistics_FollowerViews_up_action1: "Hikayelerde takipçilere sorular sor veya anket yap.",
    Statistics_FollowerViews_up_action2: "Takipçiler için özel içerik paylaş (ör. AMA).",
    Statistics_FollowerViews_up_action3: "Formatları persona ile kontrol et, böylece tercihleri daha doğru hedeflenir.",
    Statistics_FollowerViews_up_urgency: "Orta",

    Statistics_FollowerViews_neutral_title: "Takipçi Görüntülemeleri Normal 💡Zamanlama ve Formatı Test Et",
    Statistics_FollowerViews_neutral_summary: "Paylaşım zamanı veya içerik türü değişebilir; basit testler yap.",
    Statistics_FollowerViews_neutral_action1: "Paylaşım zamanını değiştir ve etkisini kaydet.",
    Statistics_FollowerViews_neutral_action2: "Takipçiler için yeni bir format test et.",
    Statistics_FollowerViews_neutral_action3: "İçeriği önceki izleyici davranışlarına göre kişiselleştir.",
    Statistics_FollowerViews_neutral_urgency: "Düşük",

    Statistics_FollowerViews_down_title: "Takipçi Görüntülemeleri Azaldı 💡Geri Bildirim Al",
    Statistics_FollowerViews_down_summary:
      "Persona’dan uzaklaşma ihtimali var; geri bildirim topla ve 3 hızlı değişiklik yap.",
    Statistics_FollowerViews_down_action1: "Son geri bildirimleri topla ve üç hızlı değişiklik uygula.",
    Statistics_FollowerViews_down_action2: "Takipçileri yeniden aktif hale getirmek için ilgi çekici hikayeler paylaş.",
    Statistics_FollowerViews_down_action3: "Kişiselleştirilmiş içerik sürümlerini test et.",
    Statistics_FollowerViews_down_urgency: "Yüksek",

    Statistics_FollowerViews_zero_title: "Takipçi Görüntülemeleri Sıfır 💡Önce Aktif Takipçileri Sağla",
    Statistics_FollowerViews_zero_summary: "Muhtemelen az aktif takipçin var; önce uyandır, sonra etkileşim kur.",
    Statistics_FollowerViews_zero_action1: "Takipçileri uyandırmak için birkaç hikaye ve gönderi paylaş.",
    Statistics_FollowerViews_zero_action2: "10 aktif takipçiyle doğrudan etkileşimde bulun.",
    Statistics_FollowerViews_zero_action3: "Önceki ilgi alanlarına göre içerik üret.",
    Statistics_FollowerViews_zero_urgency: "Yüksek",

    Statistics_NonFollowerViews_up_title: "Takipçi Olmayan Görüntülemeler Yükseldi 💡Yeni Çekim Fırsatı",
    Statistics_NonFollowerViews_up_summary:
      "Takipçileriniz dışında insanlar izliyor; her gönderi takip için güçlü bir neden sunmalı.",
    Statistics_NonFollowerViews_up_action1:
      "Başlıkta güçlü bir takip nedeni ekle (ör. seri içerik veya adım adım öğreticiler).",
    Statistics_NonFollowerViews_up_action2: "Takipçi olmayanları etkileşime çekmek için trend Reels tasarla.",
    Statistics_NonFollowerViews_up_action3: "Hedefli hashtagler ve ilgili iş birlikleri kullan.",
    Statistics_NonFollowerViews_up_urgency: "Orta",

    Statistics_NonFollowerViews_neutral_title: "Takipçi Olmayan Görüntülemeler Sabit 💡Hashtag ve Dağıtımı Optimize Et",
    Statistics_NonFollowerViews_neutral_summary:
      "Hashtag ve paylaşılabilir içerik optimizasyonu, takipçi olmayan trafiği artırabilir.",
    Statistics_NonFollowerViews_neutral_action1: "Etkili hashtagleri belirle ve birkaçını sabit tut.",
    Statistics_NonFollowerViews_neutral_action2: "Daha fazla paylaşılabilir içerik üret.",
    Statistics_NonFollowerViews_neutral_action3: "İlgili sayfalarla kısa bir iş birliği yap.",
    Statistics_NonFollowerViews_neutral_urgency: "Düşük",

    Statistics_NonFollowerViews_down_title: "Takipçi Olmayan Görüntülemeler Azaldı 💡İş Birliği ve Tanıtım Gerek",
    Statistics_NonFollowerViews_down_summary:
      "Explore erişimi düştü; iş birliği veya küçük bir tanıtımla trafiği geri getir.",
    Statistics_NonFollowerViews_down_action1: "İlgili bir sayfa ile hızlı bir iş birliği ayarla.",
    Statistics_NonFollowerViews_down_action2:
      "Daha fazla paylaşılabilir içerik üret ve destekleyici bir gönderi paylaş.",
    Statistics_NonFollowerViews_down_action3: "Trafiği geri getirmek için küçük ve hedefli bir reklam çalıştır.",
    Statistics_NonFollowerViews_down_urgency: "Yüksek",

    Statistics_NonFollowerViews_zero_title: "Takipçi Olmayan Görüntülemeler Sıfır 💡Explore için sinyal oluştur",
    Statistics_NonFollowerViews_zero_summary: "İlk trafiği almak için trend Reels ve iş birliği en iyi başlangıçtır.",
    Statistics_NonFollowerViews_zero_action1: "3 trend odaklı Reels üret.",
    Statistics_NonFollowerViews_zero_action2: "İlk trafiği oluşturmak için destekleyici bir gönderi paylaş.",
    Statistics_NonFollowerViews_zero_action3: "İlgili bir sayfa ile hızlı bir iş birliği başlat.",
    Statistics_NonFollowerViews_zero_urgency: "Yüksek",

    Statistics_Shares_up_title: "Paylaşımlar Yükseldi 💡İçeriğin Paylaşmaya Değer",
    Statistics_Shares_up_summary: "İnsanlar gönderilerini paylaşıyor; içerik hemen değerli ve dönüşüm sağlayabilir.",
    Statistics_Shares_up_action1: "Paylaşım geri bildirimlerini analiz et ve desenleri belirle.",
    Statistics_Shares_up_action2: "Başlığa net bir paylaşım sebebi ekle ('Arkadaşına gönder').",
    Statistics_Shares_up_action3: "Paylaşılabilir bir eğitim serisi tasarla.",
    Statistics_Shares_up_urgency: "Orta",

    Statistics_Shares_neutral_title: "Paylaşımlar Az veya Sabit 💡Sadece Basit Bir Tetikleyici Gerek",
    Statistics_Shares_neutral_summary: "Bazen kısa bir CTA paylaşımı artırmak için yeterlidir.",
    Statistics_Shares_neutral_action1: "Gönderinin sonunda çok kısa bir paylaşım CTA'sı ekle.",
    Statistics_Shares_neutral_action2: "Daha fazla kaydedilebilir ve paylaşılabilir içerik üret.",
    Statistics_Shares_neutral_action3: "'Arkadaşına gönder' test şablonu uygula.",
    Statistics_Shares_neutral_urgency: "Düşük",

    Statistics_Shares_down_title: "Paylaşımlar Azaldı 💡Daha Pratik İçerik Gerek",
    Statistics_Shares_down_summary:
      "İçerik artık daha az paylaşılabilir; insanların başkalarına göndermek isteyeceği bir şey üret.",
    Statistics_Shares_down_action1: "Kontrol listeleri veya adım adım içerik tasarla.",
    Statistics_Shares_down_action2: "Kısa ve öz eğitimler paylaş.",
    Statistics_Shares_down_action3: "Paylaşım için net bir CTA ekle.",
    Statistics_Shares_down_urgency: "Yüksek",

    Statistics_Shares_zero_title: "Hiç Paylaşım Yok 💡Başlangıç Noktası Oluştur",
    Statistics_Shares_zero_summary: "Ya veri yok ya da içerik paylaşılabilir değil; hızlı bir dağıtım planı oluştur.",
    Statistics_Shares_zero_action1: "Birkaç 5 ipucu veya kontrol listesi içerik üret.",
    Statistics_Shares_zero_action2: "İlk sinyali almak için küçük bir destek uygula.",
    Statistics_Shares_zero_action3: "Başlıkta paylaşmak için net bir neden yaz.",
    Statistics_Shares_zero_urgency: "Yüksek",

    Statistics_Engagement_up_title: "Etkileşim Artıyor 💡Formülü Sabitle",
    Statistics_Engagement_up_summary: "Kazanılmış bir desen buldun; şimdi bunu tekrar et ve büyüt.",
    Statistics_Engagement_up_action1: "Başarılı formatları ve zamanlamaları dikkatle kaydet.",
    Statistics_Engagement_up_action2: "Etkileşim sağlayan formatları içerik takvimine ekle.",
    Statistics_Engagement_up_action3: "Haftalık olarak yeni bir tutma odaklı format test et.",
    Statistics_Engagement_up_urgency: "Orta",

    Statistics_Engagement_neutral_title: "Etkileşim Ortalama 💡Yeni Bir Tetikleyici Gerek",
    Statistics_Engagement_neutral_summary:
      "Büyümek için yeni tetikleyiciler ekle; sorular, meydan okumalar veya yorum davetleri gibi.",
    Statistics_Engagement_neutral_action1: "Haftada bir yorum davet postu paylaş.",
    Statistics_Engagement_neutral_action2: "Etkileşimleri yönlendir ve farklı formatların sonuçlarını karşılaştır.",
    Statistics_Engagement_neutral_action3: "Hızlı etkileşim için birkaç şablon tasarla.",
    Statistics_Engagement_neutral_urgency: "Düşük",

    Statistics_Engagement_down_title: "Etkileşim Düşüyor 💡Hızlı Yeniden Tasarım Gerekli",
    Statistics_Engagement_down_summary: "Yeni testler hemen başlatılmalı; 14 günlük plan en iyi başlangıçtır.",
    Statistics_Engagement_down_action1: "3 farklı formatla 14 günlük planı uygula.",
    Statistics_Engagement_down_action2: "Verileri her gün kaydet ve hızlıca pivot yap.",
    Statistics_Engagement_down_action3: "İzleyiciden doğrudan hangi içeriğin ilgilerini çektiğini sor.",
    Statistics_Engagement_down_urgency: "Yüksek",

    Statistics_Engagement_zero_title: "Sıfır Etkileşim 💡7 Günlük Yoğun Plan Gerek",
    Statistics_Engagement_zero_summary:
      "Etkileşim sinyallerini hızlıca oluşturmalısın; günlük etkileşimli içerik paylaş ve verileri takip et.",
    Statistics_Engagement_zero_action1: "Anketler, açık sorular ve küçük meydan okumalar paylaş.",
    Statistics_Engagement_zero_action2: "Her formatı 3 gün boyunca test et.",
    Statistics_Engagement_zero_action3: "Yorumlara ve mesajlara hızlı yanıt ver.",
    Statistics_Engagement_zero_urgency: "Yüksek",

    Statistics_Replies_up_title: "Story Yanıtları Yüksek 💡Bunları İçeriğe Dönüştür",
    Statistics_Replies_up_summary: "Takipçilerin yazıyor; etkileşim istiyorlar. Bu, içerik için fırsat.",
    Statistics_Replies_up_action_1: "En iyi 3 yanıtı seç ve post veya Reel’e dönüştür.",
    Statistics_Replies_up_action_2: "En sık verilen cevaplarla bir Q&A veya FAQ oluştur.",
    Statistics_Replies_up_action_3: "Bir sonraki story’de birkaç yanıtı göstererek diğerlerini motive et.",
    Statistics_Replies_up_urgency: "Orta",

    Statistics_Replies_neutral_title: "Yanıtlar Az 💡Tetikleyici Ekle",
    Statistics_Replies_neutral_summary: "Bazen sadece basit bir soru daha fazla yanıt almak için yeterlidir.",
    Statistics_Replies_neutral_action_1: "Soru sticker’ı, anket veya Quiz ekle.",
    Statistics_Replies_neutral_action_2: "Kısa ve ilgi çekici sorular sor.",
    Statistics_Replies_neutral_action_3: "Yanıtlara hızlı tepki ver, etkileşimi artır.",
    Statistics_Replies_neutral_urgency: "Düşük",

    Statistics_Replies_down_title: "Yanıtlar Düşüyor 💡Samimiyeti Artır",
    Statistics_Replies_down_summary: "Takipçi uzaklaşmış gibi görünüyor; daha kişisel içeriklerle tekrar yakınlaş.",
    Statistics_Replies_down_action_1: "Birkaç kişisel, deneyim odaklı veya duygusal story paylaş.",
    Statistics_Replies_down_action_2: "Cevap vermesi kişisel deneyim gerektiren sorular sor.",
    Statistics_Replies_down_action_3: "İlk cevaplara mutlaka önem ver ve tepki veya yanıt ver.",
    Statistics_Replies_down_urgency: "Yüksek",

    Statistics_Replies_zero_title: "Sıfır Yanıt 💡Doğrudan Davet Gerekli",
    Statistics_Replies_zero_summary: "Hiç cevap yoksa, cazip ve doğrudan sorular sor.",
    Statistics_Replies_zero_action_1: "Çok basit ve ilgi çekici sorular paylaş (ör. iki seçenek arasında seçim).",
    Statistics_Replies_zero_action_2: "Aldığın cevapları öne çıkar ki diğerleri teşvik olsun.",
    Statistics_Replies_zero_action_3: "Her gün hafif etkileşimli bir story uygula.",
    Statistics_Replies_zero_urgency: "Yüksek",

    Statistics_TotalTime_up_title: "İzlenme Süresi Arttı 💡Daha Derin İçerik Ver",
    Statistics_TotalTime_up_summary: "İzleyici zaman harcıyor; bölümlü ve uzun içeriklere hazır.",
    Statistics_TotalTime_up_action_1: "Giriş/orta/son yapılandırmalı daha uzun videolar oluştur.",
    Statistics_TotalTime_up_action_2: "Ek içerik linklerini biyoya veya highlight’a ekle.",
    Statistics_TotalTime_up_action_3: "Videoyu net şekilde bölümlendir, izlenmeyi artır.",
    Statistics_TotalTime_up_urgency: "Orta",

    Statistics_TotalTime_neutral_title: "İzlenme Süresi Normal 💡Yapıyı Güçlendir",
    Statistics_TotalTime_neutral_summary: "İzleyici kalıyor ama tam olarak bağlanmıyor; yapıyı geliştir.",
    Statistics_TotalTime_neutral_action_1: "Videolar için üç katmanlı yapı uygula.",
    Statistics_TotalTime_neutral_action_2: "Önemli noktaları vurgula, izleyiciler ne izleyeceklerini bilsin.",
    Statistics_TotalTime_neutral_action_3: "Test ve karşılaştırma için özet bir versiyon oluştur.",
    Statistics_TotalTime_neutral_urgency: "Düşük",

    Statistics_TotalTime_down_title: "İzlenme Süresi Düştü 💡İlk Çekim Zayıf",
    Statistics_TotalTime_down_summary: "İlk 3 saniye güçlü olmalı; daha hızlı, çarpıcı ve etkileyici yap.",
    Statistics_TotalTime_down_action_1: "İlk 3 saniyeyi yeniden yaz ve birkaç versiyonunu test et.",
    Statistics_TotalTime_down_action_2: "15–30 saniyelik çok kısa versiyonlar oluştur.",
    Statistics_TotalTime_down_action_3: "Düzenleme ritmi, kesmeler ve müziği keskinleştir.",
    Statistics_TotalTime_down_urgency: "Yüksek",

    Statistics_TotalTime_zero_title: "İzlenme Süresi Sıfır 💡Henüz Yayınlamadın mı?",
    Statistics_TotalTime_zero_summary: "Video varsa ama süre kaydedilmemişse, önce teknik sorunları kontrol et.",
    Statistics_TotalTime_zero_action_1: "İçeriğin gerçekten yayınlandığından emin ol.",
    Statistics_TotalTime_zero_action_2: "Yayınlanmadıysa, arka arkaya 3 kısa reel paylaş.",
    Statistics_TotalTime_zero_action_3: "Veri toplamak için boost veya ilk gösterim uygula.",
    Statistics_TotalTime_zero_urgency: "Yüksek",

    Statistics_ReachMonth_up_title: "Aylık Erişim Arttı 💡Modelleri Kilitle",
    Statistics_ReachMonth_up_summary: "Başarılı aylar belli; modelleri not edin ve gelecek ay için plan yapın.",
    Statistics_ReachMonth_up_action_1: "Yüksek performanslı ayları analiz edin ve modelleri kaydedin.",
    Statistics_ReachMonth_up_action_2: "İçerik takvimini bu modellerle güncelleyin.",
    Statistics_ReachMonth_up_action_3: "Kazanmış formatları gelecek ay tekrar yayınlayın.",
    Statistics_ReachMonth_up_urgency: "Orta",

    Statistics_ReachMonth_neutral_title: "Aylık Erişim Sabit 💡Test ve Büyüme Zamanı",
    Statistics_ReachMonth_neutral_summary: "Aylık erişimi artırmak için kısa bir kampanya veya sınırlı reklam yapın.",
    Statistics_ReachMonth_neutral_action_1: "Ortak bir kampanya veya sınırlı reklam başlatın.",
    Statistics_ReachMonth_neutral_action_2: "Sonuçları kaydedin, karşılaştırın ve optimize edin.",
    Statistics_ReachMonth_neutral_action_3: "Önceki başarılı postları tekrar güçlendirin.",
    Statistics_ReachMonth_neutral_urgency: "Düşük",

    Statistics_ReachMonth_down_title: "Aylık Reach Düşüşte 💡İçeriği Yeniden Yarat",
    Statistics_ReachMonth_down_summary:
      "Reach’i geri getirmek için ana gönderileri yeniden paylaş veya yeniden oluştur.",
    Statistics_ReachMonth_down_action_1: "Ana gönderileri yeniden paylaş veya yeniden oluştur.",
    Statistics_ReachMonth_down_action_2: "14 günlük içerik üretimi ve tanıtım kampanyası başlat.",
    Statistics_ReachMonth_down_action_3: "Hashtag’leri ve etiketleri tekrar gözden geçir.",
    Statistics_ReachMonth_down_urgency: "Yüksek",

    Statistics_ReachMonth_zero_title: "Aylık Reach Sıfır 💡Önce Veriyi Kontrol Et",
    Statistics_ReachMonth_zero_summary:
      "Veri yok veya eksik; önce teknik sorunları kontrol et, sonra 14 günlük plan uygula.",
    Statistics_ReachMonth_zero_action_1: "Veri bağlantılarını ve kayıtları kontrol et.",
    Statistics_ReachMonth_zero_action_2: "14 günlük içerik üretim planını uygula.",
    Statistics_ReachMonth_zero_action_3: "Günlük sonuçları takip et.",
    Statistics_ReachMonth_zero_urgency: "Yüksek",

    Statistics_MonthEngagement_up_title: "Aylık Etkileşim Artıyor 💡Ölçekle",
    Statistics_MonthEngagement_up_summary: "Pozitif aylık desenleri kaydedin ve tekrarlayın.",
    Statistics_MonthEngagement_up_action_1: "Başarılı şablonları ve formatları belgeleyin.",
    Statistics_MonthEngagement_up_action_2: "Gelecek ay için net KPI ve planlar belirleyin.",
    Statistics_MonthEngagement_up_action_3: "Etkileşimi artırmak için küçük haftalık testler yapın.",
    Statistics_MonthEngagement_up_urgency: "Orta",

    Statistics_MonthEngagement_neutral_title: "Aylık Etkileşim Normal 💡Zorluk Unsuru Ekleyin",
    Statistics_MonthEngagement_neutral_summary: "Haftalık bir meydan okuma veya soru etkileşimi artırabilir.",
    Statistics_MonthEngagement_neutral_action_1: "Her hafta bir meydan okuma veya soru odaklı içerik yayınlayın.",
    Statistics_MonthEngagement_neutral_action_2: "Sonuçları kaydedin ve karşılaştırın.",
    Statistics_MonthEngagement_neutral_action_3: "Haftalık bir etkileşim serisi oluşturun.",
    Statistics_MonthEngagement_neutral_urgency: "Düşük",

    Statistics_MonthEngagement_down_title: "Aylık Etkileşim Düşüşte 💡14 Günlük Plan Başlat",
    Statistics_MonthEngagement_down_summary: "Formatları gözden geçirin ve 14 günlük bir plan uygulayın.",
    Statistics_MonthEngagement_down_action_1: "3 farklı formatla 14 günlük planı uygulayın.",
    Statistics_MonthEngagement_down_action_2: "Sonuçları günlük analiz edin.",
    Statistics_MonthEngagement_down_action_3: "Doğrudan geri bildirim toplayın.",
    Statistics_MonthEngagement_down_urgency: "Yüksek",

    Statistics_MonthEngagement_zero_title: "Aylık Etkileşim Sıfır 💡Acil 7 Günlük Program",
    Statistics_MonthEngagement_zero_summary: "7 hızlı etkileşimli post yayınlayın ve günlük takip edin.",
    Statistics_MonthEngagement_zero_action_1: "7 etkileşimli post oluşturun.",
    Statistics_MonthEngagement_zero_action_2: "Sonuçları günlük kontrol edin.",
    Statistics_MonthEngagement_zero_action_3: "Takipçilerle DM ve yorumlar üzerinden etkileşim kurun.",
    Statistics_MonthEngagement_zero_urgency: "Yüksek",

    Statistics_MonthView_up_title: "Aylık Görüntüleme Arttı 💡Yapıyı Kilitle",
    Statistics_MonthView_up_summary: "Video stratejisi işe yarıyor; bu formatları düzenli olarak yayınlayın.",
    Statistics_MonthView_up_action_1: "Video stratejinizi belgeleyin.",
    Statistics_MonthView_up_action_2: "Düzenli üretimi standart bir formata dönüştürün.",
    Statistics_MonthView_up_action_3: "Aylık temel metrikleri inceleyin ve kaydedin.",
    Statistics_MonthView_up_urgency: "Orta",

    Statistics_MonthView_neutral_title: "Aylık Görüntüleme Sabit 💡Format Karışımı Deneyin",
    Statistics_MonthView_neutral_summary: "Reels ve Stories karışımı yeni trafik kanalları yaratabilir.",
    Statistics_MonthView_neutral_action_1: "Karışık Reels+Stories içerik oluşturun.",
    Statistics_MonthView_neutral_action_2: "Performansı kaydedin ve karşılaştırın.",
    Statistics_MonthView_neutral_action_3: "Videoya yönlendiren altyazılar ekleyin.",
    Statistics_MonthView_neutral_urgency: "Düşük",

    Statistics_MonthView_down_title: "Aylık Görüntülemeler Düşüyor 💡Reels’e Odaklan",
    Statistics_MonthView_down_summary:
      "Kısa Reels ve dikkat çekici kapaklar, görüntülemeleri geri kazanmanın en hızlı yoludur.",
    Statistics_MonthView_down_action_1: "15–30 saniyelik Reels oluşturun.",
    Statistics_MonthView_down_action_2: "Çekici kapaklar tasarlayın.",
    Statistics_MonthView_down_action_3: "Zamanlama testleri yapın.",
    Statistics_MonthView_down_urgency: "Yüksek",

    Statistics_MonthView_zero_title: "Aylık Görüntüleme Sıfır 💡Önce Teknik Kontrol",
    Statistics_MonthView_zero_summary:
      "Veriler veya yayınlamada sorun olabilir; önce teknik kontrol edin, sonra 14 günlük plan başlatın.",
    Statistics_MonthView_zero_action_1: "Video verilerini teknik olarak kontrol edin.",
    Statistics_MonthView_zero_action_2: "14 günlük içerik üretim planı başlatın.",
    Statistics_MonthView_zero_action_3: "Sonuçları günlük izleyin.",
    Statistics_MonthView_zero_urgency: "Yüksek",
    Statistics_RePosts_up_title: "Repost’lar Artıyor 💡 Bunu Kullanın",
    Statistics_RePosts_up_summary:
      "Kitleniz post’larınızı paylaşıyor; bu da içeriğinizin paylaşmaya değer olduğunu gösterir.",
    Statistics_RePosts_up_action_1: 'Caption’da repost için net bir neden ekleyin ("Bir arkadaşına gönder").',
    Statistics_RePosts_up_action_2: "Paylaşılabilir bir eğitim serisi tasarlayın.",
    Statistics_RePosts_up_action_3: "Repost geri bildirimlerini analiz edin ve kalıpları bulun.",
    Statistics_RePosts_up_urgency: "Orta",
    Statistics_RePosts_neutral_title: "Repost’lar Düşük ya da Sabit 💡 Sadece Basit Bir Tetikleyici Gerek",
    Statistics_RePosts_neutral_summary: "Bazen kısa bir CTA, repost’ları artırmak için yeterlidir.",
    Statistics_RePosts_neutral_action_1: "Post’un sonuna çok kısa bir repost CTA’sı ekleyin.",
    Statistics_RePosts_neutral_action_2: "Kaydedilebilir ve gönderilebilir içerik daha fazla üretin.",
    Statistics_RePosts_neutral_action_3: "“Bir arkadaşına gönder” gibi test formatı uygulayın.",
    Statistics_RePosts_neutral_urgency: "Düşük",
    Statistics_RePosts_down_title: "Repost’lar Azaldı 💡 Daha Kullanışlı İçerik Gerekli",
    Statistics_RePosts_down_summary:
      "İçerik daha az paylaşılır hale geldi; insanların başkalarına göndermek isteyeceği şeyler üretmelisiniz.",
    Statistics_RePosts_down_action_1: "Checklist veya adım adım içerik tasarlayın.",
    Statistics_RePosts_down_action_2: "Kısa ve öz eğitimler yayınlayın.",
    Statistics_RePosts_down_action_3: "Repost için net bir CTA ekleyin.",
    Statistics_RePosts_down_urgency: "Yüksek",
    Statistics_RePosts_zero_title: "Hiç Repost Yok 💡 Bir Başlangıç Noktası Oluşturmalısınız",
    Statistics_RePosts_zero_summary:
      "Ya veri yok ya da içerik repost’a uygun değil; hızlıca bir dağıtım planı oluşturun.",
    Statistics_RePosts_zero_action_1: "5 maddelik veya checklist formatında birkaç içerik üretin.",
    Statistics_RePosts_zero_action_2: "İlk sinyali almak için küçük bir boost uygulayın.",
    Statistics_RePosts_zero_action_3: "Caption’da repost için net bir neden yazın.",
    Statistics_RePosts_zero_urgency: "Yüksek",

    // statistics suggestions box

    // 4️⃣ Page -> tools
    pageTools_hashtags: "Hashtag'ler",
    pageTools_MyList: "Hashtag Listesi",
    pageTools_CreateNewListexplain: "# listenizi oluşturun ve gönderiler oluşturmak için kullanın",
    Analyzer: "Analiz Aracı (AI)",
    pageTools_CreateNewList: "Yeni Liste Oluştur",
    pageTools_CustomFont: "Özel Yazı Tipi",
    pageTools_CustomFontExplain: "Instagram gönderileriniz için özel yazı tipleri kullanın!",
    pageToolspopup_CreateNewListexplain:
      "<Enter> veya <Space> tuşuna basarak yeni bir hashtag oluşturabilirsiniz. Bir hashtagi silmek için üzerine tıklayın.",
    pageToolspopup_Listname: "Liste Adı",
    pageToolspopup_hashtags: "Hashtag'ler",
    pageToolspopup_typehere: "Buraya yazın",
    pageTools_hashtagList: "Hashtag Listesi",
    pageTools_CreateNewListpic: "Yeni resim analizcisi",
    pageTools_CreateNewListpicexplain: "Resim ile ilgili etiketleri oluştur",
    pageTools_CreateNewListpage: "Yeni sayfa analizcisi",
    pageTools_CreateNewListpageexplain: "Instagram sayfa URL’si ile ilgili etiketleri oluştur",
    pageToolspopup_pageURL: "Instagram ID",
    pageToolspopup_HideLikeandViewCounts: "Beğeni ve Görüntüleme Sayılarını Gizle",
    pageToolspopup_TurnoffCommenting: "Yorum Yapmayı Kapat",
    pageToolspopup_TurnoffCommentingExplain: "Bu gönderi için yorum yapma devre dışı bırakılacaktır",
    pageToolspopup_TurnoffCommentingexplainforlottery:
      "Bu Post için yorum yapma, Lottery gerçekleştiği sırada devre dışı bırakılacak",

    pageToolspopup_TopHashtag: "En Popüler Hashtag",
    pageToolspopup_TopHashtagexplain: "Bu, bu hashtag'i sayfada kaç kez kullandığınızdır.",
    pageToolspopup_allRepliedcomments: "Tüm Yanıtlanan Yorumlar",
    noresult: "Sonuç Yok",
    viewreplies: "Yanıtları Görüntüle",
    allRepliedcomments: "Tüm Yanıtlanan Yorumlar",
    Followers: "Takipçiler",
    NonFollowers: "Takip etmeyenler",
    pageToolspopup_ViewersLikes: "İzleyiciler ve Beğeniler",
    supportedformat: "Desteklenen Format",
    limitsize: "Boyut Limiti",
    TagMention: "Etiket ve Bahsetme",
    cover: "Kapak",
    Pleaseselect: "Lütfen seçiniz",
    replace: "Değiştir",
    Album: "Albüm",
    SavedHashtagList: "Kaydedilmiş Hashtag Listesi",
    SavedHashtagListexplain: "Başlığın sonuna eklemek için hashtag seçin",
    FirstComment: "İlk Yorum",
    PinFirstComment: "İlk Yorumu Sabitle",
    areyousure: "Emin misiniz!?",
    shouldFollower: "Kullanıcının sayfayı takip etmesi gerekmektedir",
    draftexplain: "Taslak olarak kaydetmeye çalışıyorsunuz",
    deletedraftexplain: "Taslağı silmeye çalışıyorsunuz",
    deleteorderexplain: "Bir siparişi silmeye çalışıyorsunuz",

    Addpeopleexplain: "*İnsanları etiketledikten sonra, etiketi ayarlayın veya kaldırmak için çift tıklayın",
    AdvanceSettings: "Gelişmiş Ayarlar",
    sharepreviewtofeed: "Önizlemeyi Akışa Paylaş",
    Videocopyrightbypass: "Video telif hakkı baypas",
    SetScheduledPost: "Gönderiyi Zamanla",
    SetScheduledPostexplain: "Bu gönderi belirtilen zamanda yayınlanacaktır",
    SetScheduledStoryexplain: "Bu hikaye belirtilen zamanda yayınlanacaktır",
    addtoproduct: "Ürünlere Ekle",
    addtoproductexplain: "Bu gönderi, ürün listenize bir ürün olarak eklenecektir",
    TurnoffCommentingexplain: "Bu gönderi için yorum yapma devre dışı bırakılacaktır",
    RecommendedDateTime: "Önerilen Tarih ve Saat",
    RecommendedDateTimeexplain: "Bu zamanlar sayfanızın analizine dayanmaktadır",
    publish: "Yayınla",
    pageTools_global: "Küresel",
    pageTools_FA_AR: "Farsça / Arapça",
    pageTools_Overall: "Genel",
    pageTools_year: "Yıl",
    pageTools_Month: "Ay",
    pageTools_Week: "Hafta",
    pageTools_Day: "Gün",
    pageTools_hashtag: "Hashtag",
    pageTools_USED: "Kullanıldı",
    pageTools_SearchedHashtag: "Aranan Hashtag",
    pageTools_TrendHashtags: "Trend Hashtag'ler",
    pageTools_AutoInterAction: "Takipçilerle Oto Etkileşim",
    pageTools_AcceptPendingRequests: "Takip Taleplerini Otomatik Olarak Kabul Et",
    pageTools_LikeAllNewComments: "Yeni Yorumları Beğen",
    pageTools_LikeNewFollowersPosts: "Yeni Takipçilerin Son Paylaşımlarını Beğen",
    pageTools_RemoveAllFollowings: "Tüm Takip Edilenleri Kaldır",
    pageTools_WinnerPicker: "Çekiliş (Kazanan Seçici)",
    pageTools_DayEvents: "Günün Etkinlikleri",
    pageTools_EventDateRange: "Tarih Aralığı",
    pageTools_EventLanguage: "Dil",
    pageTools_EventSelectDate: "Tarih Aralığı Seç",
    pageTools_EventSearch: "Etkinlikleri Ara",
    pageTools_EventEmpty: "Seçilen aralık için etkinlik bulunamadı",
    pageTools_EventReligious: "Dini",
    pageTools_EventIdeas: "Etkinlik Fikirleri",
    pageTools_IdeaCreate: "Etkinlik Fikirleri Oluştur",
    pageTools_IdeaExplain: "Yaklaşan etkinliklere dayalı yapay zeka destekli içerik fikirleri alın",
    pageTools_CreateEventIdea: "Etkinlik Fikirleri Oluştur",
    pageTools_CreateEventIdeaPrompt: "Konu / Komut",
    pageTools_CreateEventIdeaPromptPlaceholder: "örn. ayakkabı, fitness, seyahat... (tüm konular için boş bırakın)",
    pageTools_CreateEventIdeaOptional: "isteğe bağlı",
    pageTools_CreateEventIdeaSubmit: "Oluştur",
    pageTools_CreateEventIdeaCancel: "İptal",
    pageTools_EventIdeasLanguage: "Dil",
    pageTools_EventIdeasFetch: "Fikirleri Yükle",
    pageTools_EventIdeasEmpty: "Etkinlik fikri bulunamadı",
    pageTools_EventIdeasLoadMore: "Daha Fazla",
    pageTools_EventIdeasIdea: "Fikir",
    pageTools_EventIdeasCountry: "Ülke",
    pageTools_EventIdeasPrompt: "Konu",
    pageTools_EventIdeasCreatedTime: "Oluşturulma Tarihi",
    pageTools_CustomEvent: "Özel Etkinlik",
    pageTools_exportcomments:
      "Tüm comment’ler Excel dosyası olarak dışa aktarılır ve indirilebilir veya paylaşılabilir",

    papageTools_Lottery: "Puan Çekilişi Oluştur",
    pageTools_emptylotteryList: "Henüz herhangi bir çekiliş oluşturmadınız",

    pageTools_LotteryExplain: "Bir paylaşımda kullanıcı puanlarına dayalı",
    pageTools_fromFollowers: "Takipçilerden",
    pageTools_FromFollowersExplain: "Tüm takipçiler arasından rastgele",
    pageTools_Result: "Sonuç",
    pageTools_ResultExplain: "Önceki çekilişin durumu",
    pageTools_popup_detail: "Detay",
    pageTools_popup_history: "Geçmiş",
    pageTools_LikeAllNewCommentsExplain:
      "Bir takipçiniz herhangi bir gönderide yorum yaptığında, bu yorum otomatik olarak beğenilecektir.",
    pageTools_AcceptType: "Etkinleştirme Türü",
    pageTools_popup_AlwaysActive: "Her Zaman Aktif",
    pageTools_popup_JustOnce: "Sadece Bir Defa",
    pageTools_AcceptPendingRequestsexplain: "Bireylerden gelen tüm follow taleplerini otomatik olarak kabul edin.",
    pageTools_onlyprivate: "*Sadece özel sayfalarla çalışır.",
    pageTools_MaxLike: "Beğenilecek gönderi sayısı",
    pageTools_Reacceptfollower: "Takip Bıraktıktan Sonra Yeniden Takip",
    pageTools_Reacceptfollowerexplain:
      "Eğer biri daha önce sizi takip etti, ardından takibi bıraktı ve tekrar takip talebinde bulunduysa, sistem kabul eder.",
    waitday: "Bekleme Süresi",
    waitdayexplain:
      "Eğer bir kişi sizin veya sistemin takibine alınırsa, belirlenen bekleme süresinden sonra kaldırılacaktır.",
    waitdayexplain2: "Bekleme sayısı gün cinsindendir. Bu sayı 0 ise, işlem anında gerçekleştirilecektir.",
    pageTools_LikeNewFollowersPostsexplain:
      "Yeni biri sizi takip ettiğinde, son gönderisi otomatik olarak beğenilecektir.",
    pageTools_RemoveAllFollowingsexplain: "Bu seçenek, sayfanızdan tüm takipçilerinizi otomatik olarak kaldırır.",
    pageTools_progress: "Bu işlem, takipçilerinizin sayısına bağlı olarak birkaç gün sürebilir.",
    pageTools_JustUnfollowwho: "Beni geri takip etmeyenleri sadece Unfollow et",
    pageTools_AllmyFollowings: "Tüm Takip Ettiklerim",
    pageTools_pageanAnalyzer: "Sayfa Analizörü",
    pageTools_pictureanAnalyzer: "Resim Analizörü",
    pageTools_StartAnalysis: "Analize Başla",
    pageLottery_Step: "Adım",
    pageLottery_Specifications: "Özellikler",
    pageLottery_SelectaPost: "Bir Post Seçin",
    pageLottery_SetDateTime: "Tarih ve Saati Ayarlayın",
    pageLottery_WinnersTasks: "Kazananların Görevleri",
    pageLottery_WinnersTasksexplain: "Katılımcıların çekilişe katılmak için tamamlaması gereken görevler.",
    pageLottery_NumberofWinners: "Kazananların Sayısı",
    pageLottery_SetScoreForLottery: "Kişileri Etiketle",
    pageLottery_SetScoreForLotteryexplain: "Kullanıcılar, Çekilişe katılmak için başkalarını etiketlemelidir",

    pageLottery_MinimumMention: "Minimum Bahsetme",
    pageLottery_MinimumMentionexplain: "Bahsedilmesi gereken kişi sayısı",
    pageLottery_FollowedPage: "Takip Edilen Sayfa",
    pageLottery_FollowedPageexplain:
      "Kişiler, çekilişe katılmak için sizin sayfanızı ve/veya seçtiğiniz sayfaları takip etmelidir.",
    pageLottery_FollowmyPage: "Sayfamı Takip Et",
    pageLottery_FollowalternativePages: "Alternatif Sayfaları Takip Et",
    pageLottery_Termsconditions: "Şartlar ve koşullar",
    pageLottery_publishTermsconditions: "Şartlar ve koşulları yayımla",
    pageLottery_previewTermsconditionsexplain: "Bu hikaye, katılımcılara hikaye olarak gösterilecektir.",
    pageLottery_Termsconditionsbanner: "Şartlar ve koşullar afişi",
    pageLottery_Termsconditionsbannerexplain:
      "Kazananı duyurmak için takipçilerinize şartlar ve koşulları bildiren bir afiş seçin.",
    pageLottery_model: "Model",
    pageLottery_Solid: "Katı",
    pageLottery_Radial: "Radyal",
    pageLottery_Linear: "Doğrusal",
    pageLottery_Background: "Arka Plan",
    pageLottery_Color: "Renk",
    pageLottery_Position: "Pozisyon",
    pageLottery_Degree: "Derece",
    pageLottery_TextBox: "Metin Kutusu",
    pageLottery_Opacity: "Opaklık",
    pageLottery_Blur: "Bulanıklık",
    pageLottery_Font: "Yazı Tipi",
    pageLottery_Winnerannouncement: "Kazanan duyurusu",
    pageLottery_participants1: "🎉 999,999 katılımcıdan 🎉",
    pageLottery_participants2: "🥳 işte şanslı olanlar: 🥳",
    pageLottery_participantsexplain:
      "*Sistem, katılımcıların ve kazananların sayısını otomatik olarak ayarlar ve her @ karakterinden sonra kimliklerini atar.",
    pageLottery_Addtocaption: "Çekiliş tamamlandıktan sonra başlığa ekle",
    pageLottery_Publishasstory: "Kazananlar listesini story olarak yayınla",
    pageLottery_deleteexplain: "Bu işlem, çekilişi kalıcı olarak silecek ve geri alınamaz.",
    pageLottery_Winnerpickersstatus: "Çekiliş durumu",
    pageLottery_scoreLotteryWinners: "Çekiliş Kazananları",
    pageLottery_NoWinners: "Kazanan bulunamadı",
    pageLottery_RandomFollowersWinners: "Rastgele Takipçi Kazananlar",
    pageLottery_specifickeywordexplain:
      "Kullanıcılar, Lottery'e katılmak için yorumlarında belirli bir anahtar kelime yazmalıdır",
    pageLottery_FollowmyPageexplain: "Kullanıcılar, Lottery'e katılmak için sayfayı Follow etmelidir",

    pageLottery_ShareRemainingTime: "Kalan Süreyi Paylaş",
    ShareTermsAndCondition: "Şartlar ve Koşulları Paylaş",
    pageLottery_LotteryRemainingTime: "Çekiliş Kalan Süresi",
    pageLottery_Winnerpickerisrunning: "Çekiliş çalışıyor",
    pageLottery_ViewandEditDetails: "Detayları Görüntüle ve Düzenle",
    pageLottery_ActiveWinnerpickers: "Aktif Çekiliş",
    pageTools_WinnerPickertooltip24hour: "Çekiliş her 24 saatte bir yapılabilir",
    specifickeywordstooltip: "Sistem otomatik olarak emojileri ve Farsça, Arapça ve İngilizce rakamları algılar",
    pageLottery_FilterKeywords: "Sistem, belirttiğiniz anahtar kelimeyi içeren yorumları rastgele seçer ve görüntüler",
    pageLottery_NumberofWinnersexplain: "Çekiliş kazananlarının sayısını belirleyin. Maksimum kazanan sayısı 100’dür",
    pageLottery_permanentlinktooltip:
      "Bu bağlantı kalıcıdır, ancak yeni bir çekiliş yapıldığında önceki bağlantı silinir",
    pageLottery_permanentlinkexplain:
      "Çekilişin güvenilirliğini ve orijinalliğini doğrulamak için bu bağlantıyı kullanıcılarla paylaşabilirsiniz",
    pageTools_randomly: "Rastgele",
    pageTools_BestEngagement: "En İyi Etkileşim",
    pageTools_BestEngagementexplain: "En çok beğeni ve yorum alan takipçilerden seçin",
    // #endregion page Section
    // #region 3️⃣ Message Section
    message_youareattemptingto: "Şu işlemi gerçekleştirmeye çalışıyorsunuz:",
    message_blockexplain:
      "Instagram'da profilinizi, postlarınızı veya hikayenizi bulamayacaklar. Instagram, onları engellediğinizi bildirmeyecek.",
    message_deleteexplain: "Bu sohbet kalıcı olarak silinecek ve geri alınamaz.",
    message_block: "Engelle",
    notactivemessage:
      "Bu sohbet geçici olarak devre dışı bırakılmıştır. Lütfen yanıtınızı Instagram uygulaması üzerinden gönderin.",
    notactivemessageexplain:
      "Lütfen dikkat edin, eğer 24 saat içinde yanıt gönderilmezse sohbet erişilemez hale gelecektir. Yeniden etkinleştirmek için ya Instagram uygulaması üzerinden yanıt verebilir ya da karşı tarafın size yeni bir mesaj göndermesini bekleyebilirsiniz.",
    waitingforconnection: "Bağlantı bekleniyor...",
    message_unblock: "Engeli kaldır",
    messagesetting_goodbye: "Hoşça kal",
    messagesetting_welcome: "Hoş geldiniz",
    messagesetting_welcomingmessage: "karşılama mesajı",
    messagesetting_Activewelcomemessageexplain:
      "Bu mesaj, sizi takip eden kişilere Instagram Direct'te bir <Selamlama mesajı> olarak gönderilecektir.",
    messagesetting_Sentmessages: "Gönderilen mesaj",
    message: "mesaj",
    messagesetting_Activewelcomingmessage: "Hoşgeldiniz mesajı",
    receivedmessage: "Alınan mesaj",
    Messageresponse: "Mesaj Yanıtı",
    receivedcomment: "Alınan Yorum",
    commentresponse: "Yorum Yanıtı",
    Likethereceivedcomment: "Alınan Yorumu Beğen",
    unreadmessage: "Okunmamış Mesaj",
    specifickeywords: "Özel Kelimeler",
    unreadcomment: "Okunmamış Yorumlar",
    hiddencommenttooltip: "Bu yorum görünümden gizlenmiştir. Gizli yorumları yalnızca yöneticiler görebilir.",
    vanishmode: "Gizli Mod",
    vanishmodeexplain: "Gizli Mod’da yanıtlanmamış ve ne göz ardı edilmiş ne de gizlenmiş mesajlar gösterilecektir.",
    totalcomments: "Toplam Yorum",
    unansweredcomments: "Cevaplanmamış Yorumlar",
    totalcommenters: "Toplam Yorum Yapanlar",
    commentmanagement: "Yorum Yönetimine Hoş Geldiniz",
    ticketmanagement: "Müşteri Bilet Yönetim Bölümüne Hoş Geldiniz",
    flowmanagement: "Bir Flow oluşturun ve Instagram yanıtlarınızı akıllı ve otomatik hale getirin",

    QuickReplyexplain: "Tüm alınan yorumlar otomatik olarak yanıtlanır.",
    autocommentReply: "Otomatik Yorum Yanıtı",
    Sendresponseifthepageisfollowed: "Sayfa takip edildiyse yanıt gönder",
    Likethereceivedmessage: "Alınan mesajı beğen",
    messagesetting_welcometext:
      "Merhaba! 🌟\nDünyamıza hoş geldiniz! 🎉 Takipçilerimizden biri olduğunuz için çok mutluyuz. Birlikte harika anlar geçireceğimizden eminiz. 🤗\n\nBu sayfanın içeriğinin sizin için ilginç ve faydalı olacağını ve bizimle kalacağınızı umuyoruz. Sorularınız veya önerileriniz varsa, size yardımcı olmaktan memnuniyet duyarız. 😊\n\nSayfamızı seçtiğiniz ve bizimle olduğunuz için teşekkür ederiz. Sizi harika dünyamızda ağırlamak için sabırsızlanıyoruz.✨\n\nSaygı ve takdirlerle 💫",
    messagesetting_goodbyetext:
      "Merhaba! 👋\nSayfamızdan ayrıldığınızı görmekten üzüntü duyuyoruz. 😢 Her bir takipçimizi önemsiyoruz ve geri bildirimleriniz ve önerileriniz bizim için çok önemli.\n\nBu kararı almanızın belirli bir nedeni varsa, bunu bizimle paylaşırsanız memnun oluruz. Takipçilerimize daha iyi bir deneyim sunabilmek için düşüncelerinizi ve önerilerinizi dinlemeye hazırız. 🫡\n\nHer halükarda, size en iyi dileklerimizi sunuyoruz ve gelecekte tekrar bize katılmanızı umuyoruz. 💫",
    messagesetting_ActiveFarewellmessage: "Veda mesajı",
    messagesetting_ActiveFarewellmessageexplain:
      "Bu mesaj, sizi takip etmeyi bırakan kişilere Instagram Direct'te <Veda mesajı> olarak gönderilecektir.",
    messagesetting_businessmessagefilter: "İş Mesajı Filtresi",
    messagesetting_businessmessagefiltering: "İş Mesajları Filtreleme",
    messagesetting_businessmessagefilteringexplain:
      "İstenen sohbet, Direct Sekmesinde <İş mesajları> bölümüne otomatik olarak gönderilecektir.",
    messagesetting_specificwords: "özelleştirilmiş kelimeler",
    messagesetting_autofiltering: "otomatik filtreleme (AI)",
    messagesetting_selectedwords: "Seçilen Öğeler",
    autocommentReplyExplain: "Bir yorum veya mesaj alındığında, sistem otomatik olarak yanıt verir.",
    selectnewmessage: "Yanıt göndermek için lütfen bir mesaj seçin.",
    sendreplyticket: "Yanıtları Gönder",
    emptyticketdirect: "Sayfanızın Direct bölümünden müşteri talebi alınmadı",
    emptysystemticket: "Brancy sistem müşterilerinden herhangi bir talep alınmadı",
    emptycomment: "Henüz gösterilecek bir yorum yok",
    emptydirect: "Henüz gösterilecek bir Direct mesajı yok",

    respondToAllComments: "Tüm Yorumlara Yanıt Ver",
    sensitiveToSpecificKeywords: "Belirli Anahtar Kelimelere Duyarlı",
    sensitiveToSpecificKeywordsExplain:
      "Bu anahtar kelimeler yorum metninin herhangi bir yerinde bulunursa, sistem otomatik olarak yanıt verir",
    contain: "Anahtar kelimeyi içerir",
    containExplain:
      "Açıkken yorum anahtar kelimeyi içeriyorsa yanıt gönderilir. Kapalıyken yalnızca yorumun tamamı anahtar kelimeyle eşleşirse yanıt gönderilir.",
    replyMethod: "Yanıt Yöntemi",
    respondInSameComment: "Aynı Yorumda Yanıt Ver",
    respondDirectly: "Doğrudan Yanıt Ver",
    ticketID: "Bilet Kimliği",
    noNewAnsweredTickets: "Yeni yanıtlanmış bir destek talebiniz yok",
    noNewPendingTickets: "Yeni devam eden bir destek talebiniz yok",
    noNewClosedTickets: "Kapalı bir destek talebiniz yok",

    Ticketclosedby: "Bilet kapandı",
    waitingforuserresponse: "Kullanıcı yanıtı bekleniyor",
    inactiveticketexpired: "Bu bilet, son 24 saat içinde etkinlik olmadığı için devre dışı bırakıldı.",
    messagesetting_specificwordsexplain: "Birden fazla Kelime yazabilirsiniz, Her Kelimeyi <Enter> tuşu ile ayırın.",
    messagesetting_Createanewsupportticket: "Destek Bileti Oluştur",
    messagesetting_CreateanewsupportticketExplain:
      "Kullanıcılar, Direct içinde bir destek bileti oluşturmak için bu seçeneği kullanabilir. Siz de Brancy paneli üzerinden veya doğrudan Direct üzerinden yanıt verebilirsiniz.",
    messagesetting_Changeapplicationlanguage: "Direct Seçeneklerinin Dilini Değiştir",
    messagesetting_ChangeapplicationlanguageExplain:
      "Bu seçeneği etkinleştirerek, kullanıcılar Direct’in tüm özelliklerini yedi dilde (İngilizce, Farsça, Arapça, Fransızca, Rusça, Türkçe ve Almanca) görüntüleyebilir. Sistem gerekli çevirileri akıllı bir şekilde sağlayacaktır.",
    messagesetting_ViewStoreandproducts: "Mağazayı ve Ürünleri Görüntüle",
    messagesetting_ViewStoreandproductsExplain:
      "Bu seçenekle kullanıcılar, ürün kataloğunuzu liste veya albüm formatında, stok durumu, fiyat ve diğer ayrıntılarla birlikte görüntüleyebilir.",
    messagesetting_Visityourwebsite: "Web Sitesini Görüntüle",
    messagesetting_VisityourwebsiteExplain:
      "Kullanıcılar bu seçenekle web sitenizin adresini ve özetini görüntüleyebilir ve doğrudan erişim sağlayabilir. (Sayfa yükleme hızı çok yüksek olacaktır.)",
    messagesetting_Viewuserrolesandpermissions: "İş Kuralları ve Düzenlemeleri",
    messagesetting_ViewuserrolesandpermissionsExplain:
      "Bu seçenek etkinleştirildiğinde, kullanıcılar Brancy ayarlarında tanımladığınız iş kurallarını, düzenlemeleri ve kısıtlamaları görüntüleyebilir.",
    messagesetting_Viewbusinesshourschart: "İşletme Çalışma Saatleri",
    messagesetting_ViewbusinesshourschartExplain:
      "Kullanıcılar çalışma saatlerinizi görüntülemek için bu seçeneği kullanabilir. Bu özellik, mesai saatleri dışında gelen mesajları azaltmaya yardımcı olur.",
    messagesetting_Viewpricinginformation: "Fiyat Bilgilerini Görüntüle",
    messagesetting_ViewpricinginformationExplain:
      "Bu seçenekle kullanıcılar, ürünlerinizin fiyatlarını ve özelliklerini görüntüleyebilir ve karşılaştırabilir.",
    messagesetting_Searchforproducts: "Ürünleri Arayın",
    messagesetting_SearchforproductsExplain:
      "Bu seçenekle kullanıcılar, ürünlerinizi adlarına, kategorilerine veya fiyatlarına göre arayabilir ve filtreleyebilir.",
    messagesetting_addautomaticreplysystemsystem: "Tüm Sayfa Bölümleri İçin Tek Bir Sistem Yanıtı",
    messagesetting_HideRobotReply: "Otomatik ve Bot Mesajlarını Gizle",
    messagesetting_HideRobotReplyExplain:
      "Otomatik bot mesajları gizlenir ve Direct'te yalnızca gerçek mesajlar gösterilir",
    messagesetting_LikeRobotReply: "Story Comment'lerini Otomatik Beğen",
    messagesetting_HideRobotReplytooltip: "Mesajlar silinmez, yalnızca Direct yönetimini kolaylaştırmak için gizlenir",
    messagesetting_LikeRobotReplyExplain: "Story comment'leri etkileşimi artırmak için otomatik olarak beğenilir",
    messagesetting_automaticreplysystem: "Otomatik Yanıt Kontrolü",
    messagesetting_automaticreplysystemforallpost:
      "Tüm Post'lar için otomatik comment yanıtlarını etkinleştir veya devre dışı bırak",
    messagesetting_automaticreplysystemforallposttooltip:
      "Farklı Post'lar için otomatik comment yanıtları ayarladıysanız, bu seçenekle hepsini tek seferde etkinleştirebilir veya devre dışı bırakabilirsiniz. Yanıtları düzenlemek için her Post'un sayfasını ayrı ayrı açmanız gerekir",

    messagesetting_messagePanellanguage: "Varsayılan Direkt Dili",
    messagesetting_messagePanellanguageExplain: "Mesajlara yanıt vermek için direkt botun varsayılan dili.",
    messagesetting_AutoReplyPerFollow: "Özel Takip Şablonu",
    messagesetting_AutoReplyPerFollowExplain:
      "Kullanıcıdan sayfayı takip etmesini istediğiniz durumlarda bu şablonu kullanın.",
    messagesetting_AutoReplyPerFollowtooltip:
      "Sizi follow etmeyen kullanıcılar önce bir follow isteği alır. Sayfanızı follow ettikten sonra otomatik mesaj gönderilir",
    messagesetting_AutoReplyPerFollowtitle: "Mesaj Metni",
    messagesetting_AutoReplyPerFollowtitlesample: "Örnek: Mesajı almak için önce sayfamızı follow edin",
    messagesetting_AutoReplyPerFollowbtn: "Buton Metni",
    messagesetting_AutoReplyPerFollowbtnsample: "Örnek: Follow Ettim, Mesajı Gönder",
    messagesetting_automaticreplysystemexplain:
      "Sayfanın herhangi bir bölümünde (Feed, Story, Reels, Canlı vb.) bir mesaj veya yorum alındığında, sistem belirlediğiniz metinle otomatik olarak yanıt verir.",

    messagesetting_KeywordSensitive: "Anahtar Kelimeler Duyarlı",
    messagesetting_KeywordsSensitive: "Anahtar Kelimeler Duyarlı",
    sendreplydirectedsuccessfully: "Direct sonrası comment içinde onay mesajı gönderildi",

    autoReplyFor: "Otomatik Yanıt İçin",
    automaticreply: "Otomatik Yanıt",
    autodirectexplain:
      "Belirli bir anahtar kelime DİREKT olarak alındığında, önceden tanımlı yanıtınız otomatik olarak DİREKT olarak gönderilecektir",
    adddirectexplain: "otomatik yanıtları DİREKT olarak ekle",
    autocommentexplain:
      "Bir yorumda belirli bir anahtar kelime alındığında, önceden tanımlı cevabınız aynı yoruma otomatik olarak gönderilecektir",
    addcommentexplain: "otomatik yanıt ekleyin",
    messagesetting_icebreaker: "Hızlı sohbet başlatma düğmesi",
    messagesetting_addNewButton: "Yeni Düğme Ekle",
    messagesetting_icebreakerexplain:
      "Kullanıcı ilk kez Direct'e girdiğinde, dört düğme görüntülenir ve her biri seçildiğinde ilgili yanıt gönderilir.",
    messagesetting_addicebreakerexplain: "En fazla 4 hızlı sohbet başlatma düğmesi ekleyin",
    messagesetting_PersistentMenu: "Kalıcı Direkt Menü",
    messagesetting_PersistentMenuexplain:
      "Her zaman erişilebilir bir menü, müşterilerin markanızla etkileşimini hızlı, kolay ve yazmaya gerek kalmadan sağlar.",
    messagesetting_addPersistentMenuexplain: "En fazla 3 kalıcı menü düğmesi ekleyin",
    Welcometodirectmessages: "Instagram Direkt Mesajlarına Hoş Geldiniz!",
    messagesetting_UseSystemButtonsExplain:
      "Mağazayı Görüntüle, Destek Talebi ve Dil Değiştirme gibi standart bilgileri sunmak için hazır sistem butonlarını kullanın",
    messagesetting_UseAIPromptsExplain:
      "Yapay zekâ prompt’larını kullanarak kendi tonunuz ve iletişim tarzınızla kullanıcılara akıllı ve kişiselleştirilmiş yanıtlar sunun",
    messagesetting_ButtonTitle: "Buton Başlığı",
    messagesetting_NoPromptsFound:
      "Hiç prompt bulunamadı. Yeni bir prompt oluşturmak için oluşturma sayfasına yönlendirileceksiniz.",
    messagesetting_CreateNewPrompt: "Yeni Prompt Oluştur",
    messagesetting_SelectYourPrompt: "Prompt’unuzu Seçin",
    messagesetting_DefineCustomResponseExplain:
      "Kendi özel yanıt metninizi tanımlayın, böylece kullanıcılara otomatik olarak gönderilsin",
    messagesetting_SelectPredefinedFlowExplain:
      "Kullanıcıyla akıllı ve otomatik bir konuşma başlatmak için önceden tanımlı bir flow seçin",
    messagesetting_NoFlowsFound:
      "Hiç flow bulunamadı. Yeni bir flow oluşturmak için oluşturma sayfasına yönlendirileceksiniz.",
    messagesetting_CreateNewFlow: "Yeni Flow Oluştur",
    messagesetting_SelectFlow: "Flow Seç",
    messagesetting_ViewFlow: "Flow’u Görüntüle",
    messagesetting_UseGeneralAIExplain: "Kullanıcılarla serbest ve sınırsız etkileşim için genel yapay zekâyı kullanın",
    tool_token_usage_guide: "Bu aracın çalıştırılması sırasında tahmini token kullanımı",
    tool_how_use: "Aracın nasıl kullanıldığı",
    tool_how_work: "Aracın nasıl çalıştığı",
    send_sms_ir_code_description: "SMS.ir platformu üzerinden kullanıcıya SMS gönderme",
    send_sms_ir_code_completeDescription:
      "Bu araç kullanıcıya doğrulama kodu, kayıt veya bilgilendirme SMS’i göndermek için kullanılır. Telefon numarası alınarak SMS servisinde kullanılabilir.",
    send_sms_ir_code_howUse: `1- SMS.ir üzerinden ApiKey alın ve girin.
2- SMS şablonunu TemplateId alanına girin.
3- {CODE} geçen yerler otomatik OTP ile değiştirilir.
`,
    send_sms_ir_code_howWork: `1- Kullanıcı Direct üzerinden telefon numarasını gönderir.
2- SMS gönderilir. {CODE} varsa OTP ile değiştirilir.
3- Kullanıcı kodu AI’ye gönderir.
4- AI kodu doğrular ve numarayı onaylar.
`,

    send_to_telegram_description: "Bot üzerinden Telegram’a mesaj gönderme",
    send_to_telegram_completeDescription:
      "Bu araç Telegram botu ile mesaj göndermek için kullanılır. Bot Token ile kanal veya sohbete mesaj iletilir.",
    send_to_telegram_howUse: "1- Bot Token girin.\n2- Chat ID veya kanal ID girin.\n3- Aracı çalıştırın.",
    send_to_telegram_howWork:
      "1- Kullanıcı Token ve Channel girer.\n2- Sistem Telegram API isteği hazırlar.\n3- Mesaj kanala gönderilir.",

    sender_username_description: "Gönderen kullanıcı adını prompt içinde kullanma",
    sender_username_completeDescription:
      "Bu araç AI prompt’larında gönderen kullanıcı adını kullanmanızı sağlar. {SENDER_USERNAME} otomatik olarak değiştirilir.",
    sender_username_howUse:
      "1- Prompt içine {SENDER_USERNAME} ekleyin.\n2- Çalıştırıldığında kullanıcı adı ile değiştirilir.",
    sender_username_howWork:
      "1- Kullanıcı {SENDER_USERNAME} ekler.\n2- Sistem kullanıcı adıyla değiştirir.\n3- AI yanıt üretir.",
    // #endregion Message Section
    // #region 5️⃣market Section
    // 5️⃣ Market -> home
    filter_most_expensive: "En Pahalı",
    filter_cheapest: "En Ucuz",
    filter_newest: "En Yeni",
    filter_highest_discount: "En Yüksek İndirim",
    filter_all_products: "Tüm Ürünler",
    filter_only_available: "Sadece Mevcut Olanlar",
    filter_reset: "Sıfırla",
    filter_sortby: "Sırala",
    filter_category: "Kategori",
    filter_price: "Fiyat",
    Pricerange: "Fiyat Aralığı",
    from: "Başlangıç",
    to: "Bitiş",
    filter_rating: "Derecelendirme",
    filter_followers: "takipçiler",
    default: "Varsayılan",
    lowtohigh: "Düşükten Yükseğe",
    hightolow: "Yüksekten Düşüğe",

    biolinkHomerating: "Değerlendir",
    biolinkHomefollower: "Follower",
    biolinkHomepost: "Post",
    biolinkHomeAllMarkets: "Hepsi",
    biolinkHomeAdvertise: "Reklamveren",
    biolinkHomeStore: "Mağaza",
    biolinkStatisticsAllLinkclicks: "Tüm Bağlantı tıklamaları",
    biolinkStatisticsMarketviews: "Pazar görüntülemeleri",
    biolinkStatisticsmostview: "en çok görüntülenen",
    biolinkStatisticscouponcodeused: "kupon kodu kullanıldı",
    biolinkStatisticslastupdate: "son güncelleme",
    biolinkStatisticsAllsearches: "Tüm aramalar",
    biolinkStatisticsfeatures: "özellikler",
    biolinkStatisticsVisits: "Ziyaretler",
    biolinkStatisticsClicksAndInteractions: "Tıklamalar ve etkileşimler",
    biolinkStatisticsVisitsConverted: "Tıklamaya dönüşen ziyaretler",
    biolinkStatisticsQuickUserExitAfterEntry: "Girişten sonra hızlı kullanıcı çıkışı",
    biolinkStatisticsNoInteractionExit: "Etkileşimsiz çıkış",
    biolinkStatisticsMaxClicksPerVisit: "Tek bir ziyarette bir kullanıcının en fazla tıklaması",
    biolinkStatisticsAvgClicksAndInteractionsPerVisitor: "Ziyaretçi başına ortalama tıklama ve etkileşim",
    biolinkStatisticsTotalVisitTime: "Toplam ziyaret süresi",
    biolinkStatisticsAvgVisitTime: "Ortalama ziyaret süresi",
    biolinkStatisticsVideoPlatformsComparison: "Video platformları karşılaştırması",
    biolinkStatisticsYoutube: "YouTube",
    biolinkStatisticsAparat: "Aparat",
    biolinkStatisticsTwitch: "Twitch",
    biolinkStatisticsPlatformEntry: "Platform girişi",
    biolinkStatisticsRedirectEvent: "Yönlendirme olayı",
    biolinkStatisticsPlayVideo: "Video oynatma",
    biolinkStatisticsPlayEvent: "Oynatma olayı",
    biolinkStatisticsUniqueVisit: "Benzersiz ziyaret",
    biolinkStatisticsDedicatedLinkVisits: "Özel bağlantı ziyaretleri",
    biolinkStatisticsCombinedLinkVisits: "Birleşik bağlantı ziyaret grafiği",
    // 5️⃣ Market -> Properties
    biolinkPropertiesfeatures: "Özellikler",
    biolinkPropertiesProfileInfoBanner: "Profil Bilgileri ve Afiş",
    biolinkPropertiesFeaturebox: "Özellik Kutusu",
    biolinkPropertiesTermsAndActiveTime: "Koşullar ve Çalışma Saatleri",
    biolinkPropertiesFeatureboxexplain:
      "Her özelliği etkinleştirerek, link sayfanızı ziyaret edenlere önemli bilgiler gösterebilirsiniz",
    biolinkPropertiesBanner: "Afiş",
    biolinkPropertiesFeaturesBox: "Özellik Kutusu",
    biolinkPropertiesReviews: "İncelemeler",
    biolinkPropertiesAnnouncements: "Duyurular",
    biolinkPropertiesAnnouncementsexplain:
      "Bu bölümde açıklamalar yazarak link sayfanızı ziyaret edenlere önemli bilgileri bildirebilirsiniz",

    biolinkPropertiesOnlineStream: "Canlı Yayın",
    biolinkPropertiesOnlineStreamexplain:
      "Bu seçeneği etkinleştirdiğinizde, kanalınızda bir canlı yayın başlattığınız anda özel linkinizde otomatik olarak görüntülenecektir",

    biolinkPropertiesLastVideo: "Son Video",
    biolinkPropertiesLastVideoexplain:
      "Bu seçeneği etkinleştirdiğinizde, kanalınıza yeni bir video yüklediğiniz anda son video otomatik olarak özel linkinizde gösterilir ve her zaman güncel kalır",

    biolinkPropertiesProducts: "Ürünler",
    biolinkPropertiesProduct: "Ürün",
    biolinkProperties_showLast10Products: "Son 10 ürünü göster",
    biolinkProperties_showBestSellingProducts: "En çok satan ürünleri göster",
    biolinkPropertiesAdsTimeline: "Reklam Zaman Çizelgesi",
    biolinkPropertiesQandABox: "Soru ve Cevap Kutusu",
    biolinkPropertiesLinkShortcut: "Bağlantı Kısayolu",
    biolinkPropertiesContactAndMap: "İletişim ve Harita",
    biolinkPropertieslinks: "Bağlantılar",
    clickonstreamvideo: "Canlı yayını izlemek için videoya tıklayın",
    livestarted: "Canlı Yayın Devam Ediyor",
    live: "Canlı",
    biolinkPropertiesaddnew: "Yeni Bağlantı Ekle",
    biolinkProperties_DomainManager: "Alan Adı Yönetimi",
    biolinkProperties_DomainManagerexplain: "Size özel web sitesi",
    biolinkProperties_DomainManagerexplain2:
      "Bu linki Instagram Bio kısmına ekleyebilir veya diğer kullanıcılarla paylaşabilirsiniz",

    biolinkProperties_explain:
      "Instagram kullanıcı adı değiştirildiğinde, bu bağlantı otomatik olarak güncellenecektir.",
    biolinkProperties_rejected: "Alan adınız reddedildi (lütfen bizimle iletişime geçin)",
    customDomain_inactive_title: "Özel alan adı etkin değil",
    customDomain_inactive_desc: "Alan adınız şu anda etkin değil. Etkinleştirmek için bir destek bileti gönderin.",
    customDomain_noPackage_title: "Özel alan adı paketi bulunamadı",
    customDomain_noPackage_desc:
      "Mevcut paketiniz özel alan adı desteği içermiyor. Bu özelliği kullanmak için paketinizi yükseltin.",
    customDomain_rule_validChars: "Yalnızca harfler ve rakamlar kullanılabilir",
    customDomain_rule_noUnderscore: "(_) ve (-) karakterlerine izin verilmez",
    customDomain_rule_noSubdomain: "Alt alan adlarına (Subdomain) izin verilmez",
    biolinkProperties_Request: "Talep",
    biolinkProperties_Requested: "Talep Edildi",
    biolinkProperties_Checking: "Kontrol Ediliyor",
    biolinkProperties_yourstore: "Mağaza (mağaza bağlantınız)",
    biolinkProperties_yourads: "Reklam Sipariş Bağlantısı",
    biolinkProperties_yourlottery: "Tamamlanan çekilişleriniz",
    biolinkProperties_yourtariff: "Tarife (fiyat tablonuz)",
    biolinkProperties_yourBusinesshours: "Aktif İş Saatleriniz",
    biolinkProperties_yourBusinessTerms: "İş Şartlarınız",
    biolinkProperties_defaultAddress: "Varsayılan Alan Adresi",
    biolinkProperties_CustomAddress: "Özel Alan Adresiniz",
    biolinkPropertiespopup_GeneralCustom: "Genel",
    biolinkPropertiespopup_socialmedia: "Sosyal Medya",
    biolinkPropertiespopup_mediastream: "Medya ve Yayın",
    biolinkPropertiespopup_clouddrivecontent: "Bulut Sürücü İçeriği",
    biolinkPropertiespopup_Finance: "Finans",
    biolinkProperties_followersrate: "Takipçi Sayısı",
    biolinkProperties_followersrateExplain: "Instagram sayfanızın takipçi sayısını gösterir",
    biolinkProperties_successRating: "Başarı Oranı",
    biolinkProperties_successRatingExplain: "Siparişleri tamamlama başarı puanınızı gösterir",
    biolinkProperties_bussinessHours: "Aktif Çalışma Saatleri",
    biolinkProperties_bussinessHoursExplain: "İşletmenizin çalışma saatlerini gösterir",
    biolinkProperties_Enamadverified: "E-Namad Doğrulaması",
    biolinkProperties_EnamadverifiedExplain: "E-Namad güven rozeti doğrulama durumunuzu gösterir",
    biolinkProperties_BusinessTerms: "İşletme Şartları",
    biolinkProperties_BusinessTermsExplain: "İşletmenizin şartlarını ve kurallarını gösterir",
    biolinkProperties_tariff: "Tarife",
    biolinkProperties_TariffExplain: "Hizmet fiyatlarınızı gösterir",
    biolinkProperties_StartADS: "Reklam Talebi Başlat",
    biolinkProperties_StartADSExplain: "Kullanıcılar fiyatlarınıza göre reklam başlatabilir",
    biolinkProperties_StartSALES: "Satın Alma Başlat",
    biolinkProperties_StartSALESExplain: "Kullanıcılar ürünlerinize göre satın alma başlatabilir",
    biolinkProperties_NameServers: "Alan Adı Name Server'ları",
    biolinkProperties_NameServersExplain: "Name Server'ları alan adı sağlayıcınızın yönetim paneline kaydedin",
    customDomain_dnsError:
      "Alan adının Name Server'ları henüz alan adı sağlayıcınızda kayıtlı değil. Lütfen tekrar deneyin",
    customDomain_active_desc:
      "Bu alan adını değiştirmek veya kaldırmak için talebinizi Ayarlar bölümündeki Destek Talebi üzerinden gönderin",
    biolinkProperties_NameServerstooltip:
      "İsteğinizin ad sunucularının internette yayılması ve alan adınızın etkinleşmesi 12 saate kadar sürebilir.",
    linkURL: "bağlantı URL'si",
    searchID: "Kanal Ekle",
    searchIDexplain: "Eklemek istediğiniz kişinin ID’sini veya kanal adını yazın",

    Browse: "Gözat",
    biolinkPropertiespopup_yourcustomIcon: "Özel simgeniz",
    Boldit: "Dikkat Çek!",

    Scheduletime: "Otomatik Kaldırma Zamanı",
    biolinkPropertiespopup_ProfileInfo: "Profil Bilgisi",
    biolinkPropertiespopup_Banner: "Afiş",
    biolinkPropertiespopup_Personal: "Kişisel",
    biolinkPropertiespopup_SameasInstagramProfile: "Instagram Profili ile Aynı",
    marketpropertise_aboutus: "Bu site Brancy platformu kullanılarak oluşturulmuştur",
    marketpropertise_copyright: "Bu sitenin tüm hakları şunlara aittir",
    marketpropertise_aboutusslogan:
      "Brancy, akıllı Biolink oluşturmak ve Instagram sayfanızı yönetmek için en iyi tercihtir",
    marketpropertise_madeby: "🤍 ile yapıldı, yapan:",

    custom: "Özel",
    advertiseProperties_biography: "Biyografi",
    uploadbannerexplain: "Birden fazla görüntü yüklemek yükleme hızını etkileyebilir.",
    Embed: "Video Göm",
    Embedexplain:
      "Bu seçeneği etkinleştirdiğinizde, video özel linkinizde doğrudan görüntülenir ve oynatılır; kullanıcı sayfayı terk etmeden veya başka bir platforma yönlendirilmeden videoyu izleyebilir",

    notfound: "bulunamadı",
    showsavecontactbutton: "Kişi kaydetme düğmesini göster",
    Map: "Harita",
    Contact: "İletişim",
    Showmap: "Haritayı göster",
    location: "Konum",
    phone: "Telefon",
    invalidphone: "Geçersiz telefon",
    email: "E-posta",
    invalidemail: "Geçersiz e-posta",
    Address: "Adres",
    // #endregion market Section
    // #region 6️⃣advertise Section
    advertise_ADDetail: "Reklam Detayı",
    content: "içerik",
    advertise_orderdate: "sipariş tarihi",
    advertise_duration: "süre",
    Remaining: "Kalan",
    ago: "önce",
    // advertise -> calendar
    advertisecalendar_calendar: "Takvim",
    advertisecalendar_nextday: "Bu gün için sonraki reklamlar",
    advertisecalendar_TODAY: "Bugün",
    advertisecalendar_BookaTime: "Bir Zaman Ayırtın",
    advertisecalendar_TIMELINEZOOM: "Zaman Çizelgesi Yakınlaştırma",
    advertisecalendar_Timeline: "Zaman çizelgesi",
    // advertise -> statistics
    advertisestatistics_lasttwomonth: "Son iki ay",
    advertisestatistics_lastmonth: "Geçen ay",
    advertisestatistics_thismonth: "Bu ay",
    advertisestatistics_ads: "Reklam",
    advertisestatistics_fromlast: "% Geçen aydan",
    advertisestatistics_totalADSstatistics: "Toplam Reklam İstatistikleri",
    advertisestatistics_TotalAds: "Toplam Reklamlar",
    advertisestatistics_TotalIncome: "Toplam Gelir",
    advertisestatistics_totaladsreport: "Toplam Reklam Raporu",
    advertisestatistics_adno: "Reklam No.",
    advertisestatistics_advertiser: "Reklamveren",
    advertisestatistics_type: "Tür",
    advertisestatistics_status: "Durum",
    advertisestatistics_price: "Fiyat",
    advertisestatistics_date: "Tarih",
    advertisestatistics_share: "Paylaş",
    // advertise -> adlist
    advertiseadlist_activeAd: "Yayınlanmış Reklamlar",
    advertiseadlist_AwaitingApproval: "Onay Bekleyen Reklamlar",
    advertiseadlist_AwaitingPublication: "Programlanan Reklamlar",
    advertiseadlist_rejectedlist: "Reddedilen Reklamlar",
    // advertise -> Properties
    advertiseProperties_Concurrentads: "Eşzamanlı Reklamlar",
    advertiseProperties_Concurrentadsexplain: "Belirli bir anda aktif olan reklam sayısı",
    advertiseProperties_numberofads: "Reklam Sayfalarının Sayısı",
    advertiseProperties_numberofadsexplain: "Gün boyunca aktif reklam sayısı",
    advertiseProperties_campaign: "Kampanya",
    advertiseProperties_campaignexplain: "Möglichkeit, an Werbekampagnen von Brancy teilzunehmen",
    advertiseProperties_adsoptions: "Reklam Seçenekleri",
    advertiseProperties_rejectreasonheader1: "Neden 1 (İlgisiz İçerik)",
    advertiseProperties_rejectreasonheader2: "Neden 2 (Sağlıksız İçerik)",
    advertiseProperties_rejectreasonheader3: "Neden 3 (Politika İhlali)",
    advertiseProperties_rejectreasonheader4: "Neden 4 (Olumsuz Geri Bildirim)",
    advertiseProperties_rejectreason1:
      "Maalesef, sağlanan içerik sayfamızın değerleri ve hedefleriyle uyumlu değil, genel izleyicimize uygun değil veya gerekli bilgileri içermiyor. Bu nedenle bu reklamı kabul edemiyoruz.",
    advertiseProperties_rejectreason2:
      "Maalesef, sağlanan içerik izleyicilerimiz için sağlıksız, yanıltıcı olabilir veya karmaşık bilgiler içerebilir. Geniş değişiklikler gerektiriyor, bu nedenle bu reklamı kabul edemiyoruz.",
    advertiseProperties_rejectreason3:
      "Maalesef, sağlanan içerik kurallarımız veya Instagram kuralları ile uyumlu değil ve mantıksız, saldırgan, tartışmalı veya suç unsuru olarak değerlendirilebilir. Bu nedenle bu reklamı kabul edemiyoruz.",
    advertiseProperties_rejectreason4:
      "Maalesef, benzer reklamların yüksek hacmi, zamanlama uyumsuzlukları, önceki deneyimlerden kullanıcıların olumsuz geri dönüşleri veya sağlanan içeriğin düşük kalitesi nedeniyle bu reklamı kabul edemiyoruz.",
    advertiseProperties_AdvertisingTerms: "Reklam Koşulları",
    advertiseProperties_AdvertisingTermsexplain:
      "Reklamverenler, sayfanızda reklam yapmak için bu kuralları kabul etmelidir.",
    advertiseProperties_AdvertisingTerm1: "Sayfanızın şartı 1",
    advertiseProperties_AdvertisingTerm2: "Sayfanızın şartı 2",
    advertiseProperties_AdvertisingTerm3: "Sayfanızın şartı 3",
    advertiseProperties_AdvertisingTerm4: "Sayfanızın şartı 4",
    advertiseProperties_AdvertisingTermsave: "Kaydet",
    advertiseProperties_businesshours: "Admin Aktif Çalışma Saatleri",
    advertiseProperties_24hours: "24 Saat Aktif",
    advertiseProperties_close: "24 Saat Pasif",
    advertiseProperties_notifications: "Bildirimler",
    advertiseProperties_notificationsSMS: "SMS",
    advertiseProperties_notificationsEmail: "E-posta",
    advertiseProperties_notificationssystem: "Sistem Bildirimi",
    advertiseProperties_notificationsinstagramdirect: "Instagram Direkt",
    advertiseProperties_notificationssystemticket: "Bilet",
    advertiseProperties_advertisetariff: "Reklam Tarifesi",
    advertiseProperties_onlyToday: "Sadece Bugün İçin",
    advertiseProperties_onlyTodayexplain: "Reklam fiyat tarifesi sadece bugün için",
    advertiseProperties_tariff12hours: "12 Saat",
    advertiseProperties_tariff24hours: "24 Saat",
    advertiseProperties_otherdays: "Temel (Diğer Günler)",
    advertiseProperties_otherdaysexplain: "Diğer günler için reklam fiyat tarifesi",
    advertiseProperties_Campaign: "Kampanya",
    advertiseProperties_Campaignexplain: "Kampanya için reklam fiyat tarifesi",
    advertiseProperties_lastModified: "Son Değişiklik",
    advertiseProperties_userreport: "Kullanıcı Raporu",
    advertiseProperties_userID: "Kullanıcı Kimliği",
    advertiseProperties_reportexplain: "Raporunuz Brancy desteğine gönderilecektir.",
    advertiseProperties_reportsubmit: "Gönder",
    Apply: "Uygula",
    signinyouradvertise: "Reklamları Etkinleştir",
    signinyouradvertiseExplain: "Reklamlarınızı birkaç tıklama ile etkinleştirin",

    // #endregion advertise Section
    // #region 7️⃣Store Section
    // Store -> product
    Storeproduct_activatestore: "Mağazanızı etkinleştirin",
    signinyourstore: "Mağazanı Oluştur",
    signinyourstoreExplain: "Sadece birkaç tıklamayla mağazanı kur",
    Storeproduct_needyourID: "Kimlik Doğrulama",
    Storeproduct_needyourIDExplain: "Kimlik kartınızı yükleyin",
    Storeproduct_successyourID: "Kimliğiniz başarıyla doğrulandı",
    Storeproduct_addcreditnumber: "Finansal Bilgiler",
    Storeproduct_addcreditnumberExplain: "Banka kartınızı girin",
    Storeproduct_successnumber: "Banka bilgileriniz başarıyla doğrulandı",
    Storeproduct_shippingmethod: "Gönderim Yöntemi",
    Storeproduct_shippingmethodExplain: "Tercih ettiğiniz gönderim yöntemini seçin",
    Storeproduct_shippingmethodsuccess: "Seçilen gönderim yöntemi başarıyla kaydedildi",
    Storeproduct_shippingmethodtooltip:
      "Önerilen yöntemler konumunuza göre seçildi. Daha sonra mağaza ayarlarından düzenlenip değiştirilebilir.",
    Storeproduct_uploadimagefirst: "Lütfen önce kimlik kartı fotoğrafınızı yükleyin",
    Storeproduct_creditcardsameidcard: "Banka kartı numarası, kimlik kartı sahibine ait olmalıdır",
    Storeproduct_postalcode: "İşletme Adresi",
    Storeproduct_postalcodeExplain: "Posta kodunu girin",
    Storeproduct_postalcodesuccess: "Adres ve konum başarıyla kaydedildi",
    Storeproduct_postalcodeinputExplain: "Kargo ücreti bu adrese göre hesaplanır, lütfen posta kodunu doğru girin.",
    Storeproduct_TermsAndCondition: "Şartlar ve Koşullar",
    Storeproduct_TermsAndConditionExplain: "Şartları okuyun ve kabul edin",
    Storeproduct_TermsAndConditionesuccess: "Şartlar ve koşullar başarıyla kabul edildi",
    Storeproduct_AcceptTermsAndCondition:
      "Brancy üzerinden mağaza oluşturmayla ilgili tüm kural ve koşulları okudum ve kabul ediyorum",
    Storeproduct_notyet: "Henüz herhangi bir ürün eklemediniz!",
    Storeproduct_addnow: "ŞİMDİ ÜRÜN EKLEYİN",
    Storeproduct_addexplain: "Ürünler Instagram sayfanızdan otomatik olarak eklenecek.",
    Storeproduct_productlist: "Ürün Listesi",
    Storeproduct_search: "'Ürün Adı' veya 'PID' Ara",
    Storeproduct_importproduct: "Ürün İçe Aktar",
    Storeproduct_importfrominsta: "Instagram'ınızdan İçe Aktar",
    Storeproduct_newproduct: "Yeni Ürün",
    Storeproduct_addnewproduct: "Yeni Bir Ürün Ekle",
    Storeproduct_name: "ÜRÜN Ad",
    Storeproduct_weight: "Ağırlık",
    Storeproduct_size: "Boyut",
    Storeproduct_color: "Renk",
    Storeproduct_stock: "Stok",
    Storeproduct_price: "Fiyat",
    Storeproduct_active: "Aktif",
    Storeproduct_gram: "Gram",
    bulkProduct: {
      title: "Seçili ürünleri yönet",
      selectedCount: "{{count}} ürün seçildi",
      priceChange: "Fiyatı değiştir",
      valueType: "Değer türü",
      amount: "Tutar",
      increase: "Artır",
      decrease: "Azalt",
      applyAll: "Aynı değişikliği tümüne uygula",
      applyIndividual: "Her ürünü ayrı ayarla",
      allProducts: "{{count}} ürünün tümüne uygula",
      discountAllHint: "Seçili tüm ürünler için yüzdelik veya sabit bir indirim belirleyin.",
      priceAllHint: "Tüm fiyatları yüzde veya sabit tutarla artırın ya da azaltın.",
      currentDiscount: "Mevcut indirim",
      saving: "Kaydediliyor...",
    },
    loadingmoreproducts: "Ürünler Yükleniyor...",
    noMoreProducts: "Yüklenebilecek daha fazla ürün yok",
    storestatistics_lasttwomonth: "Son İki Ay",
    storestatistics_lastmonth: "Geçen Ay",
    storestatistics_thismonth: "Bu Ay",
    storestatistics_sales: "Satışlar",
    storestatistics_fromlast: "Geçen Aya Göre %",
    storestatistics_totalSalesstatistics: "Genel Satış İstatistikleri",
    storestatistics_TotalSales: "Toplam Satış",
    storestatistics_TotalIncome: "Toplam Gelir",
    storestatistics_totalsalesreport: "En İyi Alıcılar",
    storestatistics_buyer: "Alıcı Bilgileri",
    storestatistics_totalPurchases: "Toplam Satın Alma Sayısı",
    storestatistics_totalAmount: "Toplam Satın Alma Tutarı",
    storestatistics_lastPurchase: "Son Satın Alma Tarihi",
    storestatistics_saleno: "Satış Numarası",
    storestatistics_seller: "Satıcı",
    storestatistics_type: "Tür",
    storestatistics_status: "Durum",
    storestatistics_price: "Fiyat",
    storestatistics_date: "Tarih",
    storestatistics_share: "Paylaş",
    storestatistics_couponTitle: "İndirimler",
    storestatistics_addCoupon: "İndirim kodu ekle",
    storestatistics_noCoupons: "Henüz indirim kodu oluşturulmadı.",
    storestatistics_couponCode: "İndirim kodu",
    storestatistics_discountPercent: "İndirim yüzdesi",
    storestatistics_maxUses: "Maksimum kullanım",
    storestatistics_phoneNumber: "Telefon numarası",
    storestatistics_maxDiscountOptional: "Maksimum indirim (isteğe bağlı)",
    storestatistics_couponExpiry: "Son kullanma zamanı (en az 1 saat sonrası olmalıdır)",
    storestatistics_showInBio: "Biyografide göster",
    storestatistics_couponDeleted: "Silindi",
    storestatistics_couponExpired: "Süresi doldu",
    storestatistics_couponExhausted: "Tükendi",
    storestatistics_couponActive: "Aktif",
    storestatistics_unlimited: "Sınırsız",
    storestatistics_couponUsage: "{{max}} kullanımdan {{used}} kullanıldı",
    storestatistics_discountValue: "%{{discount}} indirim",
    storestatistics_maxDiscountValue: "Maksimum: {{value}}",
    storestatistics_expiryValue: "Son kullanma: {{date}}",
    storestatistics_private: "Özel",
    storestatistics_public: "Herkese açık",
    // Store -> order
    incartcount: "Sepette",
    addtocart: "Sepete Ekle",
    AllProducts: "Tüm Ürünler",
    Storeproduct_inQueue: "Onay Bekliyor",
    Storeproduct_inprogress: "Devam Ediyor",
    Storeproduct_pickingup: "Toplanıyor",
    Storeproduct_sent: "Gönderildi",
    Storeproduct_delivered: "Teslim Edildi",
    Storeproduct_failed: "Başarısız",
    Storeproduct_canceledbyuser: "Alıcı tarafından iptal edildi",
    Storeproduct_canceledbyadmin: "Yönetici tarafından iptal edildi",

    Storeproduct_returned: "İade Edildi",
    Storeproduct_yourcartisempty: "Sepetiniz boş",
    Storeproduct_noitemfounded: "Ürün bulunamadı",
    Storeproduct_incart: "Sepette",
    ShowUnprocessedItemsOnly: "İşlenmemiş Ürünler",
    pageStatistics_fromstore: "Mağazadan",
    ordernumber: "Sipariş Numarası",
    order_addressSubject: "Ev, İş yeri",
    order_addressReceiver: "Bu adresteki alıcının adı",
    order_addressNote: "Adres notu",

    Storeorder_all: "Hepsi",
    Storeorder_ORDERID: "Sipariş Numarası",
    Storeorder_CUSTOMER: "Müşteri",
    Storeorder_ITEMS: "Ürünler",
    Storeorder_ITEM: "Ürün",
    Storeorder_PRICE: "Fiyat",
    Storeorder_OrderDATE: "Sipariş Tarihi",
    copytrackingcode: "Takip Kodunu Kopyala",
    Storeorder_SentDATE: "Gönderim Tarihi",
    Storeorder_deliverdate: "Teslim Tarihi",
    Storeorder_DELIVERY: "Gönderim yolu",
    Storeorder_bymyself: "Kendim Gönderdim",
    Storeorder_Envelope: "Zarf",
    Storeorder_Invoice: "Fatura",

    Storeorder_DeliveryAmount: "Teslimat Ücreti",
    Storeorder_InsuranceAmount: "Sigorta Ücreti",
    Storeorder_Coupon: "Kupon Kodu",
    Storeorder_RemoveCoupon: "Kuponu Kaldır",
    Storeorder_Productsinyourshoppingcart: "Sepetinizdeki Ürünler",
    Storeorder_SendtotheAddress: "Adrese Gönder",
    Storeorder_changeofaddress: "Adres Değişikliği",

    Storeorder_postparselbox: "Posta Kutusu",
    Storeorder_pocketenveloptitle: "Her Zarfa Düşen Ürün Sayısı",
    Storeorder_pocketenveloptitleExplain:
      "Lütfen bu üründen standart bir zarfa (veya standart ambalajınıza) kaç adet sığdığını belirtin. Bu sayı, depo, paketleme ve gönderim hesaplamalarımızı daha doğru yapmamıza yardımcı olur.",
    Storeorder_Destination: "Varış Yeri",
    Storeorder_STATUS: "Durum",
    Storeorder_DETAILS: "Detaylar",
    Storeorder_PickupRequest: "Toplama İsteği",
    Storeorder_PrintWaybill: "İrsaliye Yazdır",
    Storeorder_Waybill: "Sevk İrsaliyesi",
    Storeorder_WaybillExplain:
      "Lütfen toplama talebi vermeden önce irsaliyeyi yazdırın ve okunaklı, düz ve sağlam bir şekilde paketin üzerine yapıştırın.",
    Storeorder_noneSendExplain:
      "Bu paket Brancy gönderi sistemiyle gönderilemediği ve sizin tarafınızdan kendi sorumluluğunuzda gönderildiği için, bu adımı onaylamanız gerekmektedir.Onayladığınızda, alıcıya paketin gönderildiği bildirilecektir.",
    Storeorder_ManualTrackingExplain:
      "Paket doğrudan taşıma firmasına teslim edildiği için, lütfen takip kodunu aldıktan sonra ilgili alana girin ve bu adımı onaylayın.  Böylece Brancy, takip kodu ve gönderi bilgilerini otomatik olarak alıcıya bildirecektir.",
    Storeorder_SendExplain: "Bu bölümdeki bilgiler otomatik olarak güncellenecektir",

    Storeorder_requestedpickup: "Toplama Bekleniyor",
    Storeorder_TrackingCode: "Takip Kodu",
    Storeorder_PostMan: "Postacı",
    Storeorder_from: "Gönderim yeri",
    Storeorder_currentLocation: "Mevcut konum",
    Storeorder_lastUpdateTime: "Son güncelleme zamanı",
    Storeorder_sender: "Gönderen",

    Storeorder_IssuingTrackingCode: "Takip Kodu Verme",
    Storeorder_orderDetailsStep: "Sipariş Bilgileri",
    Storeorder_orderconfirmStep: "Paket Boyutu ve Konşimento",
    Storeorder_orderlist: "Sipariş Listesi",
    Storeorder_singleorder: "Sipariş",
    Storeorder_quantityorder: "Adet",
    Showmore: "Daha Fazla Göster",
    totalprice: "Toplam Fiyat",
    note: "Not",
    navbar_PaymentNumber: "Ödeme Takip Kodu",
    Storeorder_receiver: "Alıcı",
    Storeorder_AcceptthisOrder: "Bu Siparişi Onayla",
    Storeorder_ParselisConfirmed: "Girilen bilgilerin doğru olduğunu onaylıyorum",
    Storeorder_ParselisConfirmedExplain:
      "Yanlış beden veya ağırlık girişi cezaya ve paketin geri gönderilmesine neden olabilir",
    Storeorder_CancelOrder: "Siparişi İptal Et",
    Storeorder_nextWaybill: "Devam Et (Konşimento Al)",
    Storeorder_Pickedup: "Alındı",
    SelectProduct: "Ürün Seç",
    SelectedPosts: "Seçilen Gönderiler:",
    product_BasicDetail: "Temel Detay",
    BacktoProductList: "Ürün Listesine Geri Dön",
    Backtocart: "Sepete Geri Dön",
    product_ProductID: "Ürün Kimliği",
    product_Producttitle: "Ürün Başlığı",
    product_Product: "Ürünler",
    product_Categories: "Kategoriler",
    product_MainCategory: "Ana Kategori",
    product_Subcategory: "Alt Kategori",
    product_Subset: "Alt Küme",
    product_Group: "Grup",
    product_Branch: "Şube",
    product_Subbranch: "Alt Şube",
    product_Dependency: "Bağlılık",
    product_Brand: "Marka",
    product_instagramcaption: "Instagram Başlığı",
    product_productDescription: "Ürün Açıklaması",
    product_Informationplaceholder:
      "Bu bölümde ürün açıklamanızı yazabilirsiniz.\n\n Bu açıklama, özellikler, faydalar ve ürünle ilgili anahtar detaylar veya nasıl kullanılacağı, içerikler gibi\n tam ve çekici bilgileri kısaca ve etkili bir şekilde içerebilir.\n\n Müşteriler ürün özellikleriyle daha fazla tanışacak ve ürünün satış şansı artacaktır.",
    product_General: "Genel",
    product_Specifications: "Özellikler",
    product_Information: "Bilgi",
    product_addNewTable: "Yeni Tablo Ekle",
    product_EditTable: "Tabloyu Düzenle",
    product_PreviewTable: "Tablo",
    product_addtable: "Tablo Oluştur",
    product_tabletitle: "Tablo Başlığı (İsteğe Bağlı)",
    product_tabletitleExplain: "Örneğin: Beden Tablosu",
    product_tableheaderoption: "İlk Satır Başlık Olarak",
    product_AddColumn: "Bu Sütunun Yanına Sütun Ekle",
    product_DeleteColumn: "Bu Sütunu Sil",
    product_AddRow: "Bu Satırın Altına Satır Ekle",
    product_DeleteRow: "Bu Satırı Sil",
    rowheader: "Başlık",
    cell: "Hücre",
    product_Media: "Medya",
    Nodescriptionavailable: "Tanımlama Yok",
    NoSpecificationsavailable: "Açıklama Yok",
    product_Properties: "Özellikler",
    product_Setting: "Ayarlar",
    product_productdeleted: "Ürün Silindi",
    product_SetProperties: "Özellikleri Ayarla",
    product_SetPropertiesexplain: "1-3 özellik seçebilirsiniz ve bunlardan biri özel olarak tanımlanabilir",
    product_AddNewproperty: "Yeni Özellik Ekle",
    product_Nopropertyisset: "Herhangi bir özellik ayarlanmadı",
    product_Variation: "Varyasyon",
    product_Discount: "İndirim",
    product_PricewithDiscount: "İndirimli Fiyat",
    product_AddNewVariation: "Yeni Varyasyon Ekle",
    product_Definenew: "Yeni Tanımla (Özel)",
    product_systemlist: "Akıllı Varsayılan Liste",
    product_itemlist: "Öğe Listesi",
    product_Available: "Mevcut",
    product_supplying: "Temin Ediliyor",
    product_OutOfStock: "Stokta Yok",
    product_Stoppedsale: "Satış Durduruldu",
    product_draft: "taslak",
    product_Amount: "Miktar",
    product_NUMBEROFUSES: "Kullanım Sayısı",
    product_UNLIMITED: "Sınırsız",
    product_LIMITED: "Sınırlı",
    product_USINGTIMES: "Kullanım Süresi",
    product_UNLIMITEDTIME: "Sınırsız Süre",
    permanent: "Kalıcı",
    product_LIMITEDTIME: "Sınırlı Süre",
    product_mediatitle: "Ürünün Resim ve Videolarını Yönet",
    product_clicktoupload: "Yüklemek için Tıklayın",
    product_SuggestedImages: "Önerilen Görseller",
    product_SuggestedImagesExplain:
      "Ürün galerinizi önerilen görsellerle geliştirin veya istediğiniz görselleri yükleyin",
    product_ordragdrop: "veya Sürükleyip Bırakın",
    product_productspecifications: "ürün özellikleri",
    product_choosesystemlist: "sistem listesinden seçin",
    product_choosesystemlistexplain: "İhtiyacınız olan tüm özellikleri arayın ve seçin",
    product_Definenewexplain: "Eğer özellikleri bulamazsanız, oluşturun",
    product_importbatch: "parti ithalatı",
    product_importbatchexplain: "Önceki üründen tüm özellikleri ekleyin",
    Value: "Değer",
    Undefined: "Tanımsız",
    product_original: "Orijinal",
    product_HighCopy: "Yüksek Kopya",
    product_notoriginal: "Orijinal Değil",
    product_Corporate: "Kurumsal",
    product_Miscellaneous: "Çeşitli",
    product_fake: "Sahte",
    tomorrow: "Yarın",
    NotSet: "Ayarlanmamış",
    Yes: "Evet",
    No: "Hayır",
    "Video generation request sent.": "Video oluşturma isteği gönderildi.",
    "Image generation request sent.": "Görsel oluşturma isteği gönderildi.",
    ", Image generation failed.": ", görsel oluşturulamadı.",
    "Create and manage AI-generated images and videos.":
      "Yapay zeka tarafından oluşturulan görsel ve videoları oluşturun ve yönetin.",
    Storeproduct_OutOfStandardSize: "Standart Boyut Dışı",
    product_box: "Kutu Boyutu",
    Product_Availablity: "Mevcutluk",
    Product_maxincart: "Sepette Maksimum",
    Product_originality: "Orijinallik",
    Product_preperingforship: "Kargo Hazırlığı",
    Product_Evat: "KDV",
    Product_Evatcount: "KDV değeri",
    Product_Guarantee: "Garanti",
    Product_Guaranteelength: "Garanti Süresi",
    Product_packageshipping: "Paket ve Nakliye",
    Product_packageshippingexplain:
      "Bu seçeneği devre dışı bırakarak, ürün gönderimi ve ilgili hizmetler sizin sorumluluğunuzda olacaktır",
    Product_titleExplain:
      "Önerilen başlıklar, ürününüzün özelliklerine ve pazardaki benzer başlıkların ortalamasına dayanarak aramalarda ve benzer ürünlerde görünürlüğünü artırmak için sağlanmaktadır.\n (Bu başlıklar hata içerebilir)",
    Product_Breakable: "Kırılabilir",
    Product_Luquid: "Sıvı",
    Product_sack: "Çuval / Torba",
    Product_sackExplain:
      "Ürününüz çuval, torba, poşet veya esnek ambalajlarla gönderiliyorsa bu seçeneği işaretleyin. Bu, yerleşim, taşıma ve paketleme sürecini daha iyi yönetmemize yardımcı olur.",
    Product_Productweights: "Ürün Ağırlığı",
    Product_Productweightsexplian: "Ambalajsız ürünün net ağırlığı",
    Product_packaging: "Ambalajlama",
    Product_packagingexplian:
      "Ürünün içeriği olmadan ambalaj ağırlığı, sistem tarafından hesaplanan karton ambalaj, bant ve nakliye etiketi dahil",
    Product_shippingSize: "Kargo Boyutu ",
    product_SuggestedPrice: "Bu ürünün tüm piyasadaki fiyat analizi",
    product_MinimumPrice: "Minimum Fiyat",
    product_AveragePrice: "Ortalama Fiyat",
    product_MaximumPrice: "Maksimum Fiyat",
    length: "Uzunluk",
    width: "Genişlik",
    height: "Yükseklik",
    Weight: "Ağırlık",
    finalWeight: "Nihai Ağırlık",
    product_deleteproductexplain: "Bu ürünü silmeye çalışıyorsunuz.",
    // #endregion Store Section
    // #region 8️⃣Setting Section
    // Setting -> General -> System
    SettingGeneralSystemTitle: "Sistem",
    SettingGeneralSystemlanguage: "Dil",
    SettingGeneralSystemcalendar: "Takvim",
    SettingGeneralSystemGregorian: "Gregoryen",
    SettingGeneralSystemshamsi: "Şemsi",
    SettingGeneralSystemHijri: "Hicri",
    SettingGeneralSystemHindi: "Hintçe",
    SettingGeneralSystemStartWeek: "Haftanın Başlangıcı",
    SettingGeneralSystemsaturday: "Cumartesi",
    SettingGeneralSystemmonday: "Pazartesi",
    SettingGeneralSystemtuesday: " Salı",
    SettingGeneralSystemwednesday: " Çarşamba",
    SettingGeneralSystemthursday: " Perşembe",
    SettingGeneralSystemfriday: " Cuma",
    SettingGeneralSystemsunday: " Pazar",
    SettingGeneralSystemtheme: "Tema",
    SettingGeneralSystemDarkmode: "Karanlık Mod",
    SettingGeneralSystemlightmode: "Aydınlık Mod",
    SettingGeneralSystemPrice: "Fiyat Modeli",
    SettingGeneralSystemDollar: "Dolar",
    SettingGeneralSystemeuro: "Euro",
    SettingGeneralSystempound: "Sterlin",
    SettingGeneralSystemrial: "Riyal",
    SettingGeneralSystemtoman: "Tümen",
    SettingGeneralAiModelsTitle: "Yapay Zeka Modelleri",
    SettingGeneralAiModelsTextModels: "Metin Modelleri",
    SettingGeneralAiModelsVoiceModels: "Sesten Metne Modeller",
    SettingGeneralAiModelsDirectVoiceSupport: "Doğrudan Ses Desteği",
    // Setting -> General -> Profile
    SettingGeneralProfileTitle: "Profil",
    SettingGeneral_activedevice: "Aktif Cihazlar",
    SettingGeneral_leatestentery: "Kullanıcı Etkinlik Geçmişi",
    SettingGeneral_cantdeletesession: "Oluşturulmasının üzerinden 24 saat geçmemiş oturumlar silinemez.",
    SettingGeneral_deletesession: "Bu oturumu silmeye çalışıyorsunuz.",
    SettingGeneral_addSubAdmin: "Alt Yönetici Ekle",
    SettingGeneral_addSubAdminExplain: "Sınırlı erişime sahip bir alt yönetici ekleyin",
    SettingGeneral_addSubAdminExplain2: "Instagram’a Giriş Yapmadan, Sınırlı ve Güvenli Yetkilerle Admin Davet Edin.",

    SettingGeneral_addSubAdmintitleExplain:
      "Davet gönderilmesi için yeni yöneticinin numarasını girin. Onaylandıktan sonra erişim aktif hale gelir.",
    SettingGeneral_accesslevel: "Erişim Seviyesi",
    SettingGeneral_access: "Erişim",
    SettingGeneral_partnertitle: "İşbirlikçi Admin Başlığı",
    SettingGeneral_partnernumberexplain:
      "Bu numaraya davetiye gönderilecektir ve işbirlikçi admin bunu panelinde onaylamalıdır (admin davetiyeyi kabul edebilmek için Brancy’de kayıt olmalıdır).",
    SettingGeneral_contentTooltip: "Gönderiler, Hikayeler, Reels, IGTV ve karuseller.",
    SettingGeneral_publishTooltip: "Gönderi ve hikaye oluşturma ve içerik oluşturma. İçerik erişimi gerektirir.",
    SettingGeneral_automaticsTooltip: "Yapay zeka, akışlar ve otomatik süreç ve görevler. İçerik erişimi gerektirir.",
    SettingGeneral_messageTooltip: "Instagram Direct, dahili mesajlar ve ilgili araçlar.",
    SettingGeneral_commentTooltip: "Yorumlar, yanıtlar ve ilgili araçlar.",
    SettingGeneral_transactionTooltip: "Ödeme hesabı yönetimi, işlemler, cüzdan ve ilgili araçlar.",
    SettingGeneral_adsTooltip: "Takvim yönetimi, reklamveren yönetimi, reklam onayı, fiyatlandırma ve ilgili araçlar.",
    SettingGeneral_ordersTooltip: "Ürünler, fiyatlar, depo stoku, siparişler, irsaliyeler ve ilgili araçlar.",
    SettingGeneral_bioTooltip: "Biyografi içeriği ve düzeni, bağlantılar ve üçüncü taraf içerik kısayolları.",
    SettingGeneral_ticketTooltip: "CRM, sistem talepleri ve destek.",
    SettingGeneral_productsTooltip: "Ürün yönetimi araçları.",

    // Setting -> General -> support
    SettingGeneral_GeneralSupport: "Genel Destek",
    SettingGeneral_Customerservices: "Müşteri Hizmetleri",
    SettingGeneral_ReportBug: "Hata Bildir",
    SettingGeneral_Advertise: "Reklam Ver",
    SettingGeneral_Store: "Mağaza",
    SettingGeneral_biolink: "Biyografi Bağlantısı",
    SettingGeneral_Walletandfinance: "Cüzdan ve Finans",
    SettingGeneral_MessageingandComment: "Mesajlaşma ve Yorum",
    SettingGeneral_Support: "Destek",
    SettingGeneral_Department: "Departman",
    SettingGeneral_Title: "Başlık",
    SettingGeneral_Description: "Açıklama",
    SettingGeneral_Send: "Gönder",
    // #endregion Setting Section
    userpanel_market: "Pazar",
    userpanel_order: "Sipariş",
    userpanel_Messages: "Mesajlar",
    userpanel_Settings: "Ayarlar",
    userpanel_PersonalInfo: "Kişisel Bilgiler",
    userpanel_UploadNewPicture: "Yeni Resim Yükle",
    userpanel_Instagramid: "Instagram Kimliği",
    userpanel_Nameandfamily: "Ad ve soyad",
    userpanel_NationalCode: "Ulusal Kod",
    userpanel_BirthDay: "Doğum Günü",
    userpanel_MobileNumber: "Cep Telefonu Numarası",
    userpanel_Email: "E-posta",
    userpanel_CreditNumber: "Kredi Kartı Numarası",
    userpanel_Addresses: "Adresler",
    userpanel_AddNewAddress: "Yeni Adres Ekle",
    userpanel_ZipCode: "Posta Kodu",
    userpanel_Address: "Adres",
    userpanel_EditAddress: "Adresi Düzenle",
    userpanel_AddNewAddressexplain: "Paketiniz bu adrese ve kişiye teslim edilecektir",
    startbusiness: "İş Başlat",
    AI: "YZ",
    ExtraTokens: "Ek Token",
    TokenUsage: "Token Kullanımı",
    AdvancedAnalytics: "Gelişmiş Analiz",
    AIResponse: "YZ IG Yanıt",
    CustomSupport: "Özel Destek",
    CustomDomain: "Özel Alan Adı",
    WinnerPicker: "Kazanan Seçici",
    WinnerPickerReserve: "Yedek Çekiliş",

    dataTable1_feature1: "Post Yönetimi ve Profesyonel İstatistikler",
    dataTable1_tooltip1:
      "Post’ları kolayca zamanla. Her Post için ayrıntılı grafikler ve istatistikler: (Like, Paylaşım, Comment, Kaydetme, Etkileşim Oranı, Erişim, Gösterim, Oynatma, Tutma, Follow/Unfollow, Profil Etkinliği, Kullanılan Hashtagler) ve çok daha fazlası...",

    dataTable1_feature2: "Yeni Post Oluştur",
    dataTable1_tooltip2:
      "Sayfana göre en iyi zaman önerisi. Post zamanlama. Hashtag kaydetme. Comment’lere otomatik cevap. Taslak olarak kaydet ve daha fazlası.",

    dataTable1_feature3: "Story Yönetimi ve İstatistikler",
    dataTable1_tooltip3:
      "Story zamanlama. Her Story için detaylı grafikler: (Like, Paylaşım, Comment, Kaydetme, Etkileşim, Erişim, Gösterim, Oynatma, Tutma, Follow/Unfollow, Profil Aktivitesi, Direct, Ekran görüntüsü) ve daha fazlası...",

    dataTable1_feature4: "Yeni Story Oluştur",
    dataTable1_tooltip4:
      "Sayfana göre en iyi zamanı önerir. Story zamanlama. Otomatik Comment yanıtı. Taslak kaydı ve daha fazlası.",

    dataTable1_feature5: "Genel Sayfa İstatistikleri",
    dataTable1_tooltip5:
      "Toplam Post ve Story sayısı. En çok ve en az görüntüleme, Comment ve Like’a göre sıralama. En iyi ve en kötü zaman tespiti. Geçmiş istatistiklerle karşılaştırma, takipçi analizleri ve çok daha fazlası.",

    dataTable1_feature6: "Hashtag Yönetimi",
    dataTable1_tooltip6:
      "Sınırsız hashtag listesi oluşturma. Görsel ve sayfa analiziyle akıllı hashtag üretimi. Kullanılmış hashtag görüntüleme. Günlük, haftalık, aylık trend listeleri (İngilizce, Farsça, Arapça vb.).",

    dataTable1_feature7: "Yeni Comment’lere Otomatik Like",
    dataTable1_tooltip7:
      "Followers’tan gelen yeni Comment’leri otomatik beğen. Grafik ve liste görünümünde geçmiş veriler.",

    dataTable1_feature8: "Followers Arasında Rastgele Çekiliş",
    dataTable1_tooltip8:
      "Like ve Comment bazlı en iyi Follower’ı seç. Rastgele kazanan belirle. Otomatik sonuç Story’si oluştur. Kodla takip et ve daha fazlası...",

    dataTable1_feature9: "Puan Bazlı Çekiliş",
    dataTable1_tooltip9:
      "Katılım için görev belirle (Like, Comment, Mention, Follow). Kazanan sayısı belirle. Şart Story’si ve sonuç Story’sini otomatik oluştur. Hatırlatma gönder. Kodla takip et ve daha fazlası...",
    WithStrongCallToAction: "Güçlü Bir Call To Action ile",
    WithProsAndCons: "Artılar ve Eksiler ile",
    ForComparison: "Karşılaştırma için",
    WithKeyPoints: "Ana Noktalar ile",
    ForPromotionalPost: "Reklam Gönderisine Özel",
    WithDetailedExplanation: "Detaylı Açıklama ile",
    PersuasiveStyle: "İkna Edici Tarzda",
    ForProductIntroduction: "Ürün Tanıtımı için",
    LongText: "Uzun Metin Olarak",
    Aipromptexplain:
      "Brancy, sayfanızın içeriğini analiz ederek tonunuzu ve yazım tarzınızı tanır; ek açıklamaya gerek yok!",
    ImagineSomething: "Bir şey hayal et... ✦",
    Generating: "Oluşturuluyor...",
    AccessAndManageComments: "Yorumlara Erişim ve Yönetim",
    AccessAndManageMessages: "Mesajlara Erişim ve Yönetim",
    AccessAndPublishContent: "İçeriğe Erişim ve Yayınlama",
    AccessAndManageInsights: "İstatistiklere ve Raporlara Erişim ve Yönetim",
    AccessAndManageCommentsExplain:
      "Instagram yorumlarını yönetmek için «İzni Etkinleştir»e tıklayın ve açılan sayfada onaylayın.",
    AccessAndManageMessagesExplain:
      "Instagram mesajlarını yönetmek için «İzni Etkinleştir»e tıklayın ve açılan sayfada onaylayın.",
    AccessAndPublishContentExplain:
      "Instagram içeriğini görüntülemek ve paylaşmak için «İzni Etkinleştir»e tıklayın ve açılan sayfada onaylayın.",
    AccessAndManageInsightsExplain:
      "Instagram istatistiklerini yönetmek için «İzni Etkinleştir»e tıklayın ve açılan sayfada onaylayın.",
    EnablePermission: "İzni Etkinleştir",
    instagramTutorialTitle: "Instagram Bağlantı Kılavuzu",
    instagramTutorialStep1Title: "Adım 1: Güvenli Instagram Girişi",
    instagramTutorialStep1Text:
      "«Instagram Hesabını Bağla»ya tıklayın, instagram.com’a yönlendirileceksiniz. Hesabınıza giriş yapın. Bu, güvenli bağlantı sağlar.",
    instagramTutorialStep2Title: "Adım 2: Erişim Onayı",
    instagramTutorialStep2Text:
      "Giriş yaptıktan sonra, Instagram genel bilgilerinize erişim izni isteyecek. Hepsini onaylayın.",
    instagramremoveStep1Title: "Adım 3: Erişimleri Kontrol Et",
    instagramremoveStep1text: "Ayarlar bölümünden hesabınızdaki tüm aktif erişimleri görebilirsiniz.",
    instagramremoveStep2Title: "Adım 4: Gereksiz Erişimleri Sil",
    instagramremoveStep2text:
      "Brancy, Instagram’ın resmi ortağıdır; başka servislere gerek yok. Güvenlik için gereksiz erişimleri kaldırın.",
    understood: "Anladım",
    previous: "Önceki",
    connectTutorial: "Bağlantı Kılavuzu",
    invalidcode: "Geçersiz Kod",
    wearesorry: "Üzgünüz!",
    PaymentFailed: "Ödeme Başarısız!",
    thankyou: "Teşekkürler!",
    Paymentsuccess: "Ödeme Başarılı!",
    TransactionNumber: "İşlem Numarası:",
    TransactiontrackingNumber: "İşlem Takip Numarası:",
    InvoiceNumber: "Fatura Numarası:",
    mainSubscriptionPlan: "Ana Abonelik",
    Tokens: "Tokenler",
    tokenExplain:
      "Token, yapay zeka hizmetlerinin tüketim birimidir; ortalama olarak 100 isteğin işlenmesi yaklaşık 1000 token gerektirir.",
    ReserveToken: "Yedek Token",
    packageTokenExplain:
      "Paketle birlikte etkinleşen ve paket süresi bitene kadar kullanılabilen ücretsiz tokenlerdir; sonrasında geçerliliğini yitirirler.",
    ReserveTokenExplain: "Zamanla süresi dolmayan, satın alınmış yedek tokenlerdir.",

    pageTools_Months: "Ay",
    subscriptionExpired: "Aboneliğiniz sona erdi, yenileyin",
    subscriptionExpireSoon: "Aboneliğiniz yakında sona erecek",
    subscriptionManagement: "Abonelik Yönetimi",
    subscription: "Abonelik",
    AIAssisment: "Yapay Zekâ Asistanı",
    timeperiod: "Kalan Süre",
    domain: "Alan Adı",
    winnerpickerexpired: "Artık Lottery yapamazsınız, lütfen yükleyin",
    winnerpickerexpiresoon: "Lottery haklarınız tükenmek üzere",
    Aiexpired: "Yapay zekayı artık kullanamazsınız, lütfen bakiye yükleyin.",
    Aiexpiresoon: "Yapay zeka tokenleriniz tükenmek üzere.",

    followercount: "Falor Sayısı",
    yourCurrentSubscription: "Mevcut Aboneliğiniz",
    noItemsAvailableContactSupport: "Bu bölüm şu anda kullanılamıyor. Sipariş için Brancy desteğine ticket gönderin.",

    // #region AIFlow Section
    AIAssismentexplain:
      "Brancy yapay zekâ asistanını kullanarak Instagram mesajları ve comment’ler için otomatik yanıt veren akıllı konuşma flow’ları oluşturabilirsiniz",
    livetest: "Canlı Test",
    testlab: "Test Laboratuvarı",
    promptmode: "Prompt Modu",
    promptanalysis: "Prompt Analizi",
    promptanalysisExplain:
      "Promptunuzu ayrıntılı olarak girin; Brancy bunu karakterinize, tonunuza ve etkileşim tarzınıza göre analiz eder.",
    promptanalysisplaceholder: "Prompt analizi için en az 20 karakter girin",
    reanalyze: "Yeniden Analiz Et",
    shouldFollowerexplain: "Yanıtlar yalnızca sizi follow eden kullanıcılara gönderilir",
    RenewForThread: "Konuşma Flow’unu Yenile",
    RenewForThreadexplain: "Her konuşmada, kullanıcı yeni bir mesaj gönderirse konuşma flow’u baştan başlar",
    prompt: "Prompt",
    promptanalysisexplain: "Brancy, Prompt’unuzu analiz eder ve akıllı yanıtlar için en iyi ayarları önerir",

    autosave: "Otomatik Kaydet",
    Restrictorzoom: "Yakınlaştırmayı Sınırla",
    snapGrid: "Izgaraya Hizala",
    PanningBoundary: "Kaydırma Sınırı",
    Flow: "Akış (Flow)",
    flowtitle: "Akış Başlığı",
    AIFlow_input: "Girdi",
    AIFlow_input_message_block: "Kullanıcı Girdi Mesajı",
    AIFlow_output: "Çıktı",
    AIFlow_output_title: "Çıktı Başlığı",
    AIFlow_text: "Metin",
    AIFlow_item_text: "Öğe",
    AIFlow_block_title_required: "Lütfen blok başlığını girin (zorunlu)",
    AIFlow_item_title: "Öğe Başlığı:",
    AIFlow_show_graph: "Akış Grafiğini Göster",
    AIFlow_connect_post: "Gönderiye bağla",
    AIFlow_connect_post_access: "Instagram yorum ve mesaj izinleri ile Otomasyon ve Yorum erişimi gereklidir.",
    AIFlow_connect_post_save_first: "Gönderiye bağlamadan önce bu akışı kaydedin.",
    AIFlow_connect_post_confirm:
      "Bu akış gönderinin mevcut otomatik yanıtının yerini alır ve etkinleştirilir. Anahtar kelimeler ve eşleştirme ayarları korunur; anahtar kelime yoksa akış tüm yorumlara yanıt verir.",
    AIFlow_connect_post_resume:
      "Akış bağlantısı kaydedildi ancak etkinleştirme başarısız oldu. Yeniden etkinleştirmeyi deneyin.",
    AIFlow_connect_post_incompatible:
      "Bu akış yorumlara özel yanıt vermeye uygun değil. Bağlamadan önce düzenleyip kaydedin.",
    AIFlow_retry: "Tekrar dene",
    AIPrompt_connect_post_access: "Instagram yorum izni ile Otomasyon ve Yorum erişimi gereklidir.",
    AIPrompt_connect_post_confirm:
      "Bu yapay zekâ gönderinin mevcut otomatik yanıtının yerini alır ve etkinleştirilir. Anahtar kelimeler ve eşleştirme ayarları korunur; anahtar kelime yoksa tüm yorumlar yanıtlanır. Özel gönderim yalnızca mesaj izni varsa korunur; aksi hâlde yanıtlar yorum olarak gönderilir.",
    AIPrompt_connect_post_resume:
      "Yapay zekâ bağlantısı kaydedildi ancak etkinleştirme başarısız oldu. Yeniden etkinleştirmeyi deneyin.",
    messagesetting_PhoneNumbers: "Telefon Numaraları",
    messagesetting_PhoneNumbersExplain: "Akışlar aracılığıyla müşterilerinizden toplanan telefon numaraları",
    messagesetting_PhoneNumbersEmpty: "Henüz telefon numarası toplanmadı",
    AIFlow_item_subtitle: "Öğe Alt Başlığı:",
    AIFlow_option_title: "Seçenek Başlığı",
    AIFlow_option_default: "Seçenek",
    AIFlow_quick_reply: "Hızlı Yanıt",
    AIFlow_quick_reply_validation_error: "Tüm hızlı yanıt alanları doldurulmalıdır!",
    AIFlow_quick_reply_block_title_empty: "Blok {label}\n Başlık girilmedi",
    AIFlow_quick_reply_option_title_empty: "Blok {label}\n Seçenek {index} başlıksız",
    AIFlow_delete_image: "🗑️ Resmi Sil",
    AIFlow_delete_image_button_text: "🗑️ Resmi Sil",
    AIFlow_delete_all_block: "🗑️ Bloğu Sil",
    AIFlow_delete_all_blocks: "Tüm Akışı Sil",
    AIFlow_save_all_blocks: "Tüm Akışı Kaydet",
    AIFlow_delete: "🗑️ Sil",
    AIFlow_upload_image: "📷 Resim Yükle",
    AIFlow_image_uploaded: "Resim Yüklendi ✓",
    AIFlow_add_image: "📷 Resim Ekle",
    AIFlow_voice_recorded: "🎵 Kaydedilen Ses",
    AIFlow_record_voice: "🎤 Ses Kaydet",
    AIFlow_record_voice_confirm: "Kayda hazır mısınız? (en az 3 saniye)",
    AIFlow_play_voice: "▶️ Sesi Oynat",
    AIFlow_add_output: "Yeni Çıktı Ekle",
    AIFlow_add_subtitle: "➕ Alt Başlık Ekle",
    AIFlow_subtitle_input: "Lütfen alt başlığı girin:",
    AIFlow_link: "Bağlantı:",
    AIFlow_general_block: "Genel Blok",
    AIFlow_text_block: "Metin Bloğu",
    AIFlow_image_block: "Resim Bloğu",
    AIFlow_voice_block: "Ses Bloğu",
    AIFlow_quick_reply_block: "Hızlı Yanıt Bloğu",
    AIFlow_weblink_block: "Bağlantı Bloğu",
    AIFlow_add_text_block: "Metin Bloğu Ekle",
    AIFlow_add_image_block: "Resim Bloğu Ekle",
    AIFlow_add_voice_block: "Ses Bloğu Ekle",
    AIFlow_add_quick_reply_block: "Hızlı Yanıt Ekle",
    AIFlow_add_general_block: "Genel Blok Ekle",
    AIFlow_add_weblink_block: "Bağlantı Ekle",
    AIFlow_generic_block: "Genel Alt Blok",
    AutoLayout_block: "Otomatik Düzen",
    AIFlow_live_test_block: "Canlı Akış Testi",
    AIFlow_Deleteallblocks_alert: "Tüm akışı silmek istediğinizden emin misiniz?",
    AIFlow_add_output_error_alert: "Çıkış eklenirken hata: {error}",
    AIFlow_unknown_block_type_alert: "Bilinmeyen blok türü:",
    AIFlow_multiple_flow_for_private_reply_alert: "Özel yanıt için birden fazla akış bulundu",
    AIFlow_empty_title_for_flow_alert: "Akış başlığı boş",
    AIFlow_weblink_has_hyphen_alert: "Blok {label}\n Bağlantı '-' içermemelidir",
    AIFlow_min_output_required: "En az bir çıkış kalmalıdır",
    AIFlow_max_quick_reply_outputs: "En fazla 15 çıkışa izin verilir",
    AIFlow_max_generic_outputs: "En fazla 10 çıkışa izin verilir",
    AIFlow_generic_item_connection_only: "Bu blok yalnızca genel bloklara bağlanır",
    AIFlow_weblink_generic_item_only: "Bu blok yalnızca genel alt öğelere bağlanır",
    AIFlow_voice_record_failed: "❌ Ses kaydı başarısız oldu (hiç ses kaydedilmedi)",
    AIFlow_voice_upload_failed: "✅ Kayıt başarılı ancak yükleme başarısız",
    AIFlow_voice_record_empty: "❌ Ses kaydı boş",
    AIFlow_voice_record_start: "🎙️ Kayıt başladı...",
    AIFlow_session_invalid: "Geçersiz kullanıcı oturumu, lütfen tekrar giriş yapın",
    AIFlow_no_on_message_node: "Başlangıç mesajı düğümü bulunamadı!",
    AIFlow_validation_warning: "⚠️ Doğrulama Uyarısı",
    AIFlow_generic_item_validation_error: "Lütfen genel bloğun tüm alanlarını doldurun",
    AIFlow_weblink_validation_error_alert: "Tüm bağlantı alanları doldurulmalıdır",
    AIFlow_generic_item_title_empty_alert: "Öğe {label}\n Başlık boş",
    AIFlow_generic_item_output_title_empty_alert: "Öğe {label}\n Çıkış {index} başlıksız",
    AIFlow_weblink_empty_alert: "Blok {label}\n Bağlantı boş",

    AIFlow_weblink_incomplete_alert: "Blok {label}\n Bağlantı eksik (sadece protokol girildi)",
    AIFlow_weblink_invalid_format_alert: "Blok {label}\n Bağlantı formatı geçersiz",
    AIFlow_weblink_non_english_alert: "Blok {label}\n Bağlantı İngilizce olmalıdır",
    AIFlow_editor_init_error: "❌ Editör başlatılırken hata oluştu",
    AIFlow_unexpected_error: "⚠️ Beklenmeyen bir hata oluştu",
    AIFlow_server_error: "❌ Sunucu hatası",
    AIFlow_connection_error: "⚠️ Bağlantı sorunu",
    AIFlow_generic_connection_error: "Genel blok ile alt öğe bağlantısında hata",
    AIFlow_weblink_connection_error: "Düğüm bağlantı hatası",
    AIFlow_voice_fetch_error: "Ses dosyası alınamadı",
    AIFlow_voice_record_error: "Ses kaydı hatası",
    AIFlow_voice_play_error: "Ses oynatma hatası",
    AIFlow_media_recorder_error: "Medya kaydedici hatası",
    AIFlow_upload_error: "❌ Yükleme hatası",
    AIFlow_add_output_error: "❌ Çıkış ekleme hatası",
    AIFlow_json_parse_error: "JSON işleme hatası",
    AIFlow_position_error: "Başlangıç mesajı pozisyonu işleme hatası",
    AIFlow_node_remove_error: "Düğüm silme hatası",
    AIFlow_node_connection_warning: "Bağlantı kurulamadı:",
    AIFlow_unknown_value_type: "Butonda bilinmeyen değer türü",
    AIFlow_success: "✅ İşlem başarıyla tamamlandı",
    AIFlow_subtitle_success: "✓ Alt başlık başarıyla eklendi",
    AI_live_test: "Yapay zeka komutlarını gerçek zamanlı olarak test et",

    New_Flow_input_message_block: "Kullanıcı Giriş Mesajı",
    New_Flow_general_block: "Genel Blok",
    New_Flow_text_block: "Metin Bloğu",
    New_Flow_voice_block: "Ses Bloğu",
    New_Flow_imageorvideo_block: "Görsel / Video Bloğu",
    New_Flow_quick_reply_block: "Hızlı Yanıt Bloğu",
    New_Flow_weblink_block: "Bağlantı Bloğu",
    New_Flow_phonenumbergrabber_block: "Telefon Numarası Toplayıcı",
    New_Flow_ai_block: "Yapay Zeka",
    New_Flow_ai_select: "Bir yapay zeka seçin",
    New_Flow_ai_livetest: "Yapay zeka bloğunuz burada çalıştırılıyor",
    New_Flow_masterflow_block: "Alt Akış",
    New_Flow_masterflow_select: "Bir akış seçin",
    New_Flow_masterflow_livetest: "Seçilen alt akış buradan devam ediyor",
    New_Flow_Tutorials_buttongroup_title: "Buton Grubu Bloğu",
    New_Flow_Tutorials_buttongroup_description:
      "Bu blok en fazla üç butonlu bir mesaj gönderir; her butonun kendi çıkışı vardır ve bloğun akışı sürdüren normal bir çıkışı da bulunur.",
    New_Flow_Tutorials_buttongroup_usageType:
      "Birkaç net seçenek sunmak, menü, hızlı gezinme ve kullanıcıyı bir bağlantıya veya sonraki adıma yönlendirmek için uygundur.",
    New_Flow_Tutorials_buttongroup_feature_1: "640 karaktere kadar mesaj metni",
    New_Flow_Tutorials_buttongroup_feature_2: "3 butona kadar, her birinin bağımsız çıkışı var",
    New_Flow_Tutorials_buttongroup_feature_3: "Normal çıkış, buton tıklamasını beklemeden akışı sürdürür",
    New_Flow_Tutorials_buttongroup_tip_1: "Mesajı ve buton etiketlerini açık ve kısa yazın",
    New_Flow_Tutorials_buttongroup_tip_2: "Her butonu, seçiminden sonra gelmesi gereken bloka bağlayın",
    New_Flow_Tutorials_buttongroup_tip_3: "Web Bağlantısı bloğuna yalnızca buton çıkışları bağlanabilir",
    New_Flow_Tutorials_buttongroup_limitation_1: "En fazla 3 buton",
    New_Flow_Tutorials_buttongroup_limitation_2: "Mesaj metni: en fazla 640 karakter",
    New_Flow_Tutorials_buttongroup_limitation_3: "Buton başlığı: en fazla 20 karakter",
    New_Flow_Tutorials_buttongroup_limitation_4: "Son butonu silmek bloğu siler",
    New_Flow_Tutorials_ai_title: "Yapay Zeka Bloğu",
    New_Flow_Tutorials_ai_description:
      "Bu blok, sohbeti oluşturduğunuz yapay zekalardan birine devreder; yapay zekayı blok içindeki listeden seçin.",
    New_Flow_Tutorials_ai_usageType:
      "Müşterilerin açık uçlu sorularını, destek, danışmanlık ve satış görüşmelerini otomatik yanıtlamak için uygundur.",
    New_Flow_Tutorials_ai_feature_1: "Oluşturduğunuz tüm yapay zekaları seçmeniz için listeler",
    New_Flow_Tutorials_ai_feature_2: "Seçilen yapay zeka akışın bu noktasından itibaren sohbeti devralır",
    New_Flow_Tutorials_ai_tip_1: "Listede görünmesi için önce yapay zekanızı oluşturup yapılandırın",
    New_Flow_Tutorials_ai_tip_2: "Sohbeti başlatan bir mesaj bloğundan sonra yerleştirin",
    New_Flow_Tutorials_ai_limitation_1: "Yalnızca girişi vardır, çıkışı yoktur; bu yüzden akışı sonlandırır",
    New_Flow_Tutorials_ai_limitation_2: "Her blokta yalnızca bir yapay zeka seçilebilir",
    New_Flow_Tutorials_ai_limitation_3: "Akışın ilk bloğu olamaz",
    New_Flow_Tutorials_masterflow_title: "Alt Akış Bloğu",
    New_Flow_Tutorials_masterflow_description:
      "Kullanıcı bir düğmeye dokunduğunda konuşmayı daha önce oluşturduğunuz başka bir akışa yönlendirir.",
    New_Flow_Tutorials_masterflow_usageType: "Mevcut bir akışı bir düğmenin devamı olarak yeniden kullanın",
    New_Flow_Tutorials_masterflow_feature_1: "Oluşturduğunuz tüm akışları listeler, birini seçebilirsiniz",
    New_Flow_Tutorials_masterflow_feature_2: "Seçilen akış konuşmayı bu noktadan devam ettirir",
    New_Flow_Tutorials_masterflow_tip_1: "Listede görünmesi için önce hedef akışı oluşturup kaydedin",
    New_Flow_Tutorials_masterflow_tip_2: "Akışlar arasındaki ortak yollar (destek veya fiyatlar gibi) için kullanın",
    New_Flow_Tutorials_masterflow_limitation_1: "Yalnızca girişi vardır, çıkışı yoktur; bu yüzden bu akışı sonlandırır",
    New_Flow_Tutorials_masterflow_limitation_2: "Yalnızca düğmelere bağlanabilir, normal çıkışlara bağlanamaz",
    New_Flow_Tutorials_masterflow_limitation_3: "Düzenlediğiniz akış seçilemez",
    New_Flow_Tutorials_masterflow_connection_1: "Hızlı yanıt bloğunun düğmeleri",
    New_Flow_Tutorials_masterflow_connection_2: "Düğme grubu bloğunun düğmeleri",
    New_Flow_Tutorials_masterflow_connection_3: "Galeri alt bloğunun düğmeleri",
    New_Flow_generic_block: "Galeri Bloğu (Karusel)",
    New_Flow_add_general_block: "Galeri Bloğu Ekle",
    New_Flow_add_text_block: "Metin Bloğu Ekle",
    New_Flow_add_image_block: "Görsel Bloğu Ekle",
    New_Flow_add_voice_block: "Ses Bloğu Ekle",
    New_Flow_add_quick_reply_block: "Hızlı Yanıt Ekle",
    New_Flow_add_weblink_block: "Bağlantı Ekle",
    New_Flow_upload_imageorvideo: "Görsel veya Video Yükle",
    New_Flow_upload_image: "Resim Yükle",
    New_Flow_upload_unsupported_media: "Desteklenmeyen medya formatı",
    New_Flow_uploadmaxsizeexceeded: "Dosya boyutu 50MB’ı geçmemelidir",
    New_Flow_uploadfilefailed: "Dosya yükleme başarısız oldu, tekrar deneyin",
    New_Flow_unsupportedbrowser: "Tarayıcınız video oynatma desteği sağlamıyor",
    New_Flow_micphoneaccessdenied: "Mikrofon erişimini etkinleştirin",
    New_Flow_upload_audio: "Ses Dosyası Yükle",
    New_Flow_record_voice: "Ses Kaydet",
    New_Flow_stop_record_voice: "Kaydı Durdur",
    New_Flow_areyoureadytorecord: "Kayda hazır mısınız?",
    New_Flow_voice_recording_started: "Ses kaydı devam ediyor...",
    New_Flow_add_generic_sub_block: "Alt Blok Ekle",
    New_Flow_generic_sub: "Alt Blok",
    New_Flow_add_button: "Buton Ekle",
    New_Flow_quick_reply_title_placeholder: "Hızlı Yanıt Seçeneği Başlığı",
    New_Flow_buttongroup_block: "Düğme Grubu Bloğu",
    New_Flow_add_buttongroup_block: "Düğme Grubu Ekle",
    New_Flow_buttongroup_title_placeholder: "Düğme Grubu Mesaj Metni",
    New_Flow_imagegallery_block: "Görsel Galerisi Bloğu",
    New_Flow_add_imagegallery_block: "Görsel Galerisi Ekle",
    New_Flow_imagegallery_max_reached: "Bu bloğa en fazla {{max}} görsel ekleyebilirsiniz",
    New_Flow_Tutorials_imagegallery_title: "Görsel Galerisi Bloğu",
    New_Flow_Tutorials_imagegallery_description:
      "Bu blok, kullanıcılara doğrudan mesajla birden fazla görsel (en fazla {{max}}) yüklemek ve göndermek için kullanılır.",
    New_Flow_Tutorials_imagegallery_usageType:
      "Birden fazla ürünü, fotoğraf albümlerini, önce/sonra görsellerini ve görsel koleksiyonlarını sergilemek için uygundur.",
    New_Flow_Tutorials_imagegallery_feature_1: "Tek blokta en fazla {{max}} görsel kabul eder",
    New_Flow_Tutorials_imagegallery_limitation_1:
      "Blok başına en fazla {{max}} görsel (bu sınır gelecekte artırılabilir)",
    New_Flow_message_title: "Mesaj Başlığı",
    New_Flow_message_description: "Mesaj Açıklaması",
    New_Flow_live_test_block: "Canlı Akış Testi",
    New_Flow_delete_all_blocks: "Tüm Akışı Sil",
    New_Flow_shortcuts_explain: "Çalışma akışlarını yönetmede hız ve hâkimiyeti artıran klavye kısayolları.",
    New_Flow_Tutorials_Not_Available: "Kılavuz mevcut değil",
    New_Flow_Tutorials_Not_Available_Description: "Bu düğüm için herhangi bir kılavuz mevcut değildir.",
    New_Flow_Tutorials_Usage_Type: "Kullanım Türü",
    New_Flow_Tutorials_Features: "Özellikler",
    New_Flow_Tutorials_Tips: "Kullanışlı İpuçları",
    New_Flow_Tutorials_Limitations: "Sınırlamalar",
    New_Flow_Tutorials_Connections: "Bağlantılar",
    New_Flow_unsavedChanges: "Kaydedilmemiş değişiklikleriniz var",
    New_Flow_addedNodes: "Eklenen Nodelar",
    New_Flow_removedNodes: "Kaldırılan Nodelar",
    New_Flow_modifiedNodes: "Düzenlenen Nodelar",
    New_Flow_invalidFlow_explain: "Flow geçerli değil. Lütfen kaydetmeden önce nodeları hatalar için kontrol edin",
    sendsms: "Kullanıcıya SMS gönder",
    sendtotelegram: "Kullanıcıyı Telegram’a yönlendir",
    senderusername: "Kullanıcının adını kullanarak seslen",
    addtools: "Araç Ekle",
    generatebyai: "Yapay Zeka ile Oluştur",

    //tutorials

    New_Flow_Tutorials_onmessage_title: "Akış Başlangıç Noktanız",
    New_Flow_Tutorials_onmessage_description:
      "Bu blok, akışınızın başlangıç noktasıdır. Kullanıcı Instagram dırektinize bir mesaj gönderdiğinde, bu blok tetiklenir ve akış başlar. Her otomasyonda her zaman ilk bloktur ve silinemez.",
    New_Flow_Tutorials_onmessage_feature_1: "Bir sonraki bloğa bağlanmak için tek çıkış",
    New_Flow_Tutorials_onmessage_tip_1:
      "Bu bloğun çıkışını diğer herhangi bir bloğa bağlayın. Kullanıcı herhangi bir mesaj gönderdiğinde (metin, resim, video, ses, vb.) akış başlar",
    New_Flow_Tutorials_onmessage_connection_1: "Aşağıdaki bloklara bağlanabilir:",
    New_Flow_Tutorials_onmessage_connection_2: "❌ Web Link Bloğu",
    New_Flow_Tutorials_onmessage_connection_3: "✅ Sesli Mesaj Bloğu",
    New_Flow_Tutorials_onmessage_connection_4: "✅ Metin Mesaj Bloğu",
    New_Flow_Tutorials_onmessage_connection_5: "✅ Hızlı Yanıt Bloğu",
    New_Flow_Tutorials_onmessage_connection_6: "✅ Resim & Video Bloğu",
    New_Flow_Tutorials_onmessage_connection_7: "✅ Galeri Bloğu",

    New_Flow_Tutorials_text_title: "Metin Mesaj Bloğu",
    New_Flow_Tutorials_text_description: "Bu blok, kullanıcılara metin mesajı göndermek için kullanılır.",
    New_Flow_Tutorials_text_usageType:
      "Hoşgeldin mesajları, ürün açıklamaları, SSS, bildirimler ve kullanıcı rehberliği için uygundur.",
    New_Flow_Tutorials_text_feature_1: "Tüm dilleri destekler",
    New_Flow_Tutorials_text_feature_2: "Emoji ve özel karakter kullanabilme",
    New_Flow_Tutorials_text_tip_1: "Mesajları kısa ve net yazın",
    New_Flow_Tutorials_text_tip_2: "Emojileri ölçülü kullanın",
    New_Flow_Tutorials_text_tip_3: "Uzun metinleri birkaç bölüme ayırın",
    New_Flow_Tutorials_text_tip_4: "Samimi ve dostane bir ton kullanın",
    New_Flow_Tutorials_text_tip_5: "Uygun paragraf düzenlemesi kullanın",
    New_Flow_Tutorials_text_limitation_1: "Maksimum 2200 karakter",
    New_Flow_Tutorials_text_limitation_2: "Sadece metin (dosya veya medya yok)",
    New_Flow_Tutorials_text_limitation_3: "Biçimlendirme yok (Kalın, İtalik)",
    New_Flow_Tutorials_text_connection_1: "✅ Mesaj Giriş Bloğu",
    New_Flow_Tutorials_text_connection_2: "❌ Web Link Bloğu",
    New_Flow_Tutorials_text_connection_3: "✅ Sesli Mesaj Bloğu",
    New_Flow_Tutorials_text_connection_4: "✅ Metin Mesaj Bloğu",
    New_Flow_Tutorials_text_connection_5: "✅ Hızlı Yanıt Bloğu",
    New_Flow_Tutorials_text_connection_6: "✅ Resim & Video Bloğu",
    New_Flow_Tutorials_text_connection_7: "❌ Galeri Bloğu",
    New_Flow_Tutorials_text_connection_8: "✅ Galeri Alt Dal Bloğu",

    New_Flow_Tutorials_image_title: "Görsel & Video Bloku",
    New_Flow_Tutorials_image_description:
      "Bu blok, kullanıcıya direct üzerinden görsel ve video yüklemek ve göndermek için kullanılır.",
    New_Flow_Tutorials_image_usageType:
      "Ürün tanıtımı, görsel galeriler, logo, tanıtım bannerları, eğitim ve tanıtım videoları için uygundur.",
    New_Flow_Tutorials_image_feature_1: "Görsel desteği: JPEG, PNG, GIF, WebP, SVG",
    New_Flow_Tutorials_image_feature_2: "Video desteği: MP4, WebM, OGG, MOV, AVI, MKV",
    New_Flow_Tutorials_image_feature_3: "Dosya türünü otomatik algılama",
    New_Flow_Tutorials_image_tip_1: "Yüksek kaliteli görseller kullanın",
    New_Flow_Tutorials_image_tip_2: "Büyük dosyaları yüklemeden önce sıkıştırın",
    New_Flow_Tutorials_image_tip_3: "Standart boyutlar: 1080×1080 veya 1080×1350",
    New_Flow_Tutorials_image_tip_4: "Videoları 30 saniyenin altında tutun",
    New_Flow_Tutorials_image_tip_5: "Normal görseller için JPEG, şeffaf arka plan için PNG",
    New_Flow_Tutorials_image_limitation_1: "Maksimum boyut: 50 MB",
    New_Flow_Tutorials_image_limitation_2: "Her blokta bir dosya",
    New_Flow_Tutorials_image_limitation_3: "Alışılmadık formatlar desteklenmeyebilir",
    New_Flow_Tutorials_image_connection_1: "✅ Mesaj Giriş Bloğu",
    New_Flow_Tutorials_image_connection_2: "❌ Web Link Bloğu",
    New_Flow_Tutorials_image_connection_3: "✅ Sesli Mesaj Bloğu",
    New_Flow_Tutorials_image_connection_4: "✅ Metin Mesaj Bloğu",
    New_Flow_Tutorials_image_connection_5: "✅ Hızlı Yanıt Bloğu",
    New_Flow_Tutorials_image_connection_6: "✅ Görsel & Video Bloku",
    New_Flow_Tutorials_image_connection_7: "❌ Galeri Bloğu",
    New_Flow_Tutorials_image_connection_8: "✅ Alt Galeri Bloğu",
    invalidFlowDetected: "Geçersiz akış tespit edildi! Bazı blokların girişi yok veya mesaj bloğu tek başına.",

    New_Flow_Tutorials_voice_title: "Sesli Mesaj Bloğu",
    New_Flow_Tutorials_voice_description:
      "Bu blok, kullanıcıya ses dosyası yüklemek veya canlı ses kaydı göndermek için kullanılır.",
    New_Flow_Tutorials_voice_usageType:
      "Kişisel sesli mesajlar, anlatımlı eğitimler, kısa podcast'ler ve sesli rehberler için uygundur.",
    New_Flow_Tutorials_voice_feature_1: "Format desteği: MP3, M4A, WAV, OGG, AAC",
    New_Flow_Tutorials_voice_feature_2: "Mikrofondan doğrudan kayıt",
    New_Flow_Tutorials_voice_feature_3: "Önceden kaydedilmiş ses dosyası yükleme",
    New_Flow_Tutorials_voice_tip_1: "Sessiz bir ortamda kaydedin",
    New_Flow_Tutorials_voice_tip_2: "Kısa mesajlar (1 dakikadan az) tercih edilir",
    New_Flow_Tutorials_voice_tip_3: "Göndermeden önce ses kalitesini kontrol edin",
    New_Flow_Tutorials_voice_tip_4: "Kayda başlamadan önce metninizi hazırlayın",
    New_Flow_Tutorials_voice_limitation_1: "Maksimum boyut: 50 MB",
    New_Flow_Tutorials_voice_limitation_2: "Kayıt için mikrofon erişimi gerekli",
    New_Flow_Tutorials_voice_limitation_3: "Her blokta bir dosya",
    New_Flow_Tutorials_voice_connection_1: "✅ Mesaj Giriş Bloğu",
    New_Flow_Tutorials_voice_connection_2: "❌ Web Link Bloğu",
    New_Flow_Tutorials_voice_connection_3: "✅ Sesli Mesaj Bloğu",
    New_Flow_Tutorials_voice_connection_4: "✅ Metin Mesaj Bloğu",
    New_Flow_Tutorials_voice_connection_5: "✅ Hızlı Yanıt Bloğu",
    New_Flow_Tutorials_voice_connection_6: "✅ Görsel & Video Bloku",
    New_Flow_Tutorials_voice_connection_7: "❌ Galeri Bloğu",
    New_Flow_Tutorials_voice_connection_8: "✅ Alt Galeri Bloğu",

    New_Flow_Tutorials_quickreply_title: "Hızlı Yanıt Bloğu",
    New_Flow_Tutorials_quickreply_description:
      "Bu blok, kullanıcılar için tek seferlik seçilebilir Hızlı Yanıt düğmeleri oluşturmak için kullanılır ve her düğme kullanıcıyı belirli bir akış yoluna yönlendirir.",
    New_Flow_Tutorials_quickreply_usageType:
      "Seçim menüleri, ürün kategorileri, çoktan seçmeli sorular, anketler ve arama filtreleri için uygundur.",
    New_Flow_Tutorials_quickreply_feature_1: "Her blokta maksimum 10 düğme",
    New_Flow_Tutorials_quickreply_feature_2: "Her düğmenin bağımsız bir çıktısı vardır",
    New_Flow_Tutorials_quickreply_feature_3: "Düğmeleri silme ve düzenleme imkanı",
    New_Flow_Tutorials_quickreply_tip_1: "Düğme metinlerini net ve kullanışlı yazın",
    New_Flow_Tutorials_quickreply_tip_2: "Daha iyi deneyim için 3–5 düğme",
    New_Flow_Tutorials_quickreply_tip_3: "Etiketleri kısa tutun (20 karakterden az)",
    New_Flow_Tutorials_quickreply_tip_4: "Rehberlik için başlık alanını kullanın",
    New_Flow_Tutorials_quickreply_tip_5: "Düğmeleri önem sırasına göre önceliklendirin",
    New_Flow_Tutorials_quickreply_limitation_1: "Maksimum 10 düğme",
    New_Flow_Tutorials_quickreply_limitation_2: "Düğme başlığı: Maks 40 karakter",
    New_Flow_Tutorials_quickreply_limitation_3: "Açıklama: Maks 140 karakter",
    New_Flow_Tutorials_quickreply_limitation_4: "En az bir düğme gerekli",
    New_Flow_Tutorials_quickreply_connection_1: "✅ Mesaj Giriş Bloğu",
    New_Flow_Tutorials_quickreply_connection_2: "❌ Web Link Bloğu",
    New_Flow_Tutorials_quickreply_connection_3: "✅ Sesli Mesaj Bloğu",
    New_Flow_Tutorials_quickreply_connection_4: "✅ Metin Mesaj Bloğu",
    New_Flow_Tutorials_quickreply_connection_5: "✅ Hızlı Yanıt Bloğu",
    New_Flow_Tutorials_quickreply_connection_6: "✅ Görsel & Video Bloğu",
    New_Flow_Tutorials_quickreply_connection_7: "❌ Galeri Bloğu",
    New_Flow_Tutorials_quickreply_connection_8: "✅ Galeri Alt Bloğu",

    New_Flow_Tutorials_generic_title: "Galeri (Karusel) Bloğu",
    New_Flow_Tutorials_generic_description: "Öğelerin yatay kaydırılabilir bir galerisi (karusel) oluşturun",
    New_Flow_Tutorials_generic_usageType:
      "Ürünleri, hizmet menülerini, kategorileri, ekip tanıtımını, portföyü ve seçenek karşılaştırmalarını göstermek için uygundur.",
    New_Flow_Tutorials_generic_tip_1: "Aynı boyutta resimler kullanın (örn. 1:1)",
    New_Flow_Tutorials_generic_tip_2: "Öğe sayısını 3–5 arasında tutun",
    New_Flow_Tutorials_generic_tip_3: "Başlıkları kısa ve net yazın",
    New_Flow_Tutorials_generic_tip_4: "Benzer ürünler veya karşılaştırmalar için uygundur",
    New_Flow_Tutorials_generic_limitation_1: "Her karusel için maksimum 10 öğe",
    New_Flow_Tutorials_generic_connection_1: "✅ Mesaj Giriş Bloğu",
    New_Flow_Tutorials_generic_connection_2: "✅ Galeri Alt Bloğu",
    New_Flow_Tutorials_generic_connection_3: "❌ Web Link Bloğu",
    New_Flow_Tutorials_generic_connection_4: "❌ Sesli Mesaj Bloğu",
    New_Flow_Tutorials_generic_connection_5: "❌ Metin Mesaj Bloğu",
    New_Flow_Tutorials_generic_connection_6: "❌ Hızlı Yanıt Bloğu",
    New_Flow_Tutorials_generic_connection_7: "❌ Görsel & Video Bloğu",

    New_Flow_Tutorials_genericitem_title: "Carousel Öğesi",
    New_Flow_Tutorials_genericitem_description:
      "Carousel içindeki bir öğe; resim, başlık, açıklama, link ve 3’e kadar buton içerir",
    New_Flow_Tutorials_genericitem_usageType:
      "Ürün detaylarını göstermek, hizmetleri tanıtmak, ekip gösterimi, portföy ve fiyat paketleri için uygundur.",
    New_Flow_Tutorials_genericitem_feature_1: "İsteğe bağlı web linki",
    New_Flow_Tutorials_genericitem_feature_2: "İsteğe bağlı resim: JPEG, PNG, GIF",
    New_Flow_Tutorials_genericitem_feature_3: "Video: MP4, WebM, OGG",
    New_Flow_Tutorials_genericitem_feature_4: "Bağımsız çıkışlara sahip 3’e kadar buton",
    New_Flow_Tutorials_genericitem_tip_1: "Her öğeye çekici bir resim ekleyin",
    New_Flow_Tutorials_genericitem_tip_2: "Ana mesaj için başlık, detaylar için açıklama",
    New_Flow_Tutorials_genericitem_tip_3: "Linkleri göndermeden önce test edin",
    New_Flow_Tutorials_genericitem_tip_4: "Buton metinleri kısa ve anlaşılır olsun",
    New_Flow_Tutorials_genericitem_tip_5: "Kısaltılmış link kullanmanız önerilir",
    New_Flow_Tutorials_genericitem_limitation_1: "Başlık: maksimum 140 karakter",
    New_Flow_Tutorials_genericitem_limitation_2: "Açıklama: maksimum 140 karakter",
    New_Flow_Tutorials_genericitem_limitation_3: "Maksimum 3 buton",
    New_Flow_Tutorials_genericitem_limitation_4: "Buton başlığı: maksimum 40 karakter",
    New_Flow_Tutorials_genericitem_limitation_5: "Dosya boyutu: maksimum 50 MB",
    New_Flow_Tutorials_genericitem_limitation_6: "En az bir buton zorunludur",
    New_Flow_Tutorials_genericitem_connection_1: "❌ Mesaj giriş bloğu",
    New_Flow_Tutorials_genericitem_connection_2: "✅ Galeri bloğu",
    New_Flow_Tutorials_genericitem_connection_3: "✅ Web linki bloğu",
    New_Flow_Tutorials_genericitem_connection_4: "✅ Sesli mesaj bloğu",
    New_Flow_Tutorials_genericitem_connection_5: "✅ Metin mesaj bloğu",
    New_Flow_Tutorials_genericitem_connection_6: "✅ Hızlı cevap bloğu",
    New_Flow_Tutorials_genericitem_connection_7: "✅ Resim ve video bloğu",

    New_Flow_Tutorials_weblink_title: "Web Linki Bloğu",
    New_Flow_Tutorials_phonenumbergrabber_title: "Telefon Numarası Toplayıcı Bloğu",
    New_Flow_Tutorials_phonenumbergrabber_description:
      "Bu blok bir telefon numarası alınmasını bekler ve alındığında geçerli numara olarak kaydeder.",
    New_Flow_Tutorials_phonenumbergrabber_usageType:
      "Müşteri numaralarını toplama, kayıt, sipariş takibi, danışmanlık ve satış iletişimi için uygundur.",
    New_Flow_Tutorials_phonenumbergrabber_feature_1: "Telefon numarası alınana kadar kullanıcının yanıtını bekler",
    New_Flow_Tutorials_phonenumbergrabber_feature_2: "Alınan numarayı otomatik olarak doğrular ve kaydeder",
    New_Flow_Tutorials_phonenumbergrabber_tip_1: "Bu bloktan önce bir metin bloğuyla kullanıcıdan numarasını isteyin",
    New_Flow_Tutorials_phonenumbergrabber_tip_2: "Beklenen numara biçimini belirtin (ör. ülke koduyla)",
    New_Flow_Tutorials_phonenumbergrabber_tip_3: "Bu bloktan sonra bir onay veya teşekkür mesajı gönderin",
    New_Flow_Tutorials_phonenumbergrabber_limitation_1: "Akışın ilk bloğu olamaz",
    New_Flow_Tutorials_phonenumbergrabber_limitation_2: "Yalnızca bir giriş ve bir çıkışı vardır",
    New_Flow_Tutorials_phonenumbergrabber_limitation_3: "Yalnızca geçerli numaralar kaydedilir",
    New_Flow_Tutorials_phonenumbergrabber_connection_3: "❌ Galeri Alt Dal Bloğu",
    New_Flow_Tutorials_phonenumbergrabber_connection_2: "❌ Hızlı Yanıt Bloğu",
    New_Flow_Tutorials_phonenumbergrabber_connection_1: "❌ Mesaj Giriş Bloğu (ilk blok olamaz)",
    New_Flow_Tutorials_weblink_description: "Kullanıcının tarayıcısında açılan tıklanabilir web linki gönderir",
    New_Flow_Tutorials_weblink_usageType:
      "Web sitesi, ürün sayfası, mağaza, kayıt formu, açılış sayfaları ve makaleler için uygundur.",
    New_Flow_Tutorials_weblink_feature_1: "URL otomatik doğrulama",
    New_Flow_Tutorials_weblink_feature_2: "WWW ile/olmadan link desteği",
    New_Flow_Tutorials_weblink_tip_1: "Kısaltılmış link kullanmanız önerilir",
    New_Flow_Tutorials_weblink_tip_2: "Linkleri göndermeden önce test edin",
    New_Flow_Tutorials_weblink_tip_3: "Linkler mobil uyumlu olmalı",
    New_Flow_Tutorials_weblink_tip_4: "Çok fazla yönlendirmeden kaçının",
    New_Flow_Tutorials_weblink_tip_5: "Tercihen HTTPS kullanın",
    New_Flow_Tutorials_weblink_limitation_1: "Sadece http:// veya https:// geçerlidir",
    New_Flow_Tutorials_weblink_limitation_2: "Açıklama eklenemez",
    New_Flow_Tutorials_weblink_limitation_3: "Yerel linkler (file://) desteklenmez",
    New_Flow_Tutorials_weblink_connection_1: "⬅️ Giriş: Alt galeri bloğu",
    New_Flow_Tutorials_weblink_connection_2: "❌ Çıkış yok (Akış sonu)",

    // #region AIFlow Section

    // #region Notification Section
    Notify_Ok: "İşlem başarıyla tamamlandı",
    Notify_InternalException: "Sistemde bir hata oluştu",
    Notify_CannotSendSmsNow: "Şu anda SMS gönderilemiyor",
    Notify_InvalidPhoneNumber: "Girilen telefon numarası geçersiz",
    Notify_InvalidCountryCode: "Girilen ülke kodu geçersiz",
    Notify_PhoneNumberNotAvailableInThisCountry: "Bu numara seçilen ülkede kullanılamaz",
    Notify_InstagramerIdNotExist: "Instagram kullanıcısı bulunamadı",
    Notify_EmptyProductList: "Ürün listesi boş",
    Notify_InvalidVerificationCode: "Girilen doğrulama kodu yanlış",
    Notify_LowQuality: "İçerik kalitesi düşük",
    Notify_CannotEmptyChildren: "Alt öğeler silinemez",
    Notify_InvalidAspectRatio: "Girilen en boy oranı geçersiz",
    Notify_InvalidMediaCodec: "Medya kodeği desteklenmiyor",
    Notify_InvalidMediaType: "Medya türü desteklenmiyor",
    Notify_MediaUrlNotAccessible: "Medya URL'si erişilebilir değil",
    Notify_CannotCreatePrePostNow: "Şu anda ön gönderi oluşturulamaz",
    Notify_InvalidMediaContent: "Medya içeriği geçersiz",
    Notify_Unexpected: "Beklenmeyen bir hata oluştu",
    Notify_TooManyRequestForImageHashtagGenerator: "Görsel hashtag üretimi için çok fazla istek yapıldı",
    Notify_LoginFailed: "Giriş başarısız oldu, lütfen tekrar deneyin",
    Notify_NullUserId: "Kullanıcı ID girilmedi",
    Notify_RealtimeSocketNotExist: "Sunucuya bağlantı yok",
    Notify_PushSocketNotExist: "Bağlantı yok",
    Notify_InstaApiNotFoundForConnect: "Instagram sunucularına bağlantı yok",
    Notify_EmptyHashtagList: "Hashtag listesi boş",
    Notify_InvalidHashtagListId: "Hashtag listesi ID geçersiz",
    Notify_DeleteHashtagFail: "Hashtag silinemedi",
    Notify_InvalidBase64Content: "Base64 içeriği geçersiz",
    Notify_InvalidTermsAndConditionSvgType: "Şartlar geçersiz",
    Notify_InvalidLotteryAnnouncementBannerId: "Çekiliş banner ID geçersiz",
    Notify_InvalidLotteryAnnouncementBannerStr: "Çekiliş banner metni geçersiz",
    Notify_InvalidPostId: "Post ID geçersiz",
    Notify_TooSoonLotteryInfo: "Çekiliş bilgisi çok erken gönderildi",
    Notify_InvalidDirectParams: "Direct parametreleri geçersiz",
    Notify_NoInstagramerExists: "Hiçbir Instagram hesabı bulunamadı",
    Notify_PropertyNotFoundOrNull: "Öğe bulunamadı veya boş",
    Notify_ReachNumberOfPinDirect: "Sabitlenmiş mesajların maksimum sayısına ulaşıldı",
    Notify_InvalidStoryId: "Story ID geçersiz",
    Notify_MaxPrePostReach: "Maksimum ön paylaşımlar sayısına ulaşıldı",
    Notify_InvalidDraftId: "Taslak ID geçersiz",
    Notify_InvalidPrePostId: "Ön paylaşımlar ID geçersiz",
    Notify_ReachHashtagListLimit: "Maksimum hashtag listesi sayısına ulaşıldı",
    Notify_EmptyUsername: "Kullanıcı adı girilmedi",
    Notify_TooManyRequestForPageHashtagAnalysis: "Sayfa hashtag analizi için çok fazla istek yapıldı",
    Notify_PasswordRequired: "Şifre gerekli",
    Notify_PackageRequiredInThisTime: "Aktif paket gerekli",
    Notify_FeatureRequiredInThisTime: "Bu özellik etkin olmalı",
    Notify_NoShopperExist: "Hiçbir satıcı bulunamadı",
    Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount:
      "Doğrulanmış veya özel hesaplar için giriş yapmadan rastgele takipçi çekilişi yapılamaz",
    Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount:
      "Özel hesaplar için giriş yapmadan etkileşim çekilişi yapılamaz",
    Notify_InvalidLinkId: "Bağlantı ID geçersiz",
    Notify_ReachMaxBioLink: "Biyografi linklerinin maksimum sayısına ulaşıldı",
    Notify_OnlyBusinessAccountHasThisAccess: "Bu erişim yalnızca işletme hesapları için geçerlidir",
    Notify_NoYoutubeChannelFound: "Hiçbir YouTube kanalı bulunamadı",
    Notify_CannotGetYoutubeRightNow: "Şu anda YouTube bilgisi alınamıyor",
    Notify_AparatUsernameNotFound: "Aparat kullanıcı adı bulunamadı",
    Notify_AparatChannelHasNotAnyVideo: "Aparat kanalı herhangi bir video içermiyor",
    Notify_InvalidYoutubeChannelId: "YouTube kanal ID geçersiz",
    Notify_NoAparatChannelFound: "Hiçbir Aparat kanalı bulunamadı",
    Notify_CannotGetAparatRightNow: "Şu anda Aparat bilgisi alınamıyor",
    Notify_NotSettedCustomDomain: "Özel alan adı ayarlanmadı",
    Notify_CannotStoryWithoutWinnerBanner: "Kazanan banner olmadan Story oluşturulamaz",
    Notify_ExceedMaxStoryWinnerLotteryBanner: "Story kazanan banner sayısı sınırı aştı",
    Notify_LotteryOnProcessingOrEnded: "Çekiliş işleniyor veya sona erdi",
    Notify_CannotAbortLotteryOneHourBefore: "Çekilişi başlatmadan bir saat önce iptal edemezsiniz",
    Notify_CannotAbortFollowerLottery: "Takipçi çekilişi iptal edilemez",
    Notify_InvalidImageOrExceedMaxSize: "Resim geçersiz veya maksimum boyutu aşıyor",
    Notify_ExceedLoginAttempt: "Giriş denemeleri maksimum sayıyı aştı",
    Notify_NotExistComment: "Yorum bulunamadı",
    Notify_UserNotFound: "Kullanıcı bulunamadı",
    Notify_ExistInstagramerBefore: "Bu Instagram hesabı zaten kayıtlı",
    Notify_CannotChangeBusinessAccountType: "İşletme hesabı türü değiştirilemez, lütfen destek ile iletişime geçin",
    Notify_InvalidProductId: "Girilen ürün ID'si geçerli değil",
    Notify_InvalidTrendHashtagPeriod: "Seçilen trend hashtag dönemi geçerli değil",
    Notify_InvalidLanguageId: "Dil ID'si geçerli değil",
    Notify_CannotStoryWithoutTermsBanner: "Story, şartlar bannerı olmadan oluşturulamaz",
    Notify_ExceedMaxStoryTermsLotteryBanner: "Story çekiliş şart bannerlarının sayısı izin verilen sınırı aşıyor",
    Notify_LotteryTermsIsNull: "Çekiliş şartları kayıtlı değil",
    Notify_CanShareTermsBefore6HoursOfStartLottery:
      "Şartlar sadece çekiliş başlamadan 6 saat öncesine kadar paylaşılabilir",
    Notify_CanShareTermForOnlyDefinedStatusLotteries:
      "Şart paylaşımı yalnızca tanımlı durumdaki çekilişler için aktiftir",
    Notify_SharedRemainingTimeBefore: "Kalan süre zaten paylaşılmış",
    Notify_ShareRemainingTimeOnlyActiveForScoreLottery:
      "Kalan sürenin paylaşımı yalnızca puanlı çekilişler için aktiftir",
    Notify_CanShareTermsBefore1HoursOfStartLottery:
      "Şartlar sadece çekiliş başlamadan 1 saat öncesine kadar paylaşılabilir",
    Notify_InvalidSubProductIds: "Alt ürün ID'leri geçerli değil",
    Notify_ReachMaxProductMedia: "Bu ürün için maksimum medya sayısına ulaşıldı",
    Notify_InvalidMediaProductId: "Medya ürün ID'si geçerli değil",
    Notify_AccountNotABusiness: "Bu hesap işletme hesabı değil",
    Notify_NotFoundProductWithThisTempId: "Bu geçici ID ile ürün bulunamadı",
    Notify_InvalidAvailabilityStatus: "Girilen erişilebilirlik durumu geçerli değil",
    Notify_InvalidIbanNumber: "Girilen IBAN numarası geçerli değil",
    Notify_ExistedIbanNumber: "Bu IBAN numarası zaten kayıtlı",
    Notify_IbanMethodNotAvailableForNotTomanPriceUser: "IBAN yöntemi, Toman olmayan kullanıcılar için aktif değil",
    Notify_SearchQueryIsEmpty: "Arama sorgusu boş",
    Notify_ExceedMaxInEachCard: "Her karttaki öğe sayısı izin verilen sınırı aşıyor",
    Notify_ProductNotAlbumPost: "Bu ürün bir albüm Post olarak kayıtlı değil",
    Notify_InvalidChildrenId: "Çocuk ID'si geçerli değil",
    Notify_NotAvailableProduct: "Ürün şu anda mevcut değil",
    Notify_ExceedStockCount: "Seçilen miktar stoktan fazla",
    Notify_CannotUnloadAnInstanceProduct: "Ürünün bir örneğini boşaltmak mümkün değil",
    Notify_InvalidCategoryId: "Kategori ID'si geçerli değil",
    Notify_NotFoundAnyProductOnThisCategory: "Bu kategoride ürün bulunamadı",
    Notify_NotFoundAnyNextProduct: "Sonraki ürün bulunamadı",
    Notify_NotFoundAnyPreviousProduct: "Önceki ürün bulunamadı",
    Notify_InvalidItemId: "Öğe ID'si geçerli değil",
    Notify_IpInvalid: "Girilen IP geçerli değil",
    Notify_InstagramRedirectInTenSeconds: "10 saniye içinde otomatik olarak Instagram'a yönlendirileceksiniz",
    Notify_InstagramRedirect: "Instagram'a yönlendiriliyor",
    Notify_InstagramRedirectExplain: "IP adresiniz geçerli olmadığı için VPN'inizin etkin olduğundan emin olun",
    Notify_ThisInstagramAccountAddedBefore: "Bu Instagram hesabı zaten eklenmiş",
    Notify_InvalidTicketId: "Bilet ID'si geçerli değil",
    Notify_ExpiredSignature: "İmza süresi dolmuş",
    Notify_Forbidden: "Yetkisiz erişim",
    Notify_ConnectedInstagramPageNotFound: "Bağlı Instagram sayfası bulunamadı",
    Notify_AllInstagramAccountConnectedAddedBefore: "Tüm bağlı Instagram hesapları zaten eklenmiş",
    Notify_SelectInstagramPageToConnect: "Bağlanacak Instagram sayfasını seçiniz",
    Notify_InstagramRedirectRoleNotFound: "Instagram yönlendirme rolü bulunamadı",
    Notify_FacebookLoginNotFound: "Facebook girişi bulunamadı",
    Notify_SelectedPageNotFound: "Seçilen sayfa bulunamadı",
    Notify_ShouldConnectInstaPageAgain: "Instagram sayfasını yeniden bağlamanız gerekiyor",
    Notify_InvalidProductSuggestionId: "Ürün öneri ID'si geçerli değil",
    Notify_NotSavedSuggestions: "Öneriler kaydedilmedi",
    Notify_ExistedSuggestedMedia: "Bu önerilen medya zaten kayıtlı",
    Notify_InvalidUploadMediaUrl: "Medya yükleme URL'si geçerli değil",
    Notify_SuggestedPostAutoReplyKeyNotExist: "Önerilen Post otomatik yanıt anahtarı bulunamadı",
    Notify_UploadingTimeIsSoSoon: "Yükleme zamanı çok erken",
    Notify_InvalidPreStoryId: "Pre-Story ID geçerli değil",
    Notify_NotProvidedInstagramerId: "Instagramer ID sağlanmadı",
    Notify_InvalidInstagramerId: "Instagramer ID geçerli değil",
    Notify_InvalidThreadId: "Thread ID geçerli değil",
    Notify_InvalidLiveMediaId: "Canlı medya ID geçerli değil",
    Notify_NotCreatedExportComment: "Yorum çıktısı oluşturulmadı",
    Notify_CreateExportAvailableWith24HourPeriod: "Çıktı oluşturma işlemi her 24 saatte bir yapılabilir",
    Notify_NotSetted: "Ayar yapılmamış",
    Notify_ExceedGeneralAutoReplyCount: "Genel otomatik yanıt sayısı sınırı aştı",
    Notify_InvalidTransactionId: "İşlem ID geçerli değil",
    Notify_CannotRenewalPackageWith1MonthTimeExist: "1 aylık paketi şu anda yenileyemezsiniz",
    Notify_CannotDeleteCurrentSession: "Mevcut oturum silinemiyor",
    Notify_InvalidSessionId: "Oturum ID geçerli değil",
    Notify_CannotDeleteCurrentSessionForNewSessionFor1Day:
      "Yeni bir oturum oluşturmak için mevcut oturum 1 gün boyunca silinemez",
    Notify_UpgradedBefore: "Bu hesap daha önce yükseltildi",
    Notify_PermissionNotExist: "İzin mevcut değil",
    Notify_NotExistUser: "Kullanıcı bulunamadı",
    Notify_UserAlreadyAsPartner: "Kullanıcı zaten partner admin olarak kayıtlı",
    Notify_ReachMaxPartnerCount: "Maksimum partner admin sayısına ulaşıldı",
    Notify_InvalidPartnerRoleProvided: "Verilen partner admin rolü geçerli değil",
    Notify_PartnerRolesLengthIsZero: "Partner admin için rol tanımlanmamış",
    Notify_PartnerNotExist: "Partner admin bulunamadı",
    Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf: "Kendinizi partner admin olarak seçemezsiniz",
    Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow: "Partner adminin süresi en az 1 saat sonra olmalıdır",
    Notify_PartnerNameCannotExceed100: "Partner admin adı 100 karakteri geçemez",
    Notify_ProductIsMultiSubproducted: "Bu ürün birden fazla alt ürün içeriyor",
    Notify_InvalidSubProductId: "Alt ürün ID'si geçerli değil",
    Notify_ProductIdOutOfStock: "Ürün stokta yok",
    Notify_SubProductIdRequired: "Alt ürün ID'si gereklidir",
    Notify_CardIsEmpty: "Kart boş",
    Notify_InvalidAddressId: "Adres ID'si geçerli değil",
    Notify_ExceedTotalCreateAddress: "İzin verilen maksimum adres sayısını aştınız",
    Notify_NotSupportedCountry: "Seçilen ülke desteklenmiyor",
    Notify_CannotFetchAddressInThisEndpoint: "Bu uç noktada adres alınamıyor",
    Notify_InvalidPostalCode: "Posta kodu geçerli değil",
    Notify_NeedCompleteAddress: "Tam adres girişi gereklidir",
    Notify_CannotBuyFromYourSelf: "Kendinizden satın alamazsınız",
    Notify_AllReadyIsBusiness: "Bu hesap zaten işletme olarak kayıtlı",
    Notify_InvalidBusinessType: "İşletme hesabı türü geçerli değil",
    Notify_UserAlreadyAuthorized: "Kullanıcı zaten yetkilendirilmiş",
    Notify_InstagramerNotInfluencer: "Instagramer bir influencer değil",
    Notify_InstagramerNotShopper: "Instagramer satıcı değil",
    Notify_AuthorizedInstagramerBefore: "Bu Instagramer zaten yetkilendirilmiş",
    Notify_UserNotAuthorizedYet: "Kullanıcı henüz yetkilendirilmedi",
    Notify_InstagramerNotAuthorized: "Instagramer yetkilendirilmemiş",
    Notify_InvalidBankCardNumber: "Banka kartı numarası geçerli değil",
    Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber: "Telefon numarasının sahibi ulusal numara ile eşleşmiyor",
    Notify_CouponCodeAlreadyExists: "Kupon kodu zaten mevcut",
    Notify_InvalidCouponId: "Kupon ID'si geçerli değil",
    Notify_CannotChangeShowPrivateCouponInBio: "Bio'da özel kupon gösterimini değiştiremezsiniz",
    Notify_InvalidCouponCode: "Kupon kodu geçerli değil",
    Notify_CouponForAnotherPerson: "Kupon başka birine ait",
    Notify_CouponExpired: "Kuponun süresi dolmuş",
    Notify_CouponDeleted: "Kupon silindi",
    Notify_CouponUsedUp: "Kupon kullanılmış",
    Notify_InvalidUsernameSearchQuery: "Kullanıcı adı arama sorgusu geçersiz",
    Notify_PreviouslyAddedShopAddress: "Bu mağaza adresi daha önce eklenmiş",
    Notify_NotSettedShopperAddress: "Alıcı adresi ayarlanmamış",
    Notify_NotExistAnyLogesticInYourCountry: "Ülkenizde lojistik sistemi yok",
    Notify_InvalidLogesticIds: "Lojistik ID'leri geçersiz",
    Notify_LogsticsNotSetted: "Lojistik ayarlanmamış",
    Notify_NotCommpletedAllBusinessVerification: "Tüm iş doğrulamaları tamamlanmadı",
    Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic:
      "Bu paket seçilen mevcut lojistik tarafından desteklenmiyor",
    Notify_NotSupportedLogestic: "Seçilen lojistik desteklenmiyor",
    Notify_ExceedLogesticHeight: "Paketin yüksekliği lojistik sınırını aşıyor",
    Notify_ExceedLogesticWidth: "Paketin genişliği lojistik sınırını aşıyor",
    Notify_ExceedLogesticLength: "Paketin uzunluğu lojistik sınırını aşıyor",
    Notify_ExceedLogesticTotalLength: "Paketin toplam uzunluğu lojistik sınırını aşıyor",
    Notify_ExceedLogesticWeight: "Paketin ağırlığı lojistik sınırını aşıyor",
    Notify_UserAddressesIsEmptyOrNotSetDefaultAddress: "Kullanıcı adresleri boş veya varsayılan adres ayarlanmamış",
    Notify_NotSupportedBoxByThisDimensions: "Bu boyutlarda kutu desteklenmiyor",
    Notify_CannotAvailableOutOfStackProduct: "Stok dışı ürün mevcut yapılamaz",
    Notify_YouAreDeadInCivilRegistration: "Medeni kayıtta ölü olarak kaydedildiniz",
    Notify_InstagramerAlreadyAuthorized: "Instagramer zaten yetkilendirilmiş",
    Notify_ThreadShouldBeActiveForSendMessage: "Mesaj göndermek için sohbet aktif olmalıdır",
    Notify_PreviouslyClosedTicket: "Bilet daha önce kapatılmış",
    Notify_NotMatchedCart: "Sepet eşleşmiyor",
    Notify_PhoneNumberNotBlongsNationalNumber: "Telefon numarası ulusal numara ile eşleşmiyor",
    Notify_NotMatchedCardNumberAndIdentity: "Kart numarası ve kimlik bilgileri eşleşmiyor",
    Notify_SuspendedShop: "Bu mağaza askıya alınmış, lütfen destek ile iletişime geçin",
    Notify_LogesticIdNotSpecifiedForaPostParcel: "Posta paketi için lojistik ID belirtilmemiş",
    Notify_LogesticNotInAvailableLogestics: "Seçilen lojistik mevcut lojistik listesinde yok",
    Notify_ExceedProductReportForLast24Hour: "Son 24 saatteki ürün rapor sayısı sınırı aşıyor",
    Notify_PreviouslyReportedThisProduct: "Bu ürünü daha önce bildirdiniz",
    Notify_InvalidOrderId: "Sipariş ID geçersiz",
    Notify_NotPendingPayRequest: "Ödeme talebi beklemede değil",
    Notify_NotExistShopAddress: "Mağaza adresi bulunamadı",
    Notify_InvalidOrderStatus: "Sipariş durumu geçersiz",
    Notify_CancelInvoiceFailed: "Fatura iptali başarısız",
    Notify_PaymentSystemNotSupportedThisPriceType: "Ödeme sistemi bu fiyat türünü desteklemiyor",
    Notify_InvalidSentOrderType: "Gönderilen sipariş türü geçersiz",
    Notify_InvalidParcelId: "Paket ID geçersiz",
    Notify_AddedParcelIdBefore: "Paket ID daha önce eklenmiş",
    Notify_InvoiceNotOnPaid: "Fatura henüz ödenmemiş",
    Notify_CreatedSystemTicketOnOrderBefore: "Bu sipariş için sistem bileti zaten oluşturulmuş",
    Notify_PaymentServiceNotResponding: "Ödeme servisi şu anda yanıt vermiyor",
    Notify_YouAreNotAdmin: "Sen admin değilsin",
    Notify_YouAreNotASubAdmin: "Sen alt admin değilsin",
    Notify_InvalidFbId: "Geçersiz Facebook ID",
    Notify_InvalidFeatureId: "Geçersiz özellik ID",
    Notify_InActiveFeature: "Bu özellik devre dışı",
    Notify_FeaturePaused: "Bu özellik duraklatıldı",
    Notify_InvalidPromptInput: "Geçersiz prompt girişi",
    Notify_PromptNotGenerated: "Prompt oluşturulmadı",
    Notify_AIGeneratorFailed: "AI üretici hata ile karşılaştı",
    Notify_NotExecutedPromptForCommentYet: "Yorum için prompt henüz çalıştırılmadı",
    Notify_InstagramPermissionNotExist: "Instagram izni mevcut değil",
    Notify_InvalidTimeZone: "Geçersiz saat dilimi",
    Notify_PromptCaptionExampleNotGenerated: "Prompt başlık örneği oluşturulmadı",
    Notify_InvalidMasterFlowId: "Geçersiz ana akış ID'si",
    Notify_InvalidFlowId: "Geçersiz akış ID'si",
    Notify_EmptySubFlows: "Alt akışlar boş",
    Notify_InvalidFlowObject: "Geçersiz akış nesnesi",
    Notify_InvalidMasterFlowTitle: "Geçersiz ana akış başlığı",
    Notify_InvalidPromptId: "Geçersiz prompt ID'si",
    Notify_ExceedThreadTokenLimit: "Bu konuşma için token sınırı aşıldı",
    Notify_InvalidMediaId: "Geçersiz medya ID'si",
    Notify_InvalidLotteryId: "Geçersiz piyango ID'si",
    Notify_CannotAbortNonUpcomingLottery: "Yaklaşmayan piyangoları şu anda iptal edemezsiniz",
    Notify_CommentCountExceedFreeExport: "Yorum sayısı ücretsiz piyango için izin verilen sınırı aşıyor",
    Notify_InvalidReserveFeatureId: "Geçersiz rezerv özellik ID'si",
    Notify_CannotRenewalThisFeatureNow: "Bu özelliği şu anda yenileyemezsiniz",
    Notify_InvalidLotteryStatus: "Piyango durumu değişiklik için geçerli değil",
    Notify_PublishedLotteryBannerBefore: "Piyango banner'ı daha önce yayınlandı",
    Notify_LotteryWinnerBannerIsNull: "Piyango kazanan banner'ı mevcut değil",
    Notify_InvalidCustomPromptSigniture: "Geçersiz özel istem imzası",
    Notify_ServiceTemporarilyUnavailable: "Hizmet geçici olarak kullanılamıyor",
    Notify_PageSummaryNotGenerated:
      "Brancy, sayfanızı analiz etmek için daha fazla veriye ihtiyaç duyuyor.\nLütfen sabırlı olun.",
    Notify_GenerateAIFail: "Yapay zeka üretimi başarısız oldu",
    Notify_InvalidPageAnalysis: "Geçersiz sayfa analizi",
    Notify_InvalidCustomPrompt: "Geçersiz özel istem",
    Notify_AIModelNotSupportImage: "Yapay zeka modeli görüntüleri desteklemiyor",
    Notify_PromptNotSupportImage: "İstem görüntüleri desteklemiyor",
    Notify_AIModelNotSupportAudio: "Yapay zeka modeli sesi desteklemiyor",
    Notify_PromptNotSupportVoice: "İstem ses desteklemiyor",
    Notify_AIModelNotSupportVideo: "Yapay zeka modeli videoyu desteklemiyor",
    Notify_InvalidPrompt: "Geçersiz istem",
    Notify_InvalidImageGeneratorInput: "Geçersiz görüntü oluşturucu girişi",
    Notify_InSuffcientNumberOfImage: "Yetersiz görüntü sayısı",
    Notify_CreateImageExceedLimit: "Görüntü oluşturma limiti aşıldı",
    Notify_InvalidPromptType: "Geçersiz istem türü",
    Notify_UnSupportedAIInputType: "Desteklenmeyen yapay zeka giriş türü",
    Notify_UnSupportedOrientationType: "Desteklenmeyen yönelim türü",
    Notify_SoraFailedAiCall: "Sora yapay zeka çağrısı başarısız oldu",
    Notify_AIVideoSecondNotSupported: "Yapay zeka video süresi desteklenmiyor",
    Notify_FailedToTraslateDescription: "Açıklama çevirilemedi",
    Notify_FailedToGenerateEmbedVector: "Gömme vektörü oluşturulamadı",
    Notify_NotGeneratedSummaryYet: "Özet henüz oluşturulmadı",
    Notify_NoEventsFoundForTheGivenTimeRange: "Belirtilen zaman aralığında etkinlik bulunamadı",
    Notify_NoEventsFoundForThisPrompt: "Bu istem için etkinlik bulunamadı",
    Notify_PageAnalysisNotExist: "Sayfa analizi mevcut değil",
    Notify_NoEventIdeaGenerated: "Etkinlik fikri oluşturulmadı",
    Notify_PhoneNumberAddedBefore: "Bu telefon numarası daha önce eklendi",
    Notify_WhatsAppCodeSendedBeforeAndWait1Day: "WhatsApp kodu daha önce gönderildi. Lütfen bir gün bekleyin",
    Notify_WhatsAppCodeNotRequested: "WhatsApp doğrulama kodu talep edilmedi",
    Notify_WhatsAppCodeMaxInvalidCountReach: "Maksimum geçersiz WhatsApp kodu denemesine ulaşıldı",
    Notify_UserWithThisPhoneNumberAlreadyExist: "Bu telefon numarasına sahip bir kullanıcı zaten mevcut",
    Notify_InvalidAIToolId: "Geçersiz yapay zeka aracı kimliği",
    Notify_AIToolParameterRequired: "Yapay zeka aracı parametresi gereklidir",
    Notify_AIToolParameterNotRequired: "Bu yapay zeka aracı parametre kabul etmiyor",
    Notify_ExceedDailyLimit: "Günlük limit aşıldı",
    Notify_CannotGetTwitchRightNow: "Twitch verileri şu anda alınamıyor",
    Notify_InvalidTwitchChannelId: "Geçersiz Twitch kanal kimliği",
    Notify_PhoneNumberRequired: "Telefon numarası gereklidir",
    Notify_NotVerifiedHost: "Sunucu doğrulanmamış",
    Notify_NotBusinesser: "Bu kullanıcı işletme sahibi değil",
    Notify_NotFoundAnySuggestedCategory: "Önerilen kategori bulunamadı",
    Notify_NoInvoiceExist: "Fatura mevcut değil",
    Notify_InvalidMediaAiCreatorKey: "Geçersiz yapay zeka modeli",
    Notify_InvalidMediaAiVersionKey: "Geçersiz yapay zeka sürümü",
    Notify_InvalidMediaAiRequestModel: "Geçersiz yapay zeka medya istek modeli",
    Notify_MediaAIError: "Yapay zeka medyası oluşturulurken bir hata oluştu",
    Notify_TwitchChannelDoestHaveAnyVideo: "Bu Twitch kanalında hiç video yok",
    Notify_CouponAlreadyDeleted: "Bu kupon zaten silinmiş",
    Notify_CouponNotDeleted: "Bu kupon silinmemiş",
    Notify_ExceedSubFlowCount: "Maksimum alt akış sayısı aşıldı",
    Notify_ExceedFlowDepth: "Maksimum akış derinliği aşıldı",
    Notify_ExceedFlowItemCount: "Maksimum akış öğesi sayısı aşıldı",
    Notify_ExceedFlowMediaAudioCount: "Akıştaki maksimum medya ve ses sayısı aşıldı",
    Notify_OneFlowButtonHasEmptyItem: "Düğmelerden birinin akışı yok",
    InternalNotify_Ok: "İşlem başarıyla tamamlandı",
    InternalNotify_RepetitiveHashtagInput: "Girilen hashtag tekrar ediyor",
    InternalNotify_NotFoundDevice: "Cihaz bulunamadı",
    InternalNotify_EmptyHashtagList: "Boş liste oluşturulamaz",
    InternalNotify_CannotCreatePrePostNow: "Şu anda ön-post oluşturamazsınız",
    InternalNotify_PrivateAccountSelectedForCheckHashtag: "Özel bir hesap analiz için seçilemez",
    InternalNotify_InstagramLoginRequired: "Bu seçenek Instagram girişini gerektirir",
    InternalNotify_InstagramLoginRequiredForVerifiedAccount:
      "Bu seçenek doğrulanmış hesaplar için Instagram girişini gerektirir",
    InternalNotify_PrivateOrVerifiedSponsor: "Özel veya doğrulanmış bir hesap sponsor olarak seçilemez",
    InternalNotify_StartUploadingPost: "Post yükleniyor",
    InternalNotify_UploadingPostError: "Post yüklenirken hata oluştu",
    InternalNotify_PostUploaded: "Post yüklendi, görmek için sayfayı yenileyin",
    InternalNotify_ExceededMedia: "Medya sayısı sınırı aştı",
    InternalNotify_More4IceBreaker: "4'ten fazla hızlı konuşma yapamazsınız",
    InternalNotify_CopyLink: "Linkiniz kopyalandı",
    InternalNotify_copy: "Bilgiler başarıyla kopyalandı",
    InternalNotify_CopyTrackingpost: "Paket takip kodunuz kopyalandı",
    InternalNotify_Network: "Ağ bağlantı hatası",
    InternalNotify_TimeExpire: "Kayıt yapılamıyor, süre doldu",
    InternalNotify_ExceedPermittedHashtagNumber: "Hashtag sayısı izin verilen sınırı aşıyor",
    InternalNotify_UnexpectedError: "Beklenmeyen bir hata oluştu",
    InternalNotify_CopyToClipboard: "Bilgileriniz zaten panoya kopyalanmış",
    InternalNotify_ExceedPermittedUploadMedia: "Medya sayısı izin verilen sınırı aşıyor",
    InternalNotify_FillRedBorderFields: "Kırmızı çerçeveli alanları doldurun",
    InternalNotify_RepeatedVariation: "En az iki öğe tekrar ediyor",
    InternalNotify_NeedOneProduct: "En az bir ürün gereklidir",
    InternalNotify_UploadMedia: "Medya yüklemede sorun var",
    InternalNotify_TurnOnProxy: "Geçerli bir IP kullanmalısınız",
    InternalNotify_ExceedPermittedLiveTime: "Canlı yayın süresi izin verilen sınırı aştı",
    InternalNotify_CommentDisabled: "Yorumlar devre dışı bırakıldığında işlem yapamazsınız",
    InternalNotify_ExceedSelectedCollaboratorPage: "Seçilen işbirlikçi sayfası izin verilen sınırı aşıyor",
    InternalNotify_RepetitiveCollaboratorPage: "Bu kullanıcı adı zaten seçildi",
    InternalNotify_ExceedPermittedSizeOfImage: "Resim boyutu izin verilen sınırı aşıyor",
    InternalNotify_ExceedPermittedAspectRatioAlbum: "Albüm video en-boy oranı izin verilen sınırı aştı",
    InternalNotify_ExceedPermittedSizeOfVideoAlbum: "Albüm video boyutu izin verilen sınırı aşıyor",
    InternalNotify_ExceedPermittedDurationOfVideoAlbum: "Albüm video süresi izin verilen sınırı aşıyor",
    InternalNotify_ExceedPermittedAspectRatioReels: "Reels en-boy oranı izin verilen sınırı aşıyor",
    InternalNotify_ExceedPermittedSizeOfVideoReels: "Reels boyutu izin verilen sınırı aşıyor",
    InternalNotify_ExceedPermittedDurationOfVideoReels: "Reels süresi izin verilen sınırı aşıyor",
    InternalNotify_NotPermittedMediaType: "Medya türü izin verilen tür değil",
    InternalNotify_InvalidMetaData: "Meta veriler geçerli değil",
    InternalNotify_ExceedSelectedMaxTaggedPeople: "Etiketlenen kişi sayısı izin verilen limiti aşıyor",
    InternalNotify_ExceedSelectedMaxHashtags: "Seçilen hashtag sayısı izin verilen limiti aşıyor",
    InternalNotify_ExistedInCollaborate: "Bu kullanıcı adı zaten işbirlikçilerin arasında mevcut ve ilk slaytta olamaz",
    InternalNotify_ExceedPermittedAspectRatioStory: "Story en-boy oranı izin verilen limiti aşıyor",
    InternalNotify_ExceedPermittedSizeOfVideoStory: "Story video boyutu izin verilen limiti aşıyor",
    InternalNotify_ExceedPermittedWidthOfVideo: "Video genişliği izin verilen limiti aşıyor",
    InternalNotify_ExceedPermittedDurationOfVideoStory: "Story video süresi izin verilen limiti aşıyor",
    InternalNotify_BelowMinimumDurationOfVideoStory: "Hikaye videosu en az 3 saniye uzunluğunda olmalıdır",
    InternalNotify_ExceedPermittedSpecificWordForAutoreply:
      "Otomatik yanıt için özel kelime sayısı izin verilen limiti aşıyor",
    InternalNotify_ExceedPermittedAspectRatioImage: "Görsel en-boy oranı izin verilen limiti aşıyor",
    InternalNotify_Success: "İşlem başarıyla tamamlandı",
    InternalNotify_CreateExportAvailableWith24HourPeriod: "24 saatlik süre ile çıktı oluşturma mümkün",
    InternalNotify_SaveIceBreaker: "Başarıyla eklendi",
    InternalNotify_deleteIceBreaker: "Başarıyla silindi",
    InternalNotify_SavePersistenceMenu: "Kalıcı menü başarıyla eklendi",
    InternalNotify_SelectLanguage: "Dil başarıyla değiştirildi",
    InternalNotify_SaveFollowTemplate: "Follow şablonu başarıyla kaydedildi",
    InternalNotify_AutoReplyOn: "Otomatik yanıt başarıyla etkinleştirildi",
    InternalNotify_AutoReplyOff: "Otomatik yanıt başarıyla devre dışı bırakıldı",
    InternalNotify_AutoGeneralOn: "Genel otomatik yanıt başarıyla etkinleştirildi",
    InternalNotify_AutoGeneralOff: "Genel otomatik yanıt başarıyla devre dışı bırakıldı",
    InternalNotify_MaxInEachCard: "Her kartta maksimum",
    InternalNotify_ExceedStockCard: "Talep edilen miktar kart stoğunu aşıyor",
    InternalNotify_DefaultAddress: "Varsayılan adresi silemezsiniz",
    InternalNotify_FetchingYourData: "Verileriniz alınıyor, lütfen bekleyin...",
    InternalNotify_EmptyTitleInQuickReply: "Hızlı yanıt başlığı boş",
    InternalNotify_EmptyTitleForOutputsInQuickReply: "Hızlı yanıttaki çıktı başlıkları boş",
    InternalNotify_EmptyTitleForFlow: "Akış başlığı boş",
    InternalNotify_MultipleFlowForPrivateReply: "Özel yanıt için birden fazla akış olamaz",
    InternalNotify_NotPermittedForDownload: "Bu içeriği indirme izniniz yok",
    InternalNotify_NotFeature: "Bu özellik mevcut değil",
    InternalNotify_ExceedBasefeatureTime: "Temel özellik süresi aşıldı",
    InternalNotify_ChannelIdNotStartedWithUC: "Channel ID 'UC' ile başlamalı",
    InternalNotify_PageAnalysisNotCompleted: "Ne yazık ki sayfanız henüz yapay zeka tarafından analiz edilmedi",
    JustCreated: "Destek talebi kaydedildi",
    AdminReplied: "Destek yanıt vermiş",
    UserReplied: "Kullanıcı yanıt vermiş",
    AdminClosed: "Talep destek ekibi tarafından kapatılmış",
    UserClosed: "Talep kullanıcı tarafından kapatılmış",
    TimerClosed: "Talep otomatik olarak kapatılmış",
    closethisticket: "Bu bileti kapat",

    Create: "Oluştur",
    image: "görsel",
    video: "video",
    Images: "Görseller",
    Videos: "Videolar",
    "Generated artwork and visuals": "Üretilen sanat ve görseller",
    "AI motion and clips": "Yapay zeka hareketleri ve klipleri",
    "Media type": "Medya türü",

    "Generated AI video preview": "Yapay zeka ile üretilen video önizlemesi",

    Close: "Kapat",
    Prompt: "Komut",
    Metadata: "Meta veriler",
    Creator: "Oluşturan",
    Version: "Sürüm",
    Status: "Durum",
    "Image ID": "Görsel kimliği",
    "Video ID": "Video kimliği",
    "Job ID": "İş kimliği",
    "Download image": "Görseli indir",
    "Download video": "Videoyu indir",
    "Your browser does not support video playback.": "Tarayıcınız video oynatmayı desteklemiyor.",

    Uploading: "Yükleniyor",
    "Add video": "Video ekle",
    "Add audio": "Ses ekle",
    "Add reference image": "Referans görseli ekle",
    model: "model",
    models: "model",
    "resize aspect ratio": "en-boy oranını yeniden boyutlandır",
    "Video models": "Video modelleri",
    "Image models": "Görsel modelleri",
    "Cost level {level}": "Maliyet seviyesi {level}",
    "Calculating...": "Hesaplanıyor...",
    "Search from People or Keyword": "Kişi veya anahtar kelime ara",
    "Create new Flow": "Yeni akış oluştur",
    "Welcome illustration": "Karşılama görseli",
    "Untitled generation": "Adsız üretim",
    "No images yet": "Henüz görsel yok",
    "No videos yet": "Henüz video yok",
    "Your successful image generations will appear here.": "Başarılı görsel üretimleriniz burada görünecek.",
    "Your successful video generations will appear here.": "Başarılı video üretimleriniz burada görünecek.",
    "Create your first image": "İlk görselinizi oluşturun",
    "Create your first video": "İlk videonuzu oluşturun",
    "Generating image": "Görsel oluşturuluyor",
    "Generating video": "Video oluşturuluyor",
    "In progress": "Devam ediyor",
    "Just now": "Az önce",
    "Waiting for the result": "Sonuç bekleniyor",

    "Try again": "Tekrar dene",

    "AI provider": "Yapay zeka sağlayıcısı",

    "Choose a model": "Model seçin",

    "Describe the subject, setting, light, composition, and style...":
      "Konuyu, ortamı, ışığı, kompozisyonu ve stili açıklayın...",
    "Use at least {count} characters.": "En az {count} karakter kullanın.",
    "Video creator is unavailable": "Video oluşturucu kullanılamıyor",
    "Image creator is unavailable": "Görsel oluşturucu kullanılamıyor",
    "No video models found": "Video modeli bulunamadı",
    "No image models found": "Görsel modeli bulunamadı",
    "There are no video generation models available for this account.":
      "Bu hesap için kullanılabilir video oluşturma modeli yok.",
    "There are no image generation models available for this account.":
      "Bu hesap için kullanılabilir görsel oluşturma modeli yok.",
    "Not available": "Mevcut değil",
    // #endregion Notification Section
    how: "Nasıl",
    SharedRemainingTimeBefore: "Tekrar paylaşım yapmadan önce 24 saat beklemelisiniz.",
    ConnectProduct: "Doğrudan Ürüne Bağlantı",
    messagesetting_ConnectProductResponseExplain: "Ürününüzü Story veya Live'a bağlayın.",
    biolinkProperties_Connect: "Bağla",
    economy: "Ekonomik",
    Retry: "Tekrar Dene",
    messagesetting_SpecifyProductResponseExplain: "Kullanıcılara otomatik olarak gönderilmesi için bir ürün belirtin",
    messagesetting_ProductResponseExplain: "Mevcut ürünü kullanıcıya bağlayın",
    Storeproduct_NationalCardexplain: "Bu kart, cep telefonu numarasını Brancy'ye kaydeden kişiye ait olmalıdır.",

    // #region wallet
    createdtime: "Oluşturulma Zamanı",
    BankCards: "Banka Kartları",
    Transactions: "İşlemler",
    Settlements: "Mutabakatlar",
    AddNewBankCard: "Yeni Banka Kartı Ekle",
    RegisterANewCard: "Yeni Kart Kaydet",
    CardBankNumber: "Banka Kartı Numarası",
    CardNumberExplain: "Kart numaranızı girin. Banka kartı, kayıt olan kişinin adına olmalıdır.",
    RegisterBankCard: "Banka Kartını Kaydet",
    CardNumber: "Kart Numarası",
    DefaultBankCard: "Varsayılan Banka Kartı",
    SetAsDefaultBankCard: "Varsayılan Banka Kartı Olarak Ayarla",
    Type: "Tür",
    Suspended: "Askıya Alındı",
    Amount: "Tutar",
    Time: "Zaman",
    Order: "Sipariş",
    User: "Kullanıcı",
    NotAvailable: "Kullanılamıyor",
    Unsettled: "Ödenmemiş",
    AwaitingSettled: "Ödeme Bekleniyor",
    Settled: "Ödendi",
    SettlementFailed: "Ödeme Başarısız",
    SettleRequest: "Ödeme Talebi",
    emptyInvoice: "Henüz hiç fatura kaydedilmedi.",
    InvoiceID: "Fatura Kimliği",
    InvoiceType: "Fatura Türü",
    InvoiceHistory: "Fatura Geçmişi",
    OrderDetails: "Sipariş Detayları",
    InvoiceDetails: "Fatura Detayları",
    Paid: "Ödendi",
    Success: "Başarılı",
    RefundRequest: "İade Talebi",
    Refunding: "İade Ediliyor",
    Refunded: "İade Edildi",
    RefundFailed: "İade Başarısız",
    Failed: "Başarısız",
    Package: "Paket",
    Product: "Ürün",
    Feature: "Özellik",
    Custom: "Özel",
    Invoice: "Fatura",
    UnknownStatus: "Bilinmeyen Durum",
    NoSettlementsRegisteredYet: "Henüz hiçbir ödeme kaydı oluşturulmadı.",
    LogesticPayment: "Lojistik Ödemesi",
    ProductIncome: "Ürün Geliri",
    BrancyFeatureIncome: "Brancy Özellik Geliri",
    BrancyLogesticPayment: "Brancy Lojistik Ödemesi",
    BrancyPackageIncome: "Brancy Paket Geliri",
    BrancyProductIncome: "Brancy Ürün Geliri",
    BrancyTransferPayment: "Brancy Transfer Ücreti",
    WalletBalance: "Cüzdan Bakiyesi",
    TotalWithdrawn: "Toplam Çekilen",
    FailedTransactions: "Başarısız İşlemler",
    PendingSettlement: "Ödeme Bekliyor",
    OrderInProgress: "Sipariş İşleniyor",
    OrderPickup: "Siparişin Alınması",
    OrderDelivery: "Sipariş Teslimatı",
    SubInvoiceHistory: "Alt Fatura Geçmişi",
    history: "Geçmiş",
    // #endregion wallet
  },
};
